(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amana-404"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-404]');
    if (!raiz) return;

    /* entrada em cascata */
    var rv = Array.prototype.slice.call(raiz.querySelectorAll('[data-am-rv]'));
    rv.forEach(function (e, i) { e.style.setProperty('--d', (i * 90) + 'ms'); });
    requestAnimationFrame(function () { rv.forEach(function (e) { e.classList.add('am-vis'); }); });
    setTimeout(function () { rv.forEach(function (e) { e.classList.add('am-vis'); }); }, 60);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var campo = raiz.querySelector('[data-am-404-farelo]');
    var cx = raiz.querySelector('[data-am-404-cx]');
    if (!campo) return;

    var pecas = Array.prototype.slice.call(campo.children).map(function (el) {
      var t = el.offsetWidth || 10;
      return {
        el: el, t: t,
        x: Math.random(), y: Math.random(),
        vx: (Math.random() - .5) * .0006,
        vy: (Math.random() - .5) * .0006,
        g: Math.random() * 360, vg: (Math.random() - .5) * 1.4
      };
    });

    var larg = raiz.clientWidth, alt = raiz.clientHeight;
    var pmx = -1, pmy = -1;          /* ponteiro em fração, -1 = fora */
    var vivo = true, ocioso = 0;

    raiz.addEventListener('pointermove', function (e) {
      var r = raiz.getBoundingClientRect();
      pmx = (e.clientX - r.left) / r.width;
      pmy = (e.clientY - r.top) / r.height;
      ocioso = 0;
      if (cx) {
        /* a composição inclina de leve seguindo o ponteiro */
        cx.style.transform = 'perspective(900px) rotateY(' + ((pmx - .5) * 5).toFixed(2) +
          'deg) rotateX(' + ((.5 - pmy) * 4).toFixed(2) + 'deg)';
      }
    });
    raiz.addEventListener('pointerleave', function () {
      pmx = pmy = -1;
      if (cx) cx.style.transform = '';
    });

    window.addEventListener('resize', function () {
      larg = raiz.clientWidth; alt = raiz.clientHeight;
    });

    /* para quando a aba some de vista: não vale queimar bateria numa 404 */
    document.addEventListener('visibilitychange', function () {
      vivo = !document.hidden;
      if (vivo) requestAnimationFrame(passo);
    });

    function passo() {
      if (!vivo) return;
      ocioso++;

      for (var i = 0; i < pecas.length; i++) {
        var p = pecas[i];

        /* o ponteiro empurra o farelo que está perto */
        if (pmx >= 0) {
          var dx = p.x - pmx, dy = (p.y - pmy) * (alt / larg);
          var d2 = dx * dx + dy * dy;
          if (d2 < 0.02 && d2 > 0.000001) {
            var f = (0.02 - d2) * 0.03 / Math.sqrt(d2);
            p.vx += dx * f; p.vy += dy * f;
            p.vg += (dx > 0 ? 1 : -1) * 1.2;
          }
        }

        p.vy += 0.0000075;                 /* uma gravidade bem leve */
        p.vx *= 0.988; p.vy *= 0.988; p.vg *= 0.97;
        p.x += p.vx; p.y += p.vy; p.g += p.vg;

        /* volta pelo outro lado em vez de sumir */
        if (p.x < -0.05) p.x = 1.05; else if (p.x > 1.05) p.x = -0.05;
        if (p.y > 1.05) { p.y = -0.05; p.vy = 0; }
        else if (p.y < -0.05) p.y = 1.05;

        p.el.style.transform = 'translate3d(' + (p.x * larg).toFixed(1) + 'px,' +
          (p.y * alt).toFixed(1) + 'px,0) rotate(' + p.g.toFixed(1) + 'deg)';
      }

      /* sem ponteiro e sem movimento sobrando, o laço descansa */
      if (ocioso > 600 && pmx < 0) { vivo = false; return; }
      requestAnimationFrame(passo);
    }
    requestAnimationFrame(passo);

    /* mexer de novo acorda o laço */
    raiz.addEventListener('pointerenter', function () {
      if (!vivo) { vivo = true; ocioso = 0; requestAnimationFrame(passo); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-antes-hoje"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-ah]');
    if (!raiz) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var a = raiz.querySelector('[data-am-ah-lado="a"] .am-ah__foto');
    var b = raiz.querySelector('[data-am-ah-lado="b"] .am-ah__foto');
    var nA = raiz.querySelector('[data-am-ah-nota="a"]');
    var nB = raiz.querySelector('[data-am-ah-nota="b"]');
    if (!a || !b) return;

    function entre(v, a0, b0) {
      if (b0 === a0) return 0;
      return Math.max(0, Math.min(1, (v - a0) / (b0 - a0)));
    }
    /* suaviza as pontas: sem isso o zoom "liga" e "desliga" com um tranco */
    function suave(t) { return t * t * (3 - 2 * t); }

    var quadro = null, ultimoP = -1;
    window.addEventListener('resize', function () { ultimoP = -1; });
    function pinta() {
      quadro = null;
      var r = raiz.getBoundingClientRect();
      var altura = window.innerHeight || 800;
      var curso = r.height - altura;
      if (curso <= 0) return;
      var p = Math.max(0, Math.min(1, -r.top / curso));
      /* fora da tela o progresso fica preso em 0 ou 1: nada a reescrever */
      if (p === ultimoP) return;
      ultimoP = p;

      /* A esquerda cresce primeiro e devolve; a direita cresce depois e fica.
         É a leitura da frase: primeiro o "antes", depois o "hoje". */
      var za = 1 + suave(entre(p, 0.04, 0.34)) * 0.42 - suave(entre(p, 0.5, 0.82)) * 0.36;
      var zb = 1 + suave(entre(p, 0.46, 0.94)) * 0.55;
      a.style.setProperty('--z', za.toFixed(3));
      b.style.setProperty('--z', zb.toFixed(3));
      /* o ponto do zoom caminha de leve: dá a sensação de câmera, não de escala */
      a.style.setProperty('--zy', (52 - suave(entre(p, 0, 0.5)) * 14).toFixed(1) + '%');
      b.style.setProperty('--zx', (50 - suave(entre(p, 0.4, 1)) * 16).toFixed(1) + '%');

      if (nA) nA.classList.toggle('am-on', p > 0.16 && p < 0.62);
      if (nB) nB.classList.toggle('am-on', p > 0.56);
    }
    function agenda() { if (!quadro) quadro = requestAnimationFrame(pinta); }

    /* o Horizon rola dentro de .page-wrapper em telas >=990px; window.scroll
       não dispara lá. Escuta os dois e deixa o rAF resolver a repetição. */
    var pw = document.querySelector('.page-wrapper');
    if (pw) pw.addEventListener('scroll', agenda, { passive: true });
    window.addEventListener('scroll', agenda, { passive: true });
    window.addEventListener('resize', agenda);
    pinta();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-aprender"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-apr]');
    if (!raiz) return;

    /* revelação por IntersectionObserver: no Horizon a rolagem acontece dentro
       de .page-wrapper e ouvir `scroll` no window não funciona em ≥990px */
    var alvos = raiz.querySelectorAll('[data-am-rv]');
    if ('IntersectionObserver' in window) {
      var ob = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('am-vis');
          ob.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: .05 });
      alvos.forEach(function (e) { ob.observe(e); });
    } else {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
    }

    /* os chips levam até a faixa e ficam marcados */
    var chips = raiz.querySelectorAll('[data-am-apr-ir]');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var alvo = document.getElementById('am-apr-' + c.getAttribute('data-am-apr-ir'));
        chips.forEach(function (o) { o.classList.toggle('am-on', o === c); });
        if (alvo) alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-artigo"]) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-mat]');
    if (!raiz) return;

    var texto = raiz.querySelector('[data-am-mat-texto]');
    var regua = raiz.querySelector('[data-am-mat-regua]');
    var indice = raiz.querySelector('[data-am-mat-indice]');
    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function rola(el) { if (el) el.scrollIntoView({ behavior: reduz ? 'auto' : 'smooth', block: 'start' }); }

    /* ---------------- índice a partir dos H2 do conteúdo ---------------- */
    if (texto && indice) {
      var lista = indice.querySelector('ol');
      var h2s = texto.querySelectorAll('h2');
      if (h2s.length >= 3) {
        h2s.forEach(function (h, i) {
          if (!h.id) h.id = 'am-t-' + (i + 1);
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          /* título que já vem numerado ("1. Um crocante") não ganha o número duas vezes */
          a.textContent = h.textContent.trim().replace(/^\d+[.)]\s*/, '');
          a.addEventListener('click', function (e) { e.preventDefault(); rola(h); });
          li.appendChild(a);
          lista.appendChild(li);
        });
        indice.hidden = false;
      }
    }

    /* "Começar a ler" desce até a folha */
    var ir = raiz.querySelector('[data-am-mat-ir]');
    if (ir) ir.addEventListener('click', function (e) {
      e.preventDefault();
      rola(raiz.querySelector('#am-mat-texto'));
    });

    /* ---------------- entrada por rolagem ---------------- */
    if ('IntersectionObserver' in window && !reduz) {
      raiz.classList.add('am-mat-js');
      var ob = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting && en.boundingClientRect.bottom > 0) return;
          en.target.classList.add('am-mat-vis');
          ob.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -5% 0px', threshold: .06 });
      raiz.querySelectorAll('[data-am-mat-rv]').forEach(function (e) { ob.observe(e); });
    }

    /* ---------------- régua de leitura ----------------
       Só getBoundingClientRect: serve com a rolagem no .page-wrapper ou no documento. */
    if (regua && texto) {
      var barra = regua.querySelector('i');
      var pendente = false;
      function mede() {
        pendente = false;
        var r = texto.getBoundingClientRect();
        var total = r.height - window.innerHeight * .6;
        if (total <= 0) { barra.style.setProperty('--am-lido', r.bottom < 0 ? '100%' : '0%'); return; }
        var lido = Math.max(0, Math.min(1, (-r.top + window.innerHeight * .4) / total));
        barra.style.setProperty('--am-lido', (lido * 100).toFixed(1) + '%');
      }
      function agenda() {
        if (pendente) return;
        pendente = true;
        requestAnimationFrame(mede);
      }
      document.addEventListener('scroll', agenda, { passive: true, capture: true });
      window.addEventListener('resize', agenda);
      mede();
    }

    /* ---------------- compartilhar / copiar ---------------- */
    function confirma(b, rotEl, textoOk) {
      var alvo = rotEl || b;
      var antes = alvo.textContent;
      b.classList.add('am-mat-feito');
      alvo.textContent = textoOk;
      setTimeout(function () { b.classList.remove('am-mat-feito'); alvo.textContent = antes; }, 1800);
    }
    function copia(url, b, rotEl) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { confirma(b, rotEl, 'Link copiado'); }, function () { });
      }
    }
    var share = raiz.querySelector('[data-am-mat-share]');
    if (share) {
      share.addEventListener('click', function () {
        var dados = { title: document.title, url: location.href };
        if (navigator.share) { navigator.share(dados).catch(function () { }); return; }
        copia(location.href, share);
      });
    }
    var cop = raiz.querySelector('[data-am-mat-copiar]');
    if (cop) cop.addEventListener('click', function () {
      copia(cop.getAttribute('data-am-mat-url') || location.href, cop, cop.querySelector('[data-am-mat-copiar-rot]'));
    });

    /* ---------------- pôr na sacola ----------------
       Mesmo caminho da página de receita: /cart/add.js e os dois eventos que
       o resto do tema ouve (contador do cabeçalho e a gaveta). */
    function raizLoja() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
    raiz.querySelectorAll('[data-am-mat-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        b.disabled = true;
        fetch(raizLoja() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-am-mat-add')), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('carrinho');
          document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('amana:cart:open', { bubbles: true }));
          var antes = b.textContent;
          b.classList.add('am-mat-feito');
          b.textContent = 'Na sacola';
          setTimeout(function () { b.classList.remove('am-mat-feito'); b.textContent = antes; b.disabled = false; }, 1900);
        }).catch(function () { b.disabled = false; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-barra-compra"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var barra = document.querySelector('[data-am-bcompra]');
    if (!barra) return;

    /* Sai do fluxo da seção e vai para o body: assim nenhum ancestral com
       transform quebra o position:fixed. */
    if (barra.parentNode !== document.body) document.body.appendChild(barra);
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.contains && barra.isConnected && !document.body.contains(e.target)) return;
    });

    var gatilho = document.querySelector('[data-am-comprar]');
    var celular = window.matchMedia('(max-width: 749px)');
    var mostrar = function (v) {
      if (v) {
        if (barra.classList.contains('am-vis')) return;
        barra.hidden = false;
        /* lê a caixa antes de pôr a classe: sem isso o navegador calcula o
           "aparecer" e o "am-vis" no mesmo quadro e a subida não anima */
        void barra.offsetWidth;
        barra.classList.add('am-vis');
      } else {
        barra.classList.remove('am-vis');
        setTimeout(function () { if (!barra.classList.contains('am-vis')) barra.hidden = true; }, 360);
      }
    };

    var botaoFora = false, rodapeVisto = false;
    function decide() { mostrar(botaoFora && !(rodapeVisto && celular.matches)); }

    if (gatilho && 'IntersectionObserver' in window) {
      /* A barra aparece quando o botão principal sai de vista — sem listener de
         scroll, que no Horizon não dispara no window em telas grandes. */
      new IntersectionObserver(function (ents) {
        /* Computador: só depois que o botão principal passou para CIMA da
           tela — se ele ainda está embaixo, a barra não pode nascer aberta.
           Celular (como na Bragg): fora da tela para qualquer lado; o botão
           fica abaixo da galeria, e a barra entra desde o topo. */
        ents.forEach(function (en) {
          botaoFora = !en.isIntersecting && (celular.matches || en.boundingClientRect.top < 0);
        });
        decide();
      }, { threshold: 0 }).observe(gatilho);
      /* Celular: a barra sai quando o rodapé entra — senão ela tampa o fim da
         página (na Bragg ela é presa à área do produto e para antes dele). */
      var rodape = document.querySelector('body > footer, footer');
      if (rodape) {
        new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { rodapeVisto = en.isIntersecting; });
          decide();
        }, { threshold: 0 }).observe(rodape);
      }
    } else {
      mostrar(true);
    }

    /* Adiciona sem sair da pagina e abre a gaveta do carrinho (evento que a
       amana-carrinho escuta). Sem JS, o formulario continua indo para /cart. */
    var forma = barra.querySelector('.am-bcompra__forma');
    if (forma && window.fetch) {
      forma.addEventListener('submit', function (e) {
        e.preventDefault();
        var bt = forma.querySelector('.am-bcompra__add');
        if (bt) bt.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(forma.querySelector('[name=id]').value), quantity: bqQtd() }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          document.dispatchEvent(new CustomEvent('amana:cart:open'));
        }).catch(function () { forma.submit(); })
          .finally(function () { if (bt) bt.disabled = false; });
      });
    }

    /* Mantém a variante em sincronia com a coluna principal. */
    var sel = barra.querySelector('[data-am-bcompra-var]');
    var campo = barra.querySelector('[data-am-bcompra-id]');
    var preco = barra.querySelector('[data-am-bcompra-preco]');
    var un = preco ? Number(preco.getAttribute('data-am-bq-un')) : 0;
    function pintaTotal() {
      if (!preco || !un) return;
      var c = un * bqQtd();
      try { preco.textContent = (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
      catch (e) { preco.textContent = 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
    }
    /* Quantidade da barra (só visível no celular). Ela e o campo da coluna
       principal andam juntos: mexer num repinta o outro, e o total dos dois
       botões e do Pix acompanha. */
    var bq = barra.querySelector('[data-am-bq-campo]');
    var principal = document.querySelector('[data-am-qtd-campo]');
    function bqQtd() {
      var n = bq ? parseInt(bq.value, 10) : 1;
      if (!n || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }
    function bqPoe(n, avisa) {
      if (!bq) return;
      bq.value = Math.min(99, Math.max(1, n));
      pintaTotal();
      if (avisa && principal && principal.value !== bq.value) {
        principal.value = bq.value;
        principal.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    barra.querySelectorAll('[data-am-bq-passo]').forEach(function (b) {
      b.addEventListener('click', function () {
        bqPoe(bqQtd() + Number(b.getAttribute('data-am-bq-passo')), true);
      });
    });
    if (bq) bq.addEventListener('change', function () { bqPoe(bqQtd(), true); });
    if (principal) {
      /* só no celular: no computador a barra não mostra a quantidade e
         continua pondo 1, como antes */
      var espelha = function () { if (celular.matches) bqPoe(parseInt(principal.value, 10) || 1, false); };
      principal.addEventListener('change', espelha);
      principal.addEventListener('input', espelha);
    }
    if (sel) {
      sel.addEventListener('change', function () {
        if (campo) campo.value = sel.value;
        var op = sel.options[sel.selectedIndex];
        if (op && op.getAttribute('data-am-bq-un')) un = Number(op.getAttribute('data-am-bq-un'));
        if (preco && op) preco.textContent = op.getAttribute('data-preco');
        pintaTotal();
        var principal = document.querySelector('[data-am-var="' + sel.value + '"]');
        if (principal) principal.click();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-busca"]) return;
  try {
    
  (function () {
    var cx = document.querySelector('[data-am-busca]');
    if (!cx) return;

    var MOEDA = cx.getAttribute('data-am-moeda') || 'BRL';
    var campoPainel = cx.querySelector('[data-am-bu-campo]');
    var campoHeader = document.getElementById('am-q');
    var inicio = cx.querySelector('[data-am-bu-inicio]');
    var res = cx.querySelector('[data-am-bu-res]');
    var secProd = cx.querySelector('[data-am-bu-sec-prod]');
    var secArt = cx.querySelector('[data-am-bu-sec-art]');
    var elProd = cx.querySelector('[data-am-bu-prod]');
    var elArt = cx.querySelector('[data-am-bu-art]');
    var nProd = cx.querySelector('[data-am-bu-n-prod]');
    var nArt = cx.querySelector('[data-am-bu-n-art]');
    var nada = cx.querySelector('[data-am-bu-nada]');
    var tudo = cx.querySelector('[data-am-bu-tudo]');
    var tira = cx.querySelector('[data-am-bu-tira]');

    function esc(t) {
      return String(t == null ? '' : t)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function moeda(reais) {
      var n = Number(reais);
      if (!isFinite(n)) return '';
      try { return n.toLocaleString('pt-BR', { style: 'currency', currency: MOEDA }); }
      catch (e) { return 'R$ ' + n.toFixed(2).replace('.', ','); }
    }
    function raiz() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    /* ---------------- abrir e fechar ---------------- */
    var travado = null, aberto = false;

    function alvoScroll() {
      var pw = document.querySelector('.page-wrapper');
      return (pw && pw.scrollHeight > pw.clientHeight + 4) ? pw : document.documentElement;
    }
    /* o painel encosta embaixo do header, que muda de altura com a barra de
       avisos, e alinha a direita pela borda do campo de busca do cabecalho */
    function medeTopo() {
      var topo = document.querySelector('.am-topo');
      var y = topo ? topo.getBoundingClientRect().bottom : 0;
      cx.style.setProperty('--am-bu-topo', Math.max(10, Math.round(y) + 8) + 'px');

      var forma = document.querySelector('.am-topo .am-busca');
      var caixa = (forma && forma.offsetHeight) ? forma : topo;
      if (caixa) {
        var r = caixa.getBoundingClientRect();
        var dir = Math.max(0, Math.round(window.innerWidth - r.right));
        cx.style.setProperty('--am-bu-dir', dir + 'px');
      }
    }

    function abrir() {
      if (aberto) return;
      aberto = true;
      medeTopo();
      cx.hidden = false;
      requestAnimationFrame(function () { cx.classList.add('am-vis'); });
      setTimeout(function () { if (aberto) cx.classList.add('am-vis'); }, 40);
      travado = alvoScroll();
      travado.style.overflow = 'hidden';
      document.addEventListener('keydown', naTecla);
      setTimeout(ajustaSetas, 60);
      /* o campo de dentro e o que recebe o que ja estava digitado e o foco:
         com o painel aberto, o campo do header fica atras do escurecido */
      if (campoPainel) {
        if (campoHeader && campoHeader.value && campoPainel.value !== campoHeader.value) {
          campoPainel.value = campoHeader.value;
        }
        setTimeout(function () {
          if (!aberto || campoPainel.offsetParent === null) return;
          campoPainel.focus();
          var n = campoPainel.value.length;
          try { campoPainel.setSelectionRange(n, n); } catch (e) { }
        }, 300);
      }
    }
    function fechar() {
      if (!aberto) return;
      aberto = false;
      cx.classList.remove('am-vis');
      setTimeout(function () { if (!aberto) cx.hidden = true; }, 360);
      if (travado) { travado.style.overflow = ''; travado = null; }
      document.removeEventListener('keydown', naTecla);
    }
    function naTecla(e) { if (e.key === 'Escape') fechar(); }

    cx.querySelectorAll('[data-am-busca-fecha]').forEach(function (b) {
      b.addEventListener('click', fechar);
    });
    window.addEventListener('resize', function () { if (aberto) { medeTopo(); ajustaSetas(); } });

    /* o campo do header abre o painel e continua sendo quem digita */
    if (campoHeader) {
      campoHeader.addEventListener('focus', abrir);
      campoHeader.addEventListener('click', abrir);
      campoHeader.addEventListener('input', function () { procura(campoHeader.value); });
    }
    if (campoPainel) {
      campoPainel.addEventListener('input', function () { procura(campoPainel.value); });
    }
    document.addEventListener('click', function (e) {
      var g = e.target.closest && e.target.closest('[data-am-abre-busca]');
      if (!g) return;
      e.preventDefault();
      abrir();
    });

    /* ---------------- busca ---------------- */
    var pendente = null, ultima = '', controle = null;

    function procura(termo) {
      termo = (termo || '').trim();
      if (campoPainel && campoPainel.value !== termo && document.activeElement !== campoPainel) campoPainel.value = termo;
      if (campoHeader && campoHeader.value !== termo && document.activeElement !== campoHeader) campoHeader.value = termo;
      clearTimeout(pendente);
      if (termo.length < 2) { mostraInicio(); return; }
      if (termo === ultima) return;
      pendente = setTimeout(function () { busca(termo); }, 230);
    }

    function mostraInicio() {
      ultima = '';
      inicio.hidden = false;
      res.hidden = true;
      setTimeout(ajustaSetas, 30);
    }

    function busca(termo) {
      ultima = termo;
      if (controle) controle.abort();
      controle = new AbortController();
      var url = raiz() + 'search/suggest.json?q=' + encodeURIComponent(termo) +
        '&resources[type]=product,article,page&resources[limit]=10' +
        '&resources[options][unavailable_products]=hide';
      fetch(url, { signal: controle.signal, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var r = (d.resources && d.resources.results) || {};
          /* esgotado não aparece (30/09): o `hide` acima já tira, e o filtro
             aqui segura se a Shopify um dia ignorar o parâmetro */
          var prods = (r.products || []).filter(function (p) { return p.available !== false; });
          pinta(termo, prods, (r.articles || []).concat(r.pages || []));
        })
        .catch(function () { });
    }

    function cartaoProduto(p) {
      /* sem lazy: são no máximo dez cartões e todos entram na tela de uma vez */
      var img = p.image ? '<img src="' + esc(p.image) + '" alt="">' : '';
      var preco = moeda(p.price);
      var de = (p.compare_at_price_min && Number(p.compare_at_price_min) > Number(p.price))
        ? '<s>' + moeda(p.compare_at_price_min) + '</s>' : '';
      /* A busca preditiva só preenche `variants` quando a consulta casa com uma
         variante — em geral vem vazio. Então o botão guarda a URL do produto e
         a variante é resolvida no clique, com um /produto.js. */
      var botao = p.available
        ? '<button class="am-pc__add" type="button" data-am-bu-add-url="' + esc(String(p.url).split('?')[0]) + '">' + esc(ROT_ADD) + '</button>'
        : '<button class="am-pc__add" type="button" disabled>' + esc(ROT_ESG) + '</button>';
      return '' +
        '<article class="am-pc">' +
          '<a class="am-pc__foto" href="' + esc(p.url) + '" tabindex="-1">' + img + '</a>' +
          '<a class="am-pc__nome" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="am-pc__pe">' + botao +
            '<span class="am-pc__preco">' + de + preco + '</span>' +
          '</div>' +
        '</article>';
    }

    function cartaoArtigo(a) {
      var img = a.image
        ? '<img src="' + esc(a.image) + '" alt="">'
        : '<span class="am-ar__vazio"></span>';
      return '<a class="am-ar" href="' + esc(a.url) + '">' + img + '<b>' + esc(a.title) + '</b></a>';
    }

    var ROT_ADD = cx.getAttribute('data-rot-add') || 'Adicionar';
    var ROT_ESG = cx.getAttribute('data-rot-esgotado') || 'Esgotado';

    function pinta(termo, produtos, artigos) {
      inicio.hidden = true;
      res.hidden = false;

      secProd.hidden = produtos.length === 0;
      nProd.textContent = produtos.length ? '(' + produtos.length + ')' : '';
      elProd.innerHTML = produtos.map(cartaoProduto).join('');

      secArt.hidden = artigos.length === 0;
      nArt.textContent = artigos.length ? '(' + artigos.length + ')' : '';
      elArt.innerHTML = artigos.map(cartaoArtigo).join('');

      nada.hidden = produtos.length + artigos.length > 0;
      tudo.hidden = produtos.length + artigos.length === 0;
      tudo.setAttribute('href', raiz() + 'search?q=' + encodeURIComponent(termo) + '&options%5Bunavailable_products%5D=hide');
    }

    /* ---------------- adicionar direto do resultado ---------------- */
    /* Nos destaques o id da variante já vem do Liquid; nos resultados vem a URL
       e é preciso um pulo a mais para descobrir qual variante está disponível. */
    function idDaVariante(botao) {
      var direto = botao.getAttribute('data-am-bu-add');
      if (direto) return Promise.resolve(Number(direto));
      var url = botao.getAttribute('data-am-bu-add-url');
      if (!url) return Promise.reject();
      return fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var vs = p.variants || [];
          for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i].id;
          return Promise.reject();
        });
    }

    cx.addEventListener('click', function (e) {
      var b = e.target.closest('[data-am-bu-add],[data-am-bu-add-url]');
      if (!b || b.disabled) return;
      b.disabled = true;
      var antes = b.textContent;
      idDaVariante(b)
        .then(function (id) {
          return fetch(raiz() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          });
        })
        .then(function () {
          b.classList.add('am-feito');
          b.textContent = 'Adicionado';
          document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', { bubbles: true }));
          setTimeout(function () {
            b.classList.remove('am-feito');
            b.textContent = antes;
            b.disabled = false;
          }, 1500);
        })
        .catch(function () { b.disabled = false; });
    });

    /* ---------------- chips de tema ---------------- */
    cx.querySelectorAll('[data-am-tema]').forEach(function (c) {
      c.addEventListener('click', function () {
        var t = c.getAttribute('data-am-tema');
        if (campoHeader) campoHeader.value = t;
        if (campoPainel) campoPainel.value = t;
        ultima = '';
        busca(t);
      });
    });

    /* ---------------- carrossel dos quentes ---------------- */
    function ajustaSetas() {
      if (!tira) return;
      cx.querySelectorAll('[data-am-bu-ir]').forEach(function (s) {
        s.hidden = inicio.hidden || tira.scrollWidth <= tira.clientWidth + 4;
      });
    }
    cx.querySelectorAll('[data-am-bu-ir]').forEach(function (s) {
      s.addEventListener('click', function () {
        tira.scrollLeft += Number(s.getAttribute('data-am-bu-ir')) * (tira.clientWidth * .8);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-capa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-am-capa]').forEach(function (capa) {
      var media = capa.querySelector('[data-am-capa-media]');
      var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* entrada */
      if ('IntersectionObserver' in window) {
        var ob = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (!en.isIntersecting) return;
            en.target.classList.add('am-vis');
            ob.unobserve(en.target);
          });
        }, { threshold: .15 });
        ob.observe(capa);
      } else {
        capa.classList.add('am-vis');
      }

      if (!media || reduz) return;

      /* parallax: a imagem tem 8% de folga em cima e embaixo, então pode andar
         até ~8% da própria altura sem descobrir o fundo */
      var pendente = false;
      function desenha() {
        pendente = false;
        var r = capa.getBoundingClientRect();
        if (r.bottom < -100 || r.top > window.innerHeight + 100) return;
        var meio = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        media.style.transform = 'translate3d(0,' + (meio * -7).toFixed(2) + '%,0)';
      }
      function agenda() {
        if (pendente) return;
        pendente = true;
        requestAnimationFrame(desenha);
      }
      var pw = document.querySelector('.page-wrapper');
      var rolador = (pw && pw.scrollHeight > pw.clientHeight + 4) ? pw : window;
      document.addEventListener('scroll', agenda, { passive: true, capture: true });
      window.addEventListener('resize', agenda);
      desenha();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-carrinho-pagina"]) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-cp2]');
    if (!raiz) return;

    var alvos = raiz.querySelectorAll('[data-am-rv]');
    if ('IntersectionObserver' in window) {
      var ob = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('am-vis');
          ob.unobserve(en.target);
        });
      }, { threshold: .05 });
      alvos.forEach(function (e) { ob.observe(e); });
    } else {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
    }

    /* Voltar do checkout pelo "voltar" do navegador traz esta página do cache
       de ida e volta, montada com o carrinho de antes: recarrega. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) location.reload(); });

    function raizUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    /* Repinta a própria seção pela Section Rendering API em vez de recarregar:
       mantém a posição da página e o campo de bilhete como estavam. */
    function repinta() {
      var id = raiz.getAttribute('data-am-secao');
      fetch(location.pathname + '?section_id=' + encodeURIComponent(id))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nova = doc.querySelector('[data-am-cp2]');
          if (!nova) { location.reload(); return; }
          /* a escada de degraus velha fica no lugar da nova e só repinta:
             assim a barra anda e o degrau alcançado pula, em vez de trocar seco */
          var dgVelho = raiz.querySelector('[data-am-dg]');
          var dgNovo = nova.querySelector('[data-am-dg]');
          if (dgVelho && dgNovo && window.AmanaDegraus) {
            var sub = dgNovo.getAttribute('data-am-dg-sub');
            var tot = dgNovo.getAttribute('data-am-dg-total');
            dgNovo.replaceWith(dgVelho);
            raiz.replaceWith(nova);
            window.AmanaDegraus.pinta(dgVelho, sub, tot);
          } else {
            raiz.replaceWith(nova);
          }
          /* a seção nova nasce com [data-am-rv] invisível: já mostra */
          nova.querySelectorAll('[data-am-rv]').forEach(function (e) { e.classList.add('am-vis'); });
          document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', { bubbles: true }));
        })
        .catch(function () { location.reload(); });
    }

    raiz.addEventListener('click', function (e) {
      var b = e.target.closest('[data-am-menos],[data-am-mais]');
      if (!b) return;
      var linha = b.closest('[data-am-linha]');
      if (!linha) return;
      e.preventDefault();
      var atual = Number(linha.querySelector('.am-ci__qtd span').textContent) || 1;
      var nova = b.hasAttribute('data-am-mais') ? atual + 1 : atual - 1;
      linha.classList.add('am-ocupado');
      fetch(raizUrl() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: linha.getAttribute('data-am-linha'), quantity: Math.max(0, nova) })
      })
        .then(repinta)
        .catch(function () { linha.classList.remove('am-ocupado'); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-carrinho"]) return;
  try {
    
  (function () {
    var cx = document.querySelector('[data-am-cart]');
    if (!cx) return;

    var MOEDA = cx.getAttribute('data-am-moeda') || 'BRL';
    var listaEl = cx.querySelector('[data-am-cart-itens]');
    var pratEl = cx.querySelector('[data-am-prat]');
    var pratTit = cx.querySelector('[data-am-prat-tit]');
    var carrEl = cx.querySelector('[data-am-carr]');
    var subEl = cx.querySelector('[data-am-cart-sub]');
    var nEl = cx.querySelector('[data-am-cart-n]');
    var rotEl = cx.querySelector('[data-am-cart-rot]');
    var degraus = cx.querySelector('[data-am-dg]');
    var descEl = cx.querySelector('[data-am-cart-desc]');
    var descV = cx.querySelector('[data-am-cart-desc-v]');
    var descRot = cx.querySelector('[data-am-cart-desc-rot]');
    var okBtn = cx.querySelector('[data-am-cart-ok]');
    var maisBtn = cx.querySelector('[data-am-cart-mais]');
    var botoesEl = cx.querySelector('.am-cart__botoes');
    var sugs =Array.prototype.slice.call(cx.querySelectorAll('[data-am-sug]'));

    var ROT = {
      vazio: cx.getAttribute('data-rot-vazio') || 'Seu carrinho está vazio',
      cheio: cx.getAttribute('data-rot-cheio') || 'Seu carrinho',
      sugestao: cx.getAttribute('data-rot-sugestao') || 'Combina com',
      convite: cx.getAttribute('data-rot-convite') || 'Leve alguma coisa boa',
      desconto: cx.getAttribute('data-rot-desconto') || 'Desconto progressivo',
      mais: cx.getAttribute('data-rot-mais') || 'Comprar mais',
      ver_todos: cx.getAttribute('data-rot-ver-todos') || 'Ver todos os produtos'
    };

    function moeda(centavos) {
      try {
        return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: MOEDA });
      } catch (e) {
        return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
      }
    }
    function esc(t) {
      return String(t == null ? '' : t)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    /* ---------------- abrir e fechar ----------------
       O Horizon põe overflow:hidden no html/body em telas grandes e a rolagem
       acontece dentro de .page-wrapper — travar o body não faria nada. */
    var travado = null, focoAntes = null, aberto = false;

    function alvoScroll() {
      var pw = document.querySelector('.page-wrapper');
      return (pw && pw.scrollHeight > pw.clientHeight + 4) ? pw : document.documentElement;
    }

    /* O painel encosta embaixo do header, que muda de altura com a barra de
       avisos. Medir na hora de abrir é mais barato que observar o header. */
    function medeTopo() {
      var topo = document.querySelector('.am-topo');
      var y = topo ? topo.getBoundingClientRect().bottom : 0;
      cx.style.setProperty('--am-cart-topo', Math.max(14, Math.round(y) + 10) + 'px');
    }
    window.addEventListener('resize', function () { if (aberto) medeTopo(); });

    /* AO ABRIR, A GAVETA DESCE ATÉ O FRETE (20/10, pedido do Castriani),
       mantendo pelo menos o último produto à vista: o frete fica com a borda
       de baixo no pé da área de rolar; se não couber os dois, manda o
       produto. Repete nas primeiras pinturas depois de abrir (o carrinho
       chega da loja logo depois) e para se a pessoa rolar com o dedo. */
    var rolo = cx.querySelector('.am-cart__rolo');
    var abertoEm = 0, rolarAuto = false;
    function rolaAoFrete() {
      var fr = cx.querySelector('[data-am-frete]');
      if (!rolarAuto || !rolo || !fr || fr.hidden) return;
      var itens = listaEl.querySelectorAll('[data-am-linha]');
      if (!itens.length) return;
      var ult = itens[itens.length - 1];
      var alvo = fr.offsetTop + fr.offsetHeight + 14 - rolo.clientHeight;
      alvo = Math.min(alvo, ult.offsetTop - 6);
      if (alvo <= 4) return;
      rolo.scrollTo({ top: alvo, behavior: (Date.now() - abertoEm < 120) ? 'auto' : 'smooth' });
    }
    if (rolo) {
      ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
        rolo.addEventListener(ev, function () { rolarAuto = false; }, { passive: true });
      });
    }
    document.addEventListener('amana:cart:pintado', function () {
      if (aberto && rolarAuto && Date.now() - abertoEm < 5000) setTimeout(rolaAoFrete, 60);
    });

    function abrir() {
      if (aberto) return;
      aberto = true;
      abertoEm = Date.now();
      rolarAuto = true;
      if (rolo) rolo.scrollTop = 0;
      focoAntes = document.activeElement;
      cx.hidden = false;
      medeTopo();
      /* rAF não dispara em aba de fundo; o timeout garante a entrada */
      requestAnimationFrame(function () { cx.classList.add('am-vis'); });
      setTimeout(function () { if (aberto) cx.classList.add('am-vis'); }, 40);
      travado = alvoScroll();
      travado.style.overflow = 'hidden';
      document.addEventListener('keydown', naTecla);
      carrega().then(function () { setTimeout(rolaAoFrete, 80); });
      setTimeout(function () {
        var b = cx.querySelector('[data-am-cart-fecha]');
        if (b) b.focus();
      }, 340);
    }
    function fechar() {
      if (!aberto) return;
      aberto = false;
      cx.classList.remove('am-vis');
      setTimeout(function () { if (!aberto) cx.hidden = true; }, 380);
      if (travado) { travado.style.overflow = ''; travado = null; }
      document.removeEventListener('keydown', naTecla);
      if (focoAntes && focoAntes.focus) focoAntes.focus();
    }
    function naTecla(e) {
      if (e.key === 'Escape') { fechar(); return; }
      if (e.key !== 'Tab' || cx.hidden) return;
      /* prende o tab dentro do painel enquanto ele está aberto */
      var foco = cx.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
      var vis = Array.prototype.filter.call(foco, function (el) { return el.offsetParent !== null; });
      if (!vis.length) return;
      var pri = vis[0], ult = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === pri) { e.preventDefault(); ult.focus(); }
      else if (!e.shiftKey && document.activeElement === ult) { e.preventDefault(); pri.focus(); }
    }

    cx.querySelectorAll('[data-am-cart-fecha]').forEach(function (b) {
      b.addEventListener('click', fechar);
    });

    /* o ícone do header vira gatilho; sem JS ele continua sendo link para /cart */
    document.addEventListener('click', function (e) {
      var gat = e.target.closest && e.target.closest('.am-carrinho, [data-am-abre-cart]');
      if (!gat) return;
      e.preventDefault();
      abrir();
    });

    /* quem adiciona de outra seção pede a gaveta por evento, sem simular
       clique no ícone do header — clique falso quebra quando o ícone muda */
    document.addEventListener('amana:cart:open', function () { carrega(true); abrir(); });

    /* ---------------- pintar ---------------- */
    function itemHTML(it) {
      var img = it.image
        ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" loading="lazy">'
        : '';
      var variante = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<p class="am-ci__var">' + esc(it.variant_title) + '</p>' : '';
      var nome = esc(it.product_title);
      return '' +
        '<article class="am-ci" data-am-linha="' + esc(it.key) + '" data-am-un="' + (it.final_price || 0) +
          '" data-am-orig="' + (it.original_price || 0) + '">' +
          '<a class="am-ci__foto" href="' + esc(it.url) + '" tabindex="-1">' + img + '</a>' +
          '<div class="am-ci__meio">' +
            '<a class="am-ci__nome" href="' + esc(it.url) + '">' + nome + '</a>' +
            variante +
            '<div class="am-ci__ctrl">' +
              '<div class="am-ci__qtd">' +
                '<button type="button" data-am-menos aria-label="Diminuir"' + (it.quantity <= 1 ? ' disabled' : '') + '>' +
                  '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12h12"/></svg></button>' +
                '<input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="3" autocomplete="off" value="' + it.quantity +
                  '" data-am-qtd aria-label="Quantidade de ' + nome + '">' +
                '<button type="button" data-am-mais aria-label="Aumentar">' +
                  '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg></button>' +
              '</div>' +
              '<button type="button" class="am-ci__lixo" data-am-tira aria-label="Tirar ' + nome + ' do carrinho">' +
                '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.8 7h14.4M9.6 7V5.2h4.8V7M6.8 7l.9 12.3h8.6L17.2 7M10.3 10.6v5.6M13.7 10.6v5.6"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
          '<div class="am-ci__dir">' + precoLinha(it.quantity, it.final_price, it.original_price) + '</div>' +
        '</article>';
    }
    /* preço da linha: o total, o "de" riscado e, com mais de uma, quanto sai
       cada. Também usado para repintar na hora, antes da resposta da loja. */
    function precoLinha(q, un, orig) {
      var antes = orig > un ? '<span class="am-ci__antes">' + moeda(orig * q) + '</span>' : '';
      var cada = q > 1 ? '<span class="am-ci__un">' + moeda(un) + ' cada</span>' : '';
      return '<span class="am-ci__preco" data-am-ci-preco>' + moeda(un * q) + antes + cada + '</span>';
    }

    /* a sacola se redesenha a cada vez que o carrinho fica vazio na frente de
       quem esta olhando: animacao de CSS so roda uma vez por insercao, entao a
       classe sai, o navegador e obrigado a recalcular, e ela volta */
    var vazioEl = cx.querySelector('[data-am-vazio]');
    function mostraVazio(vazio) {
      if (!vazioEl) return;
      if (!vazio) { vazioEl.hidden = true; vazioEl.classList.remove('am-vaz--desenha'); return; }
      var jaEstava = !vazioEl.hidden;
      vazioEl.hidden = false;
      if (jaEstava && vazioEl.classList.contains('am-vaz--desenha')) return;
      vazioEl.classList.remove('am-vaz--desenha');
      void vazioEl.offsetWidth;
      vazioEl.classList.add('am-vaz--desenha');
    }

    var ultimo = null;
    function pinta(carrinho) {
      var itens = carrinho.items || [];
      ultimo = carrinho;
      /* quem estava digitando a quantidade continua no campo depois da repintura */
      var focado = document.activeElement && document.activeElement.matches &&
        document.activeElement.matches('[data-am-qtd]') && listaEl.contains(document.activeElement)
        ? document.activeElement.closest('[data-am-linha]').getAttribute('data-am-linha') : null;
      listaEl.innerHTML = itens.map(itemHTML).join('');
      if (focado) {
        var volta = listaEl.querySelector('[data-am-linha="' + focado.replace(/"/g, '\\"') + '"] [data-am-qtd]');
        if (volta) { volta.focus(); try { volta.setSelectionRange(volta.value.length, volta.value.length); } catch (e) { } }
      }
      subEl.classList.remove('am-calc');

      var qtd = carrinho.item_count || 0;
      nEl.hidden = qtd === 0;
      nEl.textContent = qtd;
      /* O número do ícone do cabeçalho nasce do Liquid e ninguém mexia nele
         depois: a cliente adicionava, fechava a gaveta e o ícone continuava
         "vazio" (20/10 — "quando sai do carrinho ele esvazia"). O carrinho
         nunca esvaziou; agora o ícone acompanha cada pintura. */
      document.querySelectorAll('.am-carrinho b').forEach(function (b) {
        b.hidden = qtd === 0;
        b.textContent = qtd;
      });
      if (maisBtn) maisBtn.textContent = qtd === 0 ? ROT.ver_todos : ROT.mais;
      if (botoesEl) botoesEl.classList.toggle('am-cart__botoes--vazio', qtd === 0);
      rotEl.textContent = qtd === 0 ? ROT.vazio : ROT.cheio;
      mostraVazio(qtd === 0);
      subEl.textContent = moeda(carrinho.total_price || 0);
      if (okBtn) okBtn.disabled = qtd === 0;
      /* quem mais mostra o carrinho (a faixa de vantagens da coleção) repinta junto */
      document.dispatchEvent(new CustomEvent('amana:cart:pintado', { detail: carrinho }));

      /* a prateleira é convite quando vazio e sugestão quando cheio */
      var noCarrinho = {};
      itens.forEach(function (i) { noCarrinho[i.product_id] = true; });
      var sobrando = 0;
      sugs.forEach(function (s) {
        var fora = !noCarrinho[Number(s.getAttribute('data-am-prod'))];
        s.hidden = !fora;
        if (fora) sobrando++;
      });
      pratEl.hidden = sobrando === 0;
      pratTit.textContent = qtd === 0 ? ROT.convite : ROT.sugestao;
      if (!pratEl.hidden) ajustaSetas();

      /* Degraus: os descontos olham o subtotal ANTES do desconto de pedido
         (items_subtotal_price); o frete grátis olha o total DEPOIS dele. */
      var subItens = carrinho.items_subtotal_price || 0;
      if (degraus && window.AmanaDegraus) {
        window.AmanaDegraus.pinta(degraus, subItens, carrinho.total_price || 0);
      }

      /* Desconto de pedido em vigor. Os degraus da Shopify são incrementos que
         se somam (ver DESCONTO-PROGRESSIVO.md): aqui vira UMA linha com o total. */
      if (descEl) {
        var dsc = 0;
        (carrinho.cart_level_discount_applications || []).forEach(function (a) {
          dsc += Number(a.total_allocated_amount) || 0;
        });
        descEl.hidden = dsc <= 0;
        if (dsc > 0) {
          var pctD = subItens > 0 ? Math.round(dsc / subItens * 100) : 0;
          descRot.textContent = ROT.desconto + (pctD > 0 ? ' · ' + pctD + '% OFF' : '');
          descV.textContent = '− ' + moeda(dsc);
        }
      }
    }

    /* `fresco`: a resposta precisa refletir o que acabou de mudar; se já
       havia uma busca no ar (iniciada ANTES da mudança), espera ela e busca
       de novo, em vez de aproveitar o carrinho velho */
    var buscando = null;
    function carrega(fresco) {
      if (buscando && fresco) return buscando.then(function () { return carrega(); });
      if (buscando) return buscando;
      buscando = fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        /* com toque ainda a caminho da loja, não desfaz o que a pessoa vê */
        .then(function (c) { if (!temPendencia()) pinta(c); return c; })
        .catch(function () { })
        .then(function (c) { buscando = null; return c; });
      return buscando;
    }

    function raiz() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    /* ---------------- mexer no carrinho (20/10: na hora) ----------------
       Antes cada toque no "+" esperava a loja responder (0,6 s) com a linha
       apagada e travada: quem queria 5 unidades esperava 3 s, e o toque dado
       durante a espera se perdia. Agora o número, o preço da linha e o
       subtotal mudam NA HORA; os toques se juntam e vão num pedido só
       (/cart/update.js) 350 ms depois do último. A resposta da loja só
       repinta se nada mudou enquanto ela estava a caminho. */
    var pend = {}, pendTimer = null, versao = 0, noAr = 0;
    function temPendencia() { return noAr > 0 || Object.keys(pend).length > 0; }

    function estima() {
      var tot = 0, n = 0;
      listaEl.querySelectorAll('[data-am-linha]:not(.am-ci--sai)').forEach(function (l) {
        var campo = l.querySelector('[data-am-qtd]');
        var q = campo ? (parseInt(campo.value, 10) || 0) : 0;
        tot += q * (Number(l.getAttribute('data-am-un')) || 0);
        n += q;
      });
      subEl.textContent = moeda(tot);
      subEl.classList.add('am-calc');
      nEl.hidden = n === 0;
      nEl.textContent = n;
      document.querySelectorAll('.am-carrinho b').forEach(function (b) { b.hidden = n === 0; b.textContent = n; });
    }

    function poeLocal(linha, q) {
      var campo = linha.querySelector('[data-am-qtd]');
      if (campo && document.activeElement !== campo) campo.value = q;
      var menos = linha.querySelector('[data-am-menos]');
      if (menos) menos.disabled = q <= 1;
      var dir = linha.querySelector('.am-ci__dir');
      if (dir) {
        dir.innerHTML = precoLinha(q, Number(linha.getAttribute('data-am-un')) || 0, Number(linha.getAttribute('data-am-orig')) || 0);
        dir.firstChild.classList.add('am-calc');
      }
    }

    function muda(chave, quantidade, linha) {
      quantidade = Math.max(0, Math.min(999, quantidade | 0));
      pend[chave] = quantidade;
      versao++;
      if (linha) {
        if (quantidade === 0) {
          linha.classList.add('am-ci--sai');
          setTimeout(function () { if (linha.parentNode && temPendencia()) linha.style.display = 'none'; }, 260);
        } else {
          poeLocal(linha, quantidade);
        }
      }
      estima();
      clearTimeout(pendTimer);
      pendTimer = setTimeout(envia, 350);
    }

    function envia() {
      var ups = pend;
      pend = {};
      if (!Object.keys(ups).length) return;
      var minha = versao;
      noAr++;
      fetch(raiz() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: ups })
      })
        .then(function (r) { if (!r.ok) throw new Error('loja'); return r.json(); })
        .then(function (c) {
          noAr--;
          if (minha === versao && !temPendencia()) { pinta(c); avisa(); }
        })
        .catch(function () {
          /* sem estoque para tudo ou rede caiu: volta para o que a loja tem */
          noAr--;
          if (!temPendencia()) carrega(true).then(function () { avisa(); });
        });
    }

    /* Adicionar: um pedido só. O /cart/add.js + /cart.js eram duas idas à
       loja (~1 s); `update.js` devolve o carrinho inteiro já com o item. Se a
       variante já está no carrinho, soma a partir do que a sacola mostra. */
    function adiciona(id, botao) {
      if (botao) botao.disabled = true;
      id = Number(id);
      var ja = 0, linhas = 0;
      ((ultimo && ultimo.items) || []).forEach(function (i) {
        if (i.variant_id === id) { ja += i.quantity; linhas++; }
      });
      var pedido;
      if (linhas <= 1 && !temPendencia()) {
        var u = {}; u[id] = ja + 1;
        pedido = fetch(raiz() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: u })
        }).then(function (r) { if (!r.ok) throw new Error('loja'); return r.json(); })
          .then(function (c) { pinta(c); return c; });
      } else {
        pedido = fetch(raiz() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function () { return carrega(true); });
      }
      return pedido
        .then(function () { avisa(); })
        .catch(function () { return carrega(true); })
        .then(function () { if (botao) botao.disabled = false; });
    }

    /* linha "chegando" no topo da lista enquanto o produto é adicionado */
    function chegando(nome, img) {
      var el = document.createElement('article');
      el.className = 'am-ci am-ci--chega';
      el.innerHTML = '<span class="am-ci__foto">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</span>' +
        '<div class="am-ci__meio"><span class="am-ci__nome">' + esc(nome || 'Adicionando…') + '</span>' +
        '<p class="am-ci__var">Adicionando à sacola…</p></div>';
      listaEl.insertBefore(el, listaEl.firstChild);
      mostraVazio(false);
      return el;
    }

    /* avisa o resto do tema (contador do header, etc.) pelo evento padrão */
    function avisa() {
      document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', {
        bubbles: true, detail: { source: 'amana-carrinho' }
      }));
    }

    listaEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-am-menos],[data-am-mais],[data-am-tira]');
      if (!b || b.disabled) return;
      var linha = b.closest('[data-am-linha]');
      if (!linha) return;
      var chave = linha.getAttribute('data-am-linha');
      if (b.hasAttribute('data-am-tira')) { muda(chave, 0, linha); return; }
      var campo = linha.querySelector('[data-am-qtd]');
      var atual = parseInt(campo && campo.value, 10) || 1;
      var nova = b.hasAttribute('data-am-mais') ? atual + 1 : Math.max(1, atual - 1);
      if (campo) campo.value = nova;
      muda(chave, nova, linha);
    });

    /* digitar a quantidade: só números; vale ao parar de digitar (0,7 s), no
       Enter ou ao sair do campo. Campo vazio ao sair volta ao que era; 0 tira. */
    var digTimer = null;
    function confirmaCampo(campo) {
      clearTimeout(digTimer);
      var linha = campo.closest('[data-am-linha]');
      if (!linha) return;
      var v = campo.value.replace(/\D/g, '');
      var chave = linha.getAttribute('data-am-linha');
      if (v === '') {
        var era = (ultimo && ultimo.items || []).filter(function (i) { return i.key === chave; })[0];
        campo.value = era ? era.quantity : 1;
        return;
      }
      var q = Math.min(999, parseInt(v, 10));
      var antes = (ultimo && ultimo.items || []).filter(function (i) { return i.key === chave; })[0];
      if (antes && antes.quantity === q && pend[chave] === undefined) return;
      muda(chave, q, linha);
    }
    listaEl.addEventListener('input', function (e) {
      var campo = e.target.closest && e.target.closest('[data-am-qtd]');
      if (!campo) return;
      campo.value = campo.value.replace(/\D/g, '').slice(0, 3);
      clearTimeout(digTimer);
      if (campo.value !== '') digTimer = setTimeout(function () { confirmaCampo(campo); }, 700);
    });
    listaEl.addEventListener('keydown', function (e) {
      var campo = e.target.closest && e.target.closest('[data-am-qtd]');
      if (campo && e.key === 'Enter') { e.preventDefault(); confirmaCampo(campo); campo.blur(); }
    });
    listaEl.addEventListener('focusout', function (e) {
      var campo = e.target.closest && e.target.closest('[data-am-qtd]');
      if (campo) confirmaCampo(campo);
    });
    listaEl.addEventListener('focusin', function (e) {
      var campo = e.target.closest && e.target.closest('[data-am-qtd]');
      if (campo) setTimeout(function () { try { campo.select(); } catch (err) { } }, 0);
    });

    cx.addEventListener('click', function (e) {
      var b = e.target.closest('[data-am-add]');
      if (!b) return;
      var sug = b.closest('[data-am-sug]');
      var img = sug && sug.querySelector('img');
      var nm = sug && sug.querySelector('.am-sug__nome');
      var linha = chegando(nm && nm.textContent, img && img.src);
      if (sug) sug.hidden = true;
      adiciona(b.getAttribute('data-am-add'), b).then(function () { if (linha.parentNode) linha.remove(); });
    });

    /* ---------------- carrossel da prateleira ---------------- */
    function ajustaSetas() {
      cx.querySelectorAll('[data-am-carr-ir]').forEach(function (s) {
        s.hidden = carrEl.scrollWidth <= carrEl.clientWidth + 4;
      });
    }
    cx.querySelectorAll('[data-am-carr-ir]').forEach(function (s) {
      s.addEventListener('click', function () {
        carrEl.scrollLeft += Number(s.getAttribute('data-am-carr-ir')) * (carrEl.clientWidth * .8);
      });
    });
    window.addEventListener('resize', function () { if (!pratEl.hidden) ajustaSetas(); });

    /* ---------------- copiar o link do carrinho ---------------- */
    var btnLink = cx.querySelector('[data-am-cart-link]');
    if (btnLink) {
      btnLink.addEventListener('click', function () {
        carrega().then(function (c) {
          if (!c || !c.items || !c.items.length) return;
          var perma = c.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
          var url = location.origin + raiz() + 'cart/' + perma;
          var pronto = function () {
            btnLink.classList.add('am-copiou');
            setTimeout(function () { btnLink.classList.remove('am-copiou'); }, 1600);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(pronto, function () { });
          }
        });
      });
    }

    /* ---------------- adicionar rápido de qualquer cartão ----------------
       Um só ouvinte no documento serve a grade de coleção, a home e o que vier:
       adiciona, abre o carrinho e deixa o botão dizer que deu certo. */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-am-add-rapido]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var antes = b.textContent;
      b.disabled = true;
      /* a gaveta abre JÁ, com o produto "chegando" no topo; antes ela só
         abria depois da resposta da loja (~1 s de botão parado) */
      var card = b.closest('.am-cp, article');
      var nm = card && card.querySelector('.am-cp__nome, h3');
      var im = card && card.querySelector('img');
      abrir();
      var linha = chegando(nm && nm.textContent.trim(), im && (im.currentSrc || im.src));
      adiciona(b.getAttribute('data-am-add-rapido'), b).then(function () {
        if (linha.parentNode) linha.remove();
        b.textContent = 'Adicionado';
        setTimeout(function () { b.textContent = antes; }, 1600);
      });
    });

    /* EVENTOS DO CLARITY (20/10). O "Adicionar ao carrinho" automático do
       Clarity não enxerga a nossa sacola (fala com /cart/add.js por fetch):
       em 30 dias ele contou 4 sessões e a Shopify 72. Com estes eventos o
       funil do Clarity passa a valer. `amana:cart:open` só é disparado pela
       PDP e pela barra fixa DEPOIS de adicionar; o ícone do cabeçalho abre a
       gaveta por clique, não por este evento. */
    function evento(nome) {
      try { if (typeof window.clarity === 'function') window.clarity('event', nome); } catch (e) { }
    }
    document.addEventListener('amana:cart:open', function () { evento('adicionar_sacola'); });
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-am-add-rapido],[data-am-add]')) evento('adicionar_sacola');
      else if (e.target.closest('[data-am-cart-ok],.am-cp2__ok')) evento('iniciar_checkout');
      else if (e.target.closest('[data-am-cart-mais],.am-cp2__continuar')) evento('comprar_mais');
    }, true);

    /* qualquer componente que mexer no carrinho avisa por aqui */
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e.detail && e.detail.source === 'amana-carrinho') return;
      carrega();
    });

    /* ---------------- frete pelo CEP ---------------- */
    var freteEl = cx.querySelector('[data-am-frete]');
    var freteForma = cx.querySelector('[data-am-frete-forma]');
    var freteCep = cx.querySelector('[data-am-frete-cep]');
    var freteBt = cx.querySelector('[data-am-frete-bt]');
    var freteLista = cx.querySelector('[data-am-frete-lista]');
    var freteMsg = cx.querySelector('[data-am-frete-msg]');
    var CEP_CHAVE = 'amana-cep';
    var WHATS = 'https://wa.me/5511930339526?text=';
    var freteUltimo = '';

    /* faixas de CEP dos Correios → UF (a rota da Shopify exige o estado) */
    var FAIXAS = [
      [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
      [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
      [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
      [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
      [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
      [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
      [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'],
      [88000, 89999, 'SC'], [90000, 99999, 'RS']
    ];
    function ufDoCep(cep) {
      var n = Number(String(cep).slice(0, 5));
      for (var i = 0; i < FAIXAS.length; i++) if (n >= FAIXAS[i][0] && n <= FAIXAS[i][1]) return FAIXAS[i][2];
      return '';
    }
    function soDigitos(v) { return String(v || '').replace(/\D/g, '').slice(0, 8); }
    function mascara(d) { return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d; }
    function nomeFrete(n) { return String(n || '').replace(/\s*\(Melhor Envio\)\s*/i, '').trim(); }
    function prazo(r) {
      var d = r.delivery_days;
      if (d && d.length === 2) return d[0] === d[1] ? d[0] + ' dias úteis' : d[0] + ' a ' + d[1] + ' dias úteis';
      if (d && d.length === 1) return d[0] + ' dias úteis';
      return '';
    }
    function aviso(html) {
      if (!freteMsg) return;
      freteMsg.innerHTML = html || '';
      freteMsg.hidden = !html;
    }

    function calculaFrete(cep) {
      var d = soDigitos(cep);
      if (d.length !== 8) { aviso('Digite os 8 números do CEP.'); return; }
      var uf = ufDoCep(d);
      if (!uf) { aviso('Esse CEP não parece ser do Brasil. Confira e tente de novo.'); return; }
      try { localStorage.setItem(CEP_CHAVE, d); } catch (e) { }
      freteUltimo = d;
      evento('calcular_frete');
      var q = 'shipping_address[zip]=' + encodeURIComponent(mascara(d)) +
        '&shipping_address[country]=Brazil&shipping_address[province]=' + uf;
      freteBt.disabled = true;
      freteBt.textContent = '…';
      freteLista.innerHTML = '';
      aviso('');
      var tentativas = 0;
      function busca() {
        return fetch(raiz() + 'cart/async_shipping_rates.json?' + q, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.status === 200 ? r.text() : ''; })
          .then(function (t) {
            if (t && t !== 'null') return JSON.parse(t);
            if (++tentativas > 18) throw new Error('demora');
            return new Promise(function (ok) { setTimeout(ok, 700); }).then(busca);
          });
      }
      fetch(raiz() + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 422) throw new Error('cep');
          return busca();
        })
        .then(function (j) {
          if (d !== freteUltimo) return;
          var lista = (j && j.shipping_rates) || [];
          lista.sort(function (a, b) { return Number(a.price) - Number(b.price); });
          if (!lista.length) {
            aviso('Ainda não temos frete automático para esse CEP nesse valor. <a href="' + WHATS +
              encodeURIComponent('Oi! Quero comprar na loja da Amana e o frete não apareceu para o CEP ' + mascara(d) + '.') +
              '" target="_blank" rel="noopener">Chame a gente no WhatsApp</a> que a gente resolve.');
            return;
          }
          freteLista.innerHTML = lista.map(function (r) {
            var gratis = Number(r.price) === 0;
            var p = prazo(r);
            return '<li class="am-frete__op' + (gratis ? ' am-frete__op--gratis' : '') + '">' +
              '<b>' + esc(nomeFrete(r.name)) + '</b>' +
              '<em>' + (gratis ? 'Grátis' : moeda(Math.round(Number(r.price) * 100))) + '</em>' +
              (p ? '<span>' + esc(p) + '</span>' : '') + '</li>';
          }).join('');
        })
        .catch(function (e) {
          aviso(e && e.message === 'cep'
            ? 'Não achamos esse CEP. Confira os números e tente de novo.'
            : 'Não deu para calcular agora. O frete aparece certinho no checkout.');
        })
        .then(function () {
          freteBt.disabled = false;
          freteBt.textContent = cx.getAttribute('data-rot-frete-bt') || 'Calcular';
        });
    }

    if (freteForma) {
      freteCep.addEventListener('input', function () { freteCep.value = mascara(soDigitos(freteCep.value)); });
      freteForma.addEventListener('submit', function (e) { e.preventDefault(); calculaFrete(freteCep.value); });
      try {
        var salvo = localStorage.getItem(CEP_CHAVE);
        if (salvo) freteCep.value = mascara(salvo);
      } catch (e) { }
    }
    /* Com a gaveta aberta e um CEP guardado, a conta se refaz sozinha quando
       a sacola muda (o frete grátis entra ou sai). Fechada, não gasta pedido. */
    var freteTimer = null, freteTotal = null;
    document.addEventListener('amana:cart:pintado', function (e) {
      var c = e.detail || {};
      if (!freteEl) return;
      freteEl.hidden = !(c.item_count > 0);
      if (!c.item_count) return;
      if (!aberto) { freteTotal = null; return; }
      if (freteTotal === c.total_price && freteLista.children.length) return;
      freteTotal = c.total_price;
      if (!freteCep || soDigitos(freteCep.value).length !== 8) return;
      clearTimeout(freteTimer);
      freteTimer = setTimeout(function () { calculaFrete(freteCep.value); }, 450);
    });

    /* "Comprar mais": já estando na loja toda, não recarrega — fecha a gaveta
       e desce até a grade */
    if (maisBtn) {
      maisBtn.addEventListener('click', function (e) {
        var alvo;
        try { alvo = new URL(maisBtn.href, location.href); } catch (err) { return; }
        if (alvo.pathname !== location.pathname) return;
        e.preventDefault();
        fechar();
        var grade = document.getElementById('produtos');
        if (grade) setTimeout(function () { grade.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120);
      });
    }

    /* Página que volta sem ser carregada de novo mostra o carrinho de QUANDO
       ela foi montada: o "voltar" do celular (cache de ida e volta), a aba que
       volta do checkout e a PDP pré-montada pelas Speculation Rules
       (amana-instantaneo) antes do clique. Nos três, pergunta de novo. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) carrega(); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') carrega();
    });
    if (document.prerendering) {
      document.addEventListener('prerenderingchange', function () { carrega(); }, { once: true });
    }

    carrega();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-cartoes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-am-ct]').forEach(function (raiz) {
      var alvos = raiz.querySelectorAll('[data-am-rv]');
      if ('IntersectionObserver' in window) {
        var ob = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (!en.isIntersecting) return;
            en.target.classList.add('am-vis');
            ob.unobserve(en.target);
          });
        }, { threshold: .08 });
        alvos.forEach(function (e) { ob.observe(e); });
      } else {
        alvos.forEach(function (e) { e.classList.add('am-vis'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-colecao"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-cln]');
    if (!raiz) return;

    /* o celular é o corte da casa (749); a gaveta e a cascata só valem nele */
    var cel = window.matchMedia('(max-width: 749px)');

    /* ---------------- revelação ----------------
       No celular os cartões que entram JUNTOS (a mesma leva do observador)
       ganham atraso em cascata, 80ms um do outro — é a entrada da Bragg
       (fade + 24px, stagger .1). No computador vale o atraso de sempre, que
       vem do snippet do cartão. */
    function observa() {
      var alvos = raiz.querySelectorAll('[data-am-rv]:not(.am-vis)');
      if (!alvos.length) return;
      if (!('IntersectionObserver' in window)) {
        alvos.forEach(function (e) { e.classList.add('am-vis'); });
        return;
      }
      var ob = new IntersectionObserver(function (ents) {
        var k = 0;
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          if (cel.matches && en.target.classList.contains('am-cp')) {
            en.target.style.setProperty('--am-atraso', Math.min(k++, 6) * 80 + 'ms');
          }
          en.target.classList.add('am-vis');
          ob.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: .04 });
      alvos.forEach(function (e) { ob.observe(e); });
    }
    observa();

    /* ---------------- painel de filtros ----------------
       Computador: o painel abre e fecha no lugar (`hidden`), como sempre.
       Celular: vira gaveta. Tira o `hidden`, espera um quadro e liga
       `.am-cln--gaveta` — a transição de .2s só roda se o painel já existir
       na tela antes da classe. Ao fechar, o `hidden` volta depois da saída.
       A página de trás fica presa no lugar (position:fixed com o topo
       negativo) e volta ao mesmo ponto ao soltar — overflow:hidden sozinho
       faz a página pular para o topo (armadilha 51). */
    var btf = raiz.querySelector('[data-am-cln-filtros]');
    var painel = raiz.querySelector('[data-am-cln-painel]');
    var veu = raiz.querySelector('[data-am-cln-veu]');
    var fecha = raiz.querySelector('[data-am-cln-fecha]');
    var travadoEm = null, saida = 0;

    function trava(on) {
      var h = document.documentElement, b = document.body;
      if (on && travadoEm === null) {
        travadoEm = window.scrollY || h.scrollTop || 0;
        b.style.top = -travadoEm + 'px';
        h.classList.add('am-cln-trava');
        b.classList.add('am-cln-trava');
      } else if (!on && travadoEm !== null) {
        h.classList.remove('am-cln-trava');
        b.classList.remove('am-cln-trava');
        b.style.top = '';
        window.scrollTo(0, travadoEm);
        travadoEm = null;
      }
    }
    function aberta() { return raiz.classList.contains('am-cln--gaveta'); }
    function abre(on) {
      if (!btf || !painel) return;
      btf.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (!cel.matches) {
        painel.hidden = !on;
        return;
      }
      clearTimeout(saida);
      if (on) {
        painel.hidden = false;
        if (veu) veu.hidden = false;
        painel.setAttribute('role', 'dialog');
        painel.setAttribute('aria-modal', 'true');
        trava(true);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { raiz.classList.add('am-cln--gaveta'); });
        });
        if (fecha) fecha.focus({ preventScroll: true });
      } else {
        raiz.classList.remove('am-cln--gaveta');
        trava(false);
        painel.removeAttribute('role');
        painel.removeAttribute('aria-modal');
        saida = setTimeout(function () {
          painel.hidden = true;
          if (veu) veu.hidden = true;
        }, 220);
        btf.focus({ preventScroll: true });
      }
    }
    if (btf && painel) {
      btf.addEventListener('click', function () {
        abre(cel.matches ? !aberta() : painel.hidden);
      });
      if (fecha) fecha.addEventListener('click', function () { abre(false); });
      if (veu) veu.addEventListener('click', function () { abre(false); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && aberta()) abre(false);
      });
      /* virou a tela e passou do corte com a gaveta aberta: solta tudo */
      var mudou = function () {
        if (!cel.matches && aberta()) {
          raiz.classList.remove('am-cln--gaveta');
          trava(false);
          painel.removeAttribute('role');
          painel.removeAttribute('aria-modal');
          if (veu) veu.hidden = true;
        }
      };
      if (cel.addEventListener) cel.addEventListener('change', mudou);
      /* "Ver resultados": fecha e leva ao começo da grade */
      var ver = raiz.querySelector('[data-am-cln-ver]');
      if (ver) ver.addEventListener('click', function () {
        abre(false);
        var alvo = raiz.querySelector('#produtos');
        if (alvo) setTimeout(function () { alvo.scrollIntoView({ block: 'start' }); }, 30);
      });
    }

    /* ---------------- facetas por etiqueta, no cliente ----------------
       Os cartões já vieram todos no HTML; filtrar é esconder e mostrar.
       Dentro do grupo é "ou", entre grupos é "e". */
    var nada = raiz.querySelector('[data-am-cln-nada]');
    var conta = raiz.querySelector('[data-am-cln-conta]');
    var contaRot = raiz.querySelector('[data-am-cln-conta-rot]');
    var contador = raiz.querySelector('[data-am-cln-n]');
    var contador2 = raiz.querySelector('[data-am-cln-n2]');
    var verN = raiz.querySelector('[data-am-cln-ver-n]');
    var prog = raiz.querySelector('[data-am-cln-prog]');
    var ativos = raiz.querySelector('[data-am-cln-ativos]');
    var faixa = raiz.querySelector('[data-am-cln-faixa]');
    var caixas = Array.prototype.slice.call(raiz.querySelectorAll('[data-am-facet]'));
    var caixaEstoque = raiz.querySelector('[data-am-facet-estoque]');
    var ROT1 = raiz.getAttribute('data-rot-item') || 'produto';
    var ROTN = raiz.getAttribute('data-rot-itens') || 'produtos';
    var cartoes = Array.prototype.slice.call(raiz.querySelectorAll('.am-cln__grade [data-am-tags]'));
    var todas = caixas.concat(caixaEstoque ? [caixaEstoque] : []);

    function escolhidas() {
      var por = {};
      caixas.forEach(function (c) {
        if (!c.checked) return;
        var t = c.getAttribute('data-am-facet');
        var g = t.split(':')[0];
        (por[g] = por[g] || []).push(t);
      });
      return por;
    }
    function passa(el, por) {
      var tags = (el.getAttribute('data-am-tags') || '').split('~~');
      for (var g in por) {
        var ok = false;
        for (var i = 0; i < por[g].length; i++) {
          if (tags.indexOf(por[g][i]) > -1) { ok = true; break; }
        }
        if (!ok) return false;
      }
      if (caixaEstoque && caixaEstoque.checked && el.getAttribute('data-am-estoque') !== '1') return false;
      return true;
    }

    function pintaAtivos(marcadas) {
      if (!ativos || !todas.length) return;
      ativos.textContent = '';
      marcadas.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'am-cln__ativo';
        b.textContent = c.getAttribute('data-am-facet-rot') || '';
        var x = document.createElement('span');
        x.setAttribute('aria-hidden', 'true');
        x.textContent = '×';
        b.appendChild(x);
        b.setAttribute('aria-label', 'Tirar o filtro ' + b.firstChild.textContent);
        b.addEventListener('click', function () { c.checked = false; aplica(true); });
        ativos.appendChild(b);
      });
      if (marcadas.length > 1) {
        var l = document.createElement('button');
        l.type = 'button';
        l.className = 'am-cln__limpa';
        l.textContent = (nada && nada.querySelector('[data-am-cln-limpa]') || {}).textContent || 'Limpar tudo';
        l.addEventListener('click', limpaTudo);
        ativos.appendChild(l);
      }
      ativos.hidden = marcadas.length === 0;
    }

    function aplica(empurra) {
      if (!todas.length) return;
      var por = escolhidas();
      var quantos = 0;
      cartoes.forEach(function (el) {
        var mostra = passa(el, por);
        el.hidden = !mostra;
        if (mostra) quantos++;
      });

      /* quantos sobrariam se esta caixa também fosse marcada */
      caixas.forEach(function (c) {
        var t = c.getAttribute('data-am-facet');
        var g = t.split(':')[0];
        var teste = {};
        for (var k in por) if (k !== g) teste[k] = por[k];
        teste[g] = [t];
        var n = 0;
        cartoes.forEach(function (el) { if (passa(el, teste)) n++; });
        var alvo = c.parentNode.querySelector('[data-am-facet-n]');
        if (alvo) alvo.textContent = n;
        c.parentNode.classList.toggle('am-on', c.checked);
        c.parentNode.classList.toggle('am-zero', n === 0 && !c.checked);
        c.disabled = n === 0 && !c.checked;
      });
      if (caixaEstoque) caixaEstoque.parentNode.classList.toggle('am-on', caixaEstoque.checked);

      var marcadas = todas.filter(function (c) { return c.checked; });
      if (faixa) faixa.hidden = marcadas.length > 0;
      if (contador) { contador.hidden = marcadas.length === 0; contador.textContent = marcadas.length; }
      if (contador2) contador2.textContent = marcadas.length;
      if (verN) verN.textContent = quantos;
      if (prog) prog.hidden = marcadas.length > 0;
      if (conta) conta.textContent = quantos;
      if (contaRot) contaRot.textContent = quantos === 1 ? ROT1 : ROTN;
      if (nada) nada.hidden = quantos > 0;
      pintaAtivos(marcadas);

      /* o endereço guarda a escolha: dá para mandar o link filtrado */
      if (empurra) {
        var marcas = caixas.filter(function (c) { return c.checked; })
          .map(function (c) { return c.getAttribute('data-am-facet'); });
        if (caixaEstoque && caixaEstoque.checked) marcas.push('estoque');
        history.replaceState(null, '', location.pathname + location.search +
          (marcas.length ? '#f=' + encodeURIComponent(marcas.join('~~')) : ''));
      }
    }
    function limpaTudo() {
      todas.forEach(function (c) { c.checked = false; });
      aplica(true);
    }

    todas.forEach(function (c) { c.addEventListener('change', function () { aplica(true); }); });
    var limpar = raiz.querySelector('[data-am-cln-limpa]');
    if (limpar) {
      if (todas.length) limpar.addEventListener('click', limpaTudo);
      else limpar.hidden = true;
    }
    /* o "Limpar" do rodapé da gaveta (filtro por etiqueta; o da Shopify é link) */
    var flimpa = raiz.querySelector('[data-am-cln-flimpa]');
    if (flimpa) flimpa.addEventListener('click', limpaTudo);

    /* volta o que veio no endereço */
    (function () {
      var m = /#f=([^&]+)/.exec(location.hash);
      if (!m) { aplica(false); return; }
      var querem = decodeURIComponent(m[1]).split('~~');
      caixas.forEach(function (c) {
        if (querem.indexOf(c.getAttribute('data-am-facet')) > -1) c.checked = true;
      });
      if (caixaEstoque && querem.indexOf('estoque') > -1) caixaEstoque.checked = true;
      /* no computador o painel abre mostrando o que veio ligado; no celular a
         gaveta cobriria a página logo ao chegar — os chips de "ativos" acima
         da grade já contam o que está ligado */
      if (!cel.matches) abre(true);
      aplica(false);
    })();

    /* ---------------- "Ver mais" (celular) ----------------
       Busca a página seguinte e anexa os cartões nesta grade. Os cartões
       novos entram na lista do filtro e no observador da revelação; o texto
       "você viu" e a barra acompanham. Se a busca falhar, segue o link. */
    var mais = raiz.querySelector('[data-am-cln-mais]');
    var viuEl = raiz.querySelector('[data-am-cln-viu]');
    var barra = raiz.querySelector('[data-am-cln-barra]');
    if (mais && window.fetch && window.DOMParser) {
      mais.addEventListener('click', function (e) {
        e.preventDefault();
        if (mais.getAttribute('aria-busy') === 'true') return;
        mais.setAttribute('aria-busy', 'true');
        var url = new URL(mais.getAttribute('href'), location.href);
        url.hash = '';
        fetch(url.toString(), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var grade = raiz.querySelector('.am-cln__grade');
            var novos = doc.querySelectorAll('.am-cln__grade > .am-cp');
            if (!grade || !novos.length) throw new Error('vazio');
            novos.forEach(function (n) {
              var el = document.importNode(n, true);
              grade.appendChild(el);
              cartoes.push(el);
            });
            var total = Number(prog && prog.getAttribute('data-total')) || 0;
            var agora = Math.min(total || Infinity, (Number(viuEl && viuEl.textContent) || 0) + novos.length);
            var prox = doc.querySelector('[data-am-cln-mais]');
            /* última página: viu tudo. O esgotado não vira cartão e o
               deslocamento da página ainda o conta — sem isto a barra podia
               parar em "22 de 23" */
            if (!prox && total) agora = total;
            if (viuEl) viuEl.textContent = agora;
            if (barra && total) {
              barra.style.width = Math.round(agora / total * 100) + '%';
              barra.parentNode.setAttribute('aria-valuenow', agora);
            }
            if (prox) {
              mais.setAttribute('href', prox.getAttribute('href'));
              mais.removeAttribute('aria-busy');
            } else {
              mais.remove();
            }
            observa();
            aplica(false);
          })
          .catch(function () { location.href = mais.href; });
      });
    }

    /* ordenar é coisa de servidor: recarrega com o sort_by, mantendo filtro
       da Shopify se houver, e volta para a primeira página */
    var ord = raiz.querySelector('[data-am-cln-ord]');
    if (ord) {
      var inicial = ord.value;
      ord.addEventListener('change', function () {
        if (ord.value === inicial) return;
        var u = new URL(location.href);
        u.searchParams.set('sort_by', ord.value);
        u.searchParams.delete('page');
        u.hash = 'produtos';
        var grade = raiz.querySelector('[data-am-cln-grade]');
        if (grade) grade.classList.add('am-trocando');
        location.href = u.toString();
      });
    }
  })();

  /* ---------------- a faixa de vantagens ----------------
     Clona a escada de degraus da gaveta (amana-carrinho, no layout) para a
     faixa e repinta o clone quando a gaveta repinta (`amana:cart:pintado`,
     com o carrinho no detail). O "Seu carrinho: n itens · R$ X" aparece só
     com item no carrinho. */
  (function () {
    var slot = document.querySelector('[data-am-cln-dg]');
    if (!slot) return;
    var orig = document.querySelector('[data-am-cart] [data-am-dg]');
    var escada = null;
    if (orig) {
      escada = orig.cloneNode(true);
      slot.innerHTML = '';
      slot.appendChild(escada);
    }
    var caixa = document.querySelector('[data-am-cln-vcart]');
    var txt = document.querySelector('[data-am-cln-vcart-txt]');
    var MOEDA = (document.querySelector('[data-am-cart]') || document.body).getAttribute('data-am-moeda') || 'BRL';
    function moeda(c) {
      try { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: MOEDA }); }
      catch (e) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
    }
    document.addEventListener('amana:cart:pintado', function (e) {
      var c = e.detail || {};
      if (escada && window.AmanaDegraus) {
        window.AmanaDegraus.pinta(escada, c.items_subtotal_price || 0, c.total_price || 0);
      }
      if (caixa && txt) {
        var n = c.item_count || 0;
        caixa.hidden = n === 0;
        if (n > 0) {
          txt.innerHTML = 'No carrinho: ' + n + (n === 1 ? ' item' : ' itens') +
            ' · <b>' + moeda(c.total_price || 0) + '</b>';
        }
      }
    });

    /* cupom: copiar e guardar na sessão (/discount/CÓDIGO em segundo plano),
       como o da PDP — chega aplicado no checkout mesmo sem colar */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-am-cln-cupom-copia]');
      if (!b) return;
      var cx = b.closest('[data-am-cln-cupom]');
      var cod = cx ? cx.getAttribute('data-am-cln-cupom') : '';
      var rot = b.querySelector('[data-am-cln-cupom-rot]');
      function ok() {
        if (rot) rot.textContent = 'Copiado!';
        b.classList.add('am-feito');
        setTimeout(function () { if (rot) rot.textContent = cod; b.classList.remove('am-feito'); }, 2200);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(cod).then(ok, ok);
      else ok();
      if (!b.dataset.amCupomGuardado && window.fetch) {
        b.dataset.amCupomGuardado = '1';
        fetch('/discount/' + encodeURIComponent(cod), { credentials: 'same-origin' }).catch(function () {});
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-colecoes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-cls]');
    if (!raiz) return;
    var alvos = raiz.querySelectorAll('[data-am-rv]');
    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
      return;
    }
    var ob = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('am-vis');
        ob.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: .05 });
    alvos.forEach(function (e) { ob.observe(e); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-confronto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-cf]');
    if (!raiz) return;
    var pares = Array.prototype.slice.call(raiz.querySelectorAll('[data-am-cf-par]'));
    var pontos = Array.prototype.slice.call(raiz.querySelectorAll('[data-am-cf-ponto]'));
    if (!pares.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      pares.forEach(function (p) { p.classList.add('am-on'); });
      pontos.forEach(function (p) { p.parentNode.classList.add('am-on'); });
      return;
    }

    var atual = -1;
    function mostra(i) {
      i = Math.max(0, Math.min(pares.length - 1, i));
      if (i === atual) return;
      atual = i;
      pares.forEach(function (p, k) { p.classList.toggle('am-on', k === i); });
      pontos.forEach(function (p, k) { p.parentNode.classList.toggle('am-on', k === i); });
    }

    var pendente = false;
    function desenha() {
      pendente = false;
      var r = raiz.getBoundingClientRect();
      var total = raiz.offsetHeight - window.innerHeight;
      if (total <= 0) { mostra(0); return; }
      var p = Math.max(0, Math.min(1, -r.top / total));
      /* uma folga de 6% em cada ponta para o primeiro e o último respirarem */
      var f = Math.max(0, Math.min(1, (p - 0.06) / 0.88));
      mostra(Math.floor(f * pares.length * 0.999));
    }
    function agenda() {
      if (pendente) return;
      pendente = true;
      requestAnimationFrame(desenha);
    }

    var pw = document.querySelector('.page-wrapper');
    var rolador = (pw && pw.scrollHeight > pw.clientHeight + 4) ? pw : window;
    document.addEventListener('scroll', agenda, { passive: true, capture: true });
    window.addEventListener('resize', agenda);
    desenha();

    /* clicar num ponto rola até a fatia daquele par */
    pontos.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = Number(b.getAttribute('data-am-cf-ponto'));
        var total = raiz.offsetHeight - window.innerHeight;
        var frac = 0.06 + ((i + 0.5) / pares.length) * 0.88;
        var alvo = raiz.getBoundingClientRect().top + (rolador === window ? window.scrollY : rolador.scrollTop) + total * frac;
        (rolador === window ? window : rolador).scrollTo({ top: alvo, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-conta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cx = document.querySelector('[data-am-conta]');
    if (!cx) return;
    function troca(liga) {
      cx.classList.toggle('am-ct2c--senha', liga);
      var alvo = cx.querySelector(liga ? '#recuperar input' : '#entrar input');
      if (alvo) alvo.focus();
    }
    var pedir = cx.querySelector('[data-am-conta-senha]');
    var voltar = cx.querySelector('[data-am-conta-volta]');
    if (pedir) pedir.addEventListener('click', function (e) { e.preventDefault(); troca(true); });
    if (voltar) voltar.addEventListener('click', function (e) { e.preventDefault(); troca(false); });
    /* a Shopify volta para #recuperar depois de pedir a troca de senha */
    if (location.hash === '#recuperar') cx.classList.add('am-ct2c--senha');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-contato"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-ct2]');
    if (!raiz) return;
    var alvos = raiz.querySelectorAll('[data-am-rv]');
    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
      return;
    }
    var ob = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('am-vis');
        ob.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: .04 });
    alvos.forEach(function (e) { ob.observe(e); });

    /* volta do POST já mostrando o agradecimento — ou o erro do servidor */
    var volta = raiz.querySelector('.am-ct2__ok') || raiz.querySelector('[data-am-ct2-erro-srv]');
    if (volta) {
      volta.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (volta.hasAttribute('tabindex')) volta.focus({ preventScroll: true });
    }

    /* ---------- validação da casa: sem balão cinza do navegador ---------- */
    var forma = raiz.querySelector('[data-am-ct2-forma]');
    if (!forma) return;
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var MASSA = 'M12.42,10.3 L17.21,8.94 L23.42,8.69 L29.32,7.59 L33.22,6.55 L34.35,12.71 L34.91,20.95 L35.58,26.75 L37.45,33.22 L30.94,34.28 L23.25,34.97 L17.39,36.1 L10.78,37.45 L9.27,31.05 L8.86,22.44 L7.96,14.87 L6.55,10.78 Z';
    var nMask = 0;

    /* biscoitinho mordido com três farelos, para a dica do campo */
    function mordido() {
      var id = 'am-ct2-dm' + (++nMask);
      return '<svg viewBox="0 0 44 44" aria-hidden="true" focusable="false">'
        + '<defs><mask id="' + id + '"><rect x="-4" y="-4" width="52" height="52" fill="#fff"/>'
        + '<circle class="am-ct2__mord" cx="36" cy="13" r="8" fill="#000"/></mask></defs>'
        + '<g mask="url(#' + id + ')"><path class="am-ct2__massa" d="' + MASSA + '"/>'
        + '<path class="am-ct2__furo" d="M13.32,15.27 L15.48,15.97 L14.78,18.13 L12.62,17.43 Z"/>'
        + '<path class="am-ct2__furo" d="M18.29,28.69 L18.62,30.61 L16.71,30.95 L16.37,29.03 Z"/></g>'
        + '<path class="am-ct2__farelo am-ct2__farelo--1" d="M39.6,10 L41.8,11 L40.8,13.2 L38.6,12.2 Z"/>'
        + '<path class="am-ct2__farelo am-ct2__farelo--2" d="M41,17 L42.4,18.8 L40.6,20.2 L39.2,18.4 Z"/>'
        + '<path class="am-ct2__farelo am-ct2__farelo--3" d="M36.8,19.4 L38.6,19.7 L38.3,21.5 L36.5,21.2 Z"/>'
        + '</svg>';
    }

    function controle(campo) {
      return campo.querySelector('input, textarea, select');
    }
    /* o select da casa é casca: quem recebe foco e borda é o botão dela */
    function alvoVisivel(campo) {
      return campo.querySelector('.am-esc__botao') || controle(campo);
    }

    function problema(campo) {
      var c = controle(campo), v = (c.value || '').trim();
      var dica = campo.querySelector('.am-ct2__dica');
      if (!v) return dica.getAttribute('data-msg');
      if (c.type === 'email' && !EMAIL.test(v)) return dica.getAttribute('data-msg-formato');
      return '';
    }

    function marca(campo, msg) {
      var dica = campo.querySelector('.am-ct2__dica'), c = controle(campo);
      campo.classList.add('am-ct2__campo--erro');
      c.setAttribute('aria-invalid', 'true');
      /* texto novo = desenho novo: a mordida e o farelo tocam de novo */
      dica.innerHTML = mordido() + '<span>' + msg.replace(/</g, '&lt;') + '</span>';
      dica.hidden = false;
      campo.classList.remove('am-ct2__campo--treme');
      void campo.offsetWidth;
      campo.classList.add('am-ct2__campo--treme');
    }

    function limpa(campo) {
      var dica = campo.querySelector('.am-ct2__dica');
      campo.classList.remove('am-ct2__campo--erro', 'am-ct2__campo--treme');
      controle(campo).removeAttribute('aria-invalid');
      if (dica) { dica.hidden = true; dica.innerHTML = ''; }
    }

    /* "Quero revender": troca para o cadastro oficial de parceiro */
    var parceiro = raiz.querySelector('[data-am-ct2-parceiro]');
    var selAssunto = forma.querySelector('select[name="contact[Assunto]"]');
    function eRevenda(v) { return /revend|distribu/i.test(v || ''); }
    function mostraParceiro(sim) {
      if (!parceiro) return;
      parceiro.hidden = !sim;
      forma.hidden = sim;
      if (sim) setTimeout(function () { parceiro.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
    }
    if (selAssunto && parceiro) {
      selAssunto.addEventListener('change', function () { mostraParceiro(eRevenda(selAssunto.value)); });
      var volta = parceiro.querySelector('[data-am-ct2-volta]');
      if (volta) volta.addEventListener('click', function () {
        selAssunto.value = '';
        selAssunto.dispatchEvent(new Event('change', { bubbles: true }));
        mostraParceiro(false);
        selAssunto.focus();
      });
      /* link direto: /pages/contact#revenda já abre o cadastro */
      if (eRevenda(selAssunto.value) || location.hash === '#revenda') {
        var op = Array.prototype.find.call(selAssunto.options, function (o) { return eRevenda(o.value); });
        if (op) selAssunto.value = op.value;
        mostraParceiro(true);
      }
    }

    var campos = Array.prototype.slice.call(forma.querySelectorAll('[data-am-ct2-campo]'));
    campos.forEach(function (campo) {
      var c = controle(campo);
      function reavalia() {
        if (!campo.classList.contains('am-ct2__campo--erro')) return;
        if (!problema(campo)) limpa(campo);
      }
      c.addEventListener('input', reavalia);
      c.addEventListener('change', reavalia);
      /* e-mail: avisa ao sair do campo, não a cada tecla */
      if (c.type === 'email') c.addEventListener('blur', function () {
        if (c.value.trim() && !EMAIL.test(c.value.trim())) marca(campo, problema(campo));
      });
    });

    var enviando = false;
    forma.addEventListener('submit', function (e) {
      if (enviando) { e.preventDefault(); return; }
      var primeiro = null;
      campos.forEach(function (campo) {
        var msg = problema(campo);
        if (msg) { marca(campo, msg); if (!primeiro) primeiro = campo; }
        else limpa(campo);
      });
      if (primeiro) {
        e.preventDefault();
        var alvo = alvoVisivel(primeiro);
        primeiro.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { alvo.focus({ preventScroll: true }); }, 280);
        return;
      }
      /* tudo certo: o botão come o biscoito até a página voltar */
      enviando = true;
      var b = forma.querySelector('.am-ct2__enviar'), t = b.querySelector('.am-ct2__env-txt');
      if (t) t.setAttribute('data-antes', t.textContent);
      b.classList.add('am-ct2__enviar--indo');
      b.setAttribute('aria-busy', 'true');
      if (t && t.getAttribute('data-indo')) t.textContent = t.getAttribute('data-indo');
    });

    /* voltou do histórico (bfcache) com o botão ainda "enviando" */
    window.addEventListener('pageshow', function () {
      enviando = false;
      var b = forma.querySelector('.am-ct2__enviar--indo');
      if (!b) return;
      b.classList.remove('am-ct2__enviar--indo');
      b.removeAttribute('aria-busy');
      var t = b.querySelector('.am-ct2__env-txt');
      if (t && t.getAttribute('data-antes')) t.textContent = t.getAttribute('data-antes');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-dist-apoio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-dfa]');
    if (!raiz) return;
    var alvos = [].slice.call(raiz.querySelectorAll('[data-am-rv]'));
    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('am-vis');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    alvos.forEach(function (e) { io.observe(e); });
    setTimeout(function () {
      alvos.forEach(function (e) {
        if (!e.classList.contains('am-vis') && e.getBoundingClientRect().bottom < 0) {
          e.classList.add('am-vis'); io.unobserve(e);
        }
      });
    }, 400);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-dist-conta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-dfc]');
    if (!raiz) return;
    var f = raiz.querySelector('[data-am-dfc-form]');
    var linha = f.querySelector('[data-am-dfc-linha]');
    var un = f.querySelector('[data-am-dfc-un]');
    var mes = f.querySelector('[data-am-dfc-mes]');
    var custo = f.querySelector('[data-am-dfc-custo]');
    var venda = f.querySelector('[data-am-dfc-venda]');
    var vendaCx = f.querySelector('[data-am-dfc-venda-cx]');
    var pre = f.querySelector('[data-am-dfc-venda-pre]');
    var pos = f.querySelector('[data-am-dfc-venda-pos]');
    var alerta = f.querySelector('[data-am-dfc-alerta]');
    function o(n) { return f.querySelector('[data-am-dfc-o="' + n + '"]'); }

    /* aceita "12,50", "1.234,56", "12.5" e "R$ 12,50" */
    function num(v) {
      v = String(v || '').replace(/[R$\s%]/g, '');
      if (!v) return NaN;
      if (v.indexOf(',') > -1) v = v.replace(/\./g, '').replace(',', '.');
      return parseFloat(v);
    }
    function real(v) { return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
    function pct(v) { return v.toLocaleString('pt-BR', { maximumFractionDigits: 1, minimumFractionDigits: 1 }) + '%'; }
    function radio(nome) { var r = f.querySelector('input[name="' + nome + '"]:checked'); return r ? r.value : ''; }

    function limpa() {
      ['margem', 'cu', 'vu', 'lu', 'lc', 'lm'].forEach(function (k) { o(k).textContent = '—'; });
      o('markup-eq').textContent = '';
      alerta.hidden = true;
    }

    function conta() {
      var u = parseInt(un.value, 10);
      var m = parseInt(mes.value, 10);
      var c = num(custo.value);
      var v = num(venda.value);
      var modoVenda = radio('am-dfc-venda');
      o('mes-rot').textContent = (m > 0 ? 'Lucro no mês (' + m + (m === 1 ? ' caixa)' : ' caixas)') : 'Lucro no mês');
      if (!(u > 0) || !(c > 0) || !(v > 0)) { limpa(); return; }

      var cu = radio('am-dfc-custo') === 'un' ? c : c / u;
      var vu = modoVenda === 'markup' ? cu * (1 + v / 100) : v;
      var lu = vu - cu;
      var margem = lu / vu * 100;
      var markup = lu / cu * 100;

      o('cu').textContent = real(cu);
      o('vu').textContent = real(vu);
      o('lu').textContent = real(lu);
      o('lc').textContent = real(lu * u);
      o('lm').textContent = m > 0 ? real(lu * u * m) : '—';
      o('margem').textContent = pct(margem);
      o('markup-eq').textContent = modoVenda === 'markup'
        ? 'É o mesmo que vender a ' + real(vu) + ' a unidade.'
        : 'Equivale a um markup de ' + pct(markup) + ' sobre o custo.';
      if (lu <= 0) {
        alerta.textContent = 'Nesse preço a venda não cobre o custo da unidade.';
        alerta.hidden = false;
      } else {
        alerta.hidden = true;
      }
    }

    function trocaVenda() {
      var mk = radio('am-dfc-venda') === 'markup';
      pre.hidden = mk;
      pos.hidden = !mk;
      vendaCx.classList.toggle('am-dfc--pct', mk);
      venda.placeholder = mk ? '0' : '0,00';
      venda.setAttribute('aria-label', mk ? 'Markup em porcentagem sobre o custo' : 'Preço de venda por unidade em reais');
      venda.value = '';
      conta();
    }

    var sincronizando = false;
    function trocaLinha() {
      if (sincronizando) return;
      if (linha.value) { un.value = linha.value; }
      else { un.value = ''; un.focus(); }
      conta();
    }

    linha.addEventListener('change', trocaLinha);
    f.addEventListener('input', function (e) { if (e.target !== linha) conta(); });
    f.querySelectorAll('input[name="am-dfc-venda"]').forEach(function (r) { r.addEventListener('change', trocaVenda); });
    f.querySelectorAll('input[name="am-dfc-custo"]').forEach(function (r) { r.addEventListener('change', conta); });
    /* se a pessoa mexe nas unidades, a linha escolhida deixa de valer */
    un.addEventListener('input', function () {
      if (linha.value && un.value !== linha.value) {
        /* a casca do dropdown (amana-escolha.js) repinta no `change` */
        linha.value = '';
        sincronizando = true;
        linha.dispatchEvent(new Event('change', { bubbles: true }));
        sincronizando = false;
      }
    });
    if (linha.value) un.value = linha.value;
    conta();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-dist-duvidas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-dfd]');
    if (!raiz) return;
    var itens = [].slice.call(raiz.querySelectorAll('.am-dfd__item'));
    itens.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        itens.forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-dist-folha"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-df]');
    if (!raiz) return;
    var alvos = [].slice.call(raiz.querySelectorAll('[data-am-rv]'));
    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('am-vis');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    alvos.forEach(function (e) { io.observe(e); });

    /* quem abre a página já rolada não cruza observer nenhum */
    setTimeout(function () {
      alvos.forEach(function (e) {
        if (!e.classList.contains('am-vis') && e.getBoundingClientRect().bottom < 0) {
          e.classList.add('am-vis'); io.unobserve(e);
        }
      });
    }, 400);

    /* o CNPJ, o envio e o botão de documentos moram em snippets/amana-form-parceiro */

    /* o formulário volta com ?form_type=contact&...: leva a pessoa de volta
       ao cadastro em vez de deixá-la no topo sem saber se deu certo */
    if (/contact_posted=true/.test(location.search)) {
      var fecho = document.getElementById('cadastro');
      if (fecho) setTimeout(function () { fecho.scrollIntoView({ block: 'center' }); }, 300);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-dist-forca"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-dfz]');
    if (!raiz) return;
    var alvos = [].slice.call(raiz.querySelectorAll('[data-am-rv]'));
    var calmo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* o número sobe de zero até o valor. Só o pedaço numérico conta: "31" conta,
       "FOB" não — e o sufixo ("+", "%") volta no fim, senão o contador engole. */
    function contar(el) {
      if (el.dataset.amFeitoN) return;
      el.dataset.amFeitoN = '1';
      var bruto = el.getAttribute('data-am-dfz-n') || '';
      var m = bruto.match(/^(\D*)(\d+)(.*)$/);
      if (!m || calmo) return;
      var antes = m[1], alvo = parseInt(m[2], 10), depois = m[3];
      if (!isFinite(alvo) || alvo > 100000) return;
      var ini = null, ms = 900;
      function passo(t) {
        if (ini === null) ini = t;
        var k = Math.min(1, (t - ini) / ms);
        /* desacelera no fim: contador linear parece relógio, não conquista */
        var v = Math.round(alvo * (1 - Math.pow(1 - k, 3)));
        el.textContent = antes + v + depois;
        if (k < 1) requestAnimationFrame(passo);
      }
      el.textContent = antes + '0' + depois;
      requestAnimationFrame(passo);
    }

    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
      raiz.querySelectorAll('[data-am-dfz-n]').forEach(contar);
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('am-vis');
        e.target.querySelectorAll('[data-am-dfz-n]').forEach(contar);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    alvos.forEach(function (e) { io.observe(e); });

    /* resgate de quem abre a página já rolada — o mesmo buraco de sempre */
    setTimeout(function () {
      alvos.forEach(function (e) {
        if (e.classList.contains('am-vis')) return;
        if (e.getBoundingClientRect().bottom < 0) {
          e.classList.add('am-vis');
          e.querySelectorAll('[data-am-dfz-n]').forEach(function (n) {
            n.dataset.amFeitoN = '1';
          });
          io.unobserve(e);
        }
      });
    }, 400);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-educacao"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-am-giro]').forEach(function (giro) {
      giro.querySelectorAll('[data-am-vira]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          giro.classList.toggle('am-virado');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-fq]');
    if (!raiz) return;
    var itens = [].slice.call(raiz.querySelectorAll('[data-am-fq-item]'));
    var todas = raiz.querySelector('[data-am-fq-todas]');
    var todasRot = raiz.querySelector('[data-am-fq-todas-rot]');

    function poe(item, abrir) {
      var b = item.querySelector('.am-fq__botao');
      item.classList.toggle('am-fq__item--aberta', abrir);
      if (b) b.setAttribute('aria-expanded', abrir ? 'true' : 'false');
    }
    function sincTodas() {
      if (!todas) return;
      var tudo = itens.length && itens.every(function (i) { return i.classList.contains('am-fq__item--aberta'); });
      todas.setAttribute('aria-pressed', tudo ? 'true' : 'false');
      if (todasRot) todasRot.textContent = tudo ? todasRot.getAttribute('data-fechar') : todasRot.getAttribute('data-abrir');
    }

    itens.forEach(function (item) {
      var b = item.querySelector('.am-fq__botao');
      if (!b) return;
      b.addEventListener('click', function () {
        poe(item, !item.classList.contains('am-fq__item--aberta'));
        sincTodas();
      });
    });
    if (todas) {
      todas.addEventListener('click', function () {
        var abrir = todas.getAttribute('aria-pressed') !== 'true';
        itens.forEach(function (i) { poe(i, abrir); });
        sincTodas();
      });
    }
    sincTodas();

    /* link direto para uma pergunta: /pages/duvidas#mas-e-a-aveia-ela-nao-tem-gluten */
    function pelaAncora() {
      var h = decodeURIComponent((location.hash || '').slice(1));
      if (!h) return;
      var alvo = document.getElementById(h);
      if (!alvo || itens.indexOf(alvo) < 0) return;
      poe(alvo, true);
      alvo.classList.add('am-vis');
      sincTodas();
      setTimeout(function () { alvo.scrollIntoView({ block: 'start' }); }, 60);
    }
    pelaAncora();
    window.addEventListener('hashchange', pelaAncora);

    /* entrada por rolagem (o resgate da casa cobre quem abre já rolado) */
    var rv = [].slice.call(raiz.querySelectorAll('[data-am-rv]'));
    if (!('IntersectionObserver' in window)) {
      rv.forEach(function (e) { e.classList.add('am-vis'); });
    } else {
      var ob = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('am-vis');
          ob.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -4% 0px', threshold: .02 });
      rv.forEach(function (e) { ob.observe(e); });

      /* tema em leitura acende o chip correspondente */
      var chips = [].slice.call(raiz.querySelectorAll('[data-am-fq-chip]'));
      var grupos = [].slice.call(raiz.querySelectorAll('[data-am-fq-grupo][id]'));
      if (chips.length && grupos.length) {
        var visiveis = {};
        var ob2 = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { visiveis[en.target.id] = en.isIntersecting; });
          var atual = null;
          for (var i = 0; i < grupos.length; i++) { if (visiveis[grupos[i].id]) { atual = grupos[i].id; break; } }
          if (!atual) return;
          chips.forEach(function (c) {
            var sim = c.getAttribute('data-am-fq-chip') === atual;
            c.classList.toggle('am-fq__chip--ativo', sim);
            if (sim) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
          });
        }, { rootMargin: '-28% 0px -58% 0px', threshold: 0 });
        grupos.forEach(function (g) { ob2.observe(g); });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-guia"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raizes = document.querySelectorAll('[data-am-gd]');
    if (!raizes.length) return;
    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.prototype.forEach.call(raizes, function (raiz) {
      /* entradas */
      var alvos = raiz.querySelectorAll('[data-am-rv]');
      if (!('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(alvos, function (e) { e.classList.add('am-vis'); });
      } else {
        var ob = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (!en.isIntersecting) return;
            en.target.classList.add('am-vis');
            ob.unobserve(en.target);
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: .02 });
        Array.prototype.forEach.call(alvos, function (e) { ob.observe(e); });
      }

      /* salto suave: a rolagem mora no .page-wrapper no computador,
         então é scrollIntoView (que acha o contêiner certo) */
      Array.prototype.forEach.call(raiz.querySelectorAll('a[data-am-gd-link]'), function (a) {
        a.addEventListener('click', function (ev) {
          var id = (a.getAttribute('href') || '').slice(1);
          var alvo = id && document.getElementById(id);
          if (!alvo) return;
          ev.preventDefault();
          alvo.scrollIntoView({ behavior: reduz ? 'auto' : 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', '#' + id);
        });
      });

      /* o índice acende a parte em leitura */
      var indice = raiz.querySelector('[data-am-gd-indice]');
      var partes = raiz.querySelectorAll('[data-am-gd-parte]');
      if (!indice || !partes.length || !('IntersectionObserver' in window)) return;
      var links = {};
      Array.prototype.forEach.call(indice.querySelectorAll('a[data-am-gd-link]'), function (a) {
        links[(a.getAttribute('href') || '').slice(1)] = a;
      });
      var visiveis = {};
      function acende() {
        var atual = null;
        for (var i = 0; i < partes.length; i++) {
          if (visiveis[partes[i].id]) { atual = partes[i].id; break; }
        }
        if (!atual) return;
        Object.keys(links).forEach(function (k) {
          if (k === atual) links[k].setAttribute('aria-current', 'true');
          else links[k].removeAttribute('aria-current');
        });
      }
      var ob2 = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { visiveis[en.target.id] = en.isIntersecting; });
        acende();
      }, { rootMargin: '-22% 0px -58% 0px', threshold: 0 });
      Array.prototype.forEach.call(partes, function (p) { ob2.observe(p); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-header"]) return;
  try {
    
  (function () {
    // barra de ofertas: gira entre as mensagens ativas
    var aviso = document.querySelector('[data-am-aviso]');
    if (aviso) {
      var itens = aviso.querySelectorAll('.am-aviso__item');
      if (itens.length > 1) {
        var n = 0;
        setInterval(function () {
          itens[n].classList.remove('am-ativo');
          n = (n + 1) % itens.length;
          itens[n].classList.add('am-ativo');
        }, 4200);
      }
    }
  })();

  /* A folga do topo sai da ALTURA MEDIDA da pilula, nao de um numero fixo: a
     barra de avisos some, o menu quebra em duas linhas no celular, e o valor de
     reserva do CSS erra em alguns pixels. Medir e corrigir custa um reflow. */
  (function () {
    var topo = document.querySelector('.am-topo');
    if (!topo) return;

    /* a folga é a altura da pílula MAIS ar: encostar o conteúdo na borda de
       baixo dela deixa a página com cara de apertada, que foi a primeira
       versão. 28px é o mesmo respiro que a home já tinha por baixo do hero. */
    function mede() {
      var h = topo.offsetHeight;
      if (h > 0) document.documentElement.style.setProperty('--am-cab-folga', (h + 28) + 'px');
      /* a altura TOTAL (aviso + pilula) e o quanto o cabecalho precisa subir
         para sumir de vez; medida, porque a barra de ofertas pode nem existir */
      var cab = document.querySelector('[data-am-cabecalho]');
      if (cab) {
        var aviso = cab.querySelector('.am-aviso');
        var tot = (aviso ? aviso.offsetHeight : 0) + h;
        document.documentElement.style.setProperty('--am-aviso-alt', (aviso ? aviso.offsetHeight : 0) + 'px');
        if (tot > 0) document.documentElement.style.setProperty('--am-cab-alt', tot + 'px');
      }
    }
    mede();
    window.addEventListener('load', mede);
    window.addEventListener('resize', mede);
    if (window.ResizeObserver) new ResizeObserver(mede).observe(topo);
  })();

  (function () {
    var topo = document.querySelector('[data-am-topo]');
    if (!topo) return;

    // O Horizon rola dentro de .page-wrapper (html/body ficam overflow:hidden em >=990px).
    var raiz = (function () {
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 4) return pw;
      return window;
    })();
    /* Este trecho era:

           function posY() { return raiz === window ? posY() : raiz.scrollTop; }

       que chama a si mesma para sempre quando a raiz E a janela — e no celular
       ela SEMPRE e, porque abaixo de 990px o Horizon devolve a rolagem ao
       documento. Ninguem chamava, entao a pagina nunca estourou a pilha; mas
       era uma mina esperando o primeiro uso. Como nao ha chamador, sai. */

    var temMouse = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    var botoes = topo.querySelectorAll('[data-am-abre]');
    var megas = topo.querySelectorAll('[data-am-mega]');
    var aberto = null;
    var sair = null;

    function fechar() {
      megas.forEach(function (m) { m.hidden = true; });
      botoes.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      aberto = null;
    }

    function abrir(idx) {
      if (sair) { clearTimeout(sair); sair = null; }
      megas.forEach(function (m) { m.hidden = m.getAttribute('data-am-mega') !== idx; });
      botoes.forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-am-abre') === idx)); });
      aberto = idx;
    }

    botoes.forEach(function (b) {
      var idx = b.getAttribute('data-am-abre');
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (aberto === idx) { fechar(); } else { abrir(idx); }
      });
      /* So abre por aproximacao onde EXISTE aproximacao. No toque, o Chrome
         dispara `mouseenter` logo antes do `click`: o menu abria no mouseenter
         e o click seguinte via `aberto === idx` e fechava na mesma batida — ou
         seja, tocar num menu do cabecalho nao fazia nada. */
      if (temMouse) b.addEventListener('mouseenter', function () { abrir(idx); });
    });

    if (temMouse) {
      topo.addEventListener('mouseleave', function () {
        sair = setTimeout(fechar, 160);
      });
      topo.addEventListener('mouseenter', function () {
        if (sair) { clearTimeout(sair); sair = null; }
      });
    }

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechar(); });
    document.addEventListener('click', function (e) { if (!topo.contains(e.target)) fechar(); });

  })();

  (function () {
    var alvos = document.querySelectorAll('[data-am-rv]');
    if (!alvos.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      alvos.forEach(function (el) { el.classList.add('am-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('am-vis'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    alvos.forEach(function (el) { io.observe(el); });
  })();

  /* =====================================================================
     A GAVETA DO CELULAR — o painel da Bragg

     O que o dedo cobra e o mouse perdoa:

     1. A pagina de tras NAO pode rolar enquanto o painel esta aberto, nem
        pular. Sem travar, o gesto atravessa o fundo e a pagina anda atras.
     2. Fechar tem que ser facil de tres jeitos — o fundo escuro, o Esc e o
        proprio hamburguer, que vira X no lugar (a Bragg nao tem outro).
     3. Quem chegou pelo teclado nao pode cair para fora com Tab (o ciclo e
        hamburguer -> aba ativa -> links -> redes -> hamburguer), e volta ao
        hamburguer ao fechar.
     ===================================================================== */
  (function () {
    var gav = document.querySelector('[data-am-gav]');
    var abre = document.querySelector('[data-am-gav-abre]');
    if (!gav || !abre) return;

    var painel = gav.querySelector('.am-gav__painel');
    var cab = document.querySelector('[data-am-cabecalho]');
    var topo = document.querySelector('[data-am-topo]');
    var pilula = topo ? topo.querySelector('.am-pilula') : null;
    var grupo = document.getElementById('header-group');
    var abas = Array.prototype.slice.call(gav.querySelectorAll('[data-am-gav-aba]'));
    var paineis = gav.querySelectorAll('[data-am-gav-p]');

    var contaTempo = null;
    var yGuardado = 0;

    function aberta() { return !gav.hasAttribute('hidden') && gav.classList.contains('am-gav--on'); }

    function focaveis() {
      var dentro = Array.prototype.filter.call(
        painel.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'),
        function (el) {
          return el.getAttribute('tabindex') !== '-1' && !el.closest('[inert]') &&
                 el.getClientRects().length > 0;
        }
      );
      return [abre].concat(dentro);
    }

    /* Onde o painel comeca: 4px abaixo da pilula ja no lugar FINAL. Ao abrir,
       o cabecalho que tinha recolhido volta descendo (.3s); o retangulo lido
       agora ainda esta no meio do caminho, entao desconta o `transform` atual
       do topo. */
    function posiciona() {
      if (!pilula) return;
      var r = pilula.getBoundingClientRect();
      var t = topo ? getComputedStyle(topo).transform : 'none';
      var dy = 0;
      if (t && t !== 'none' && window.DOMMatrixReadOnly) {
        try { dy = new DOMMatrixReadOnly(t).m42; } catch (e) { dy = 0; }
      }
      gav.style.setProperty('--am-gav-topo', Math.round(r.bottom - dy + 4) + 'px');
    }

    /* Travar a rolagem: guardar onde a pagina estava e devolver na volta.
       `overflow:hidden` sozinho NAO basta (sem transbordo o navegador zera a
       rolagem e a pagina salta para o topo, visivel pelo fundo translucido):
       o corpo fica preso com `position:fixed` no deslocamento negativo.

       O cabecalho sai do fluxo junto (vira `fixed`, ver o CSS), e a pagina
       subiria a altura dele. Em vez de adivinhar essa altura, mede-se onde o
       conteudo principal APARECE antes e depois, e o `top` do corpo paga a
       diferenca. */
    function travar(liga) {
      var de = document.scrollingElement || document.documentElement;
      var ref = document.getElementById('MainContent') || document.querySelector('main');
      if (liga) {
        yGuardado = de.scrollTop;
        var antes = ref ? ref.getBoundingClientRect().top : 0;
        document.body.style.top = (-yGuardado) + 'px';
        document.documentElement.classList.add('am-gav-travado');
        document.body.classList.add('am-gav-travado');
        var depois = ref ? ref.getBoundingClientRect().top : antes;
        if (Math.abs(antes - depois) > 0.5) {
          document.body.style.top = (-yGuardado + (antes - depois)) + 'px';
        }
      } else {
        document.documentElement.classList.remove('am-gav-travado');
        document.body.classList.remove('am-gav-travado');
        document.body.style.top = '';
        de.scrollTop = yGuardado;
      }
    }

    function tecla(e) {
      if (e.key === 'Escape') { e.preventDefault(); fechar(); return; }
      if (e.key !== 'Tab') return;
      /* o ciclo e todo manual: o hamburguer mora na pilula, e o Tab natural
         dele iria para a busca e a sacola, que ficam fora do painel */
      var lista = focaveis();
      if (!lista.length) return;
      e.preventDefault();
      var i = lista.indexOf(document.activeElement);
      var n = i === -1 ? (e.shiftKey ? lista.length - 1 : 0)
                       : (i + (e.shiftKey ? -1 : 1) + lista.length) % lista.length;
      lista[n].focus();
    }

    /* ---- abas (padrao WAI-ARIA: setas trocam e ativam, Home/End nas pontas) ---- */
    function ativar(idx, foca) {
      abas.forEach(function (b) {
        var on = b.getAttribute('data-am-gav-aba') === idx;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
        if (on && foca) b.focus({ preventScroll: true });
      });
      paineis.forEach(function (p) {
        var on = p.getAttribute('data-am-gav-p') === idx;
        p.classList.toggle('am-gav__p--on', on);
        if (on) p.removeAttribute('inert'); else p.setAttribute('inert', '');
      });
      /* a aba nova comeca do topo: descer na Loja e trocar para Aprender nao
         pode abrir Aprender no meio */
      painel.scrollTop = 0;
    }

    abas.forEach(function (b, n) {
      b.addEventListener('click', function () { ativar(b.getAttribute('data-am-gav-aba'), false); });
      b.addEventListener('keydown', function (e) {
        var alvo = null;
        if (e.key === 'ArrowRight') alvo = abas[(n + 1) % abas.length];
        else if (e.key === 'ArrowLeft') alvo = abas[(n - 1 + abas.length) % abas.length];
        else if (e.key === 'Home') alvo = abas[0];
        else if (e.key === 'End') alvo = abas[abas.length - 1];
        if (!alvo) return;
        e.preventDefault();
        ativar(alvo.getAttribute('data-am-gav-aba'), true);
      });
    });

    function abrir() {
      if (contaTempo) { clearTimeout(contaTempo); contaTempo = null; }
      /* o cabecalho volta inteiro (faixa + pilula) enquanto o painel existe */
      if (cab) { cab.classList.remove('am-cab-fora'); cab.classList.add('am-gav-aberto'); }
      travar(true);
      gav.removeAttribute('hidden');
      posiciona();
      /* o quadro tem que acontecer com o painel AINDA transparente; sem este
         reflow o navegador junta o `hidden` e a classe na mesma pintura e o
         painel aparece pronto, sem fade */
      void gav.offsetWidth;
      gav.classList.add('am-gav--on');
      abre.setAttribute('aria-expanded', 'true');
      abre.setAttribute('aria-label', 'Fechar menu');
      var ativa = gav.querySelector('[data-am-gav-aba][aria-selected="true"]') || focaveis()[1];
      if (ativa) ativa.focus({ preventScroll: true });
      document.addEventListener('keydown', tecla, true);
      window.addEventListener('resize', posiciona);
    }

    function fechar(semFoco) {
      if (gav.hasAttribute('hidden') || !gav.classList.contains('am-gav--on')) return;
      gav.classList.remove('am-gav--on');
      if (cab) cab.classList.remove('am-gav-aberto');
      abre.setAttribute('aria-expanded', 'false');
      abre.setAttribute('aria-label', 'Abrir menu');
      travar(false);
      document.removeEventListener('keydown', tecla, true);
      window.removeEventListener('resize', posiciona);
      if (!semFoco) abre.focus({ preventScroll: true });
      /* esperar o fade terminar antes de esconder — tempo fixo, nao
         `transitionend`, porque com "reduzir movimento" nao ha transicao e o
         evento nunca chegaria */
      contaTempo = setTimeout(function () {
        gav.setAttribute('hidden', '');
        contaTempo = null;
      }, 420);
    }

    abre.addEventListener('click', function () {
      if (aberta()) fechar(); else abrir();
    });

    gav.querySelectorAll('[data-am-gav-fecha]').forEach(function (el) {
      el.addEventListener('click', function () { fechar(); });
    });

    /* tocou num link: fecha sem devolver o foco ao hamburguer, senao a proxima
       pagina abre com o foco num botao que ja nao e o assunto */
    gav.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', function () { fechar(true); });
    });

    /* busca, conta e sacola continuam tocaveis na pilula: usar uma delas fecha
       o painel, senao a busca abriria por baixo dele */
    if (pilula) {
      pilula.querySelectorAll('a[href],button').forEach(function (el) {
        if (el === abre) return;
        el.addEventListener('click', function () { if (aberta()) fechar(true); });
      });
    }

    /* girou o aparelho e passou de 1320: o hamburguer nao existe mais naquela
       largura, e o painel ficaria travando a rolagem de uma pagina sem ele */
    var largo = window.matchMedia('(min-width:1321px)');
    var ouvir = function (e) { if (e.matches) fechar(true); };
    if (largo.addEventListener) largo.addEventListener('change', ouvir);
    else if (largo.addListener) largo.addListener(ouvir);
  })();

  /* =====================================================================
     O cabecalho recolhe ao descer e volta ao subir (so no celular).

     Por que por DIRECAO e nao por altura: esconder depois de X pixels e voltar
     so no topo obriga a pessoa a rolar a pagina inteira de volta para achar o
     carrinho. A direcao do gesto e a intencao: descendo, ela le; subindo, ela
     procura.
     ===================================================================== */
  (function () {
    var cab = document.querySelector('[data-am-cabecalho]');
    if (!cab) return;

    var celular = window.matchMedia('(max-width:1320px)');
    /* ler .matches a cada quadro forca o Chrome a atualizar estilo/layout
       (a consulta depende da largura util, que depende da barra de rolagem);
       o valor so muda no 'change', entao fica guardado */
    var ehCelular = celular.matches;

    /* Abaixo de 990px a rolagem e do documento; acima, de `.page-wrapper`.
       A conta e refeita a cada gesto porque a raiz muda ao girar o aparelho. */
    function raiz() {
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 4) return pw;
      return document.scrollingElement || document.documentElement;
    }

    var ultimo = 0, parado = true;

    function mostrar() { cab.classList.remove('am-cab-fora'); }

    function passo() {
      parado = true;
      if (!ehCelular) { mostrar(); return; }

      /* com a gaveta ou a busca abertas o cabecalho fica: sumir com o botao de
         fechar debaixo do dedo da pessoa e o pior momento possivel */
      var gav = document.querySelector('[data-am-gav]');
      if (gav && !gav.hasAttribute('hidden')) { mostrar(); return; }
      /* DESEMPENHO: a classe vem antes do getComputedStyle (que força estilo
         a cada quadro), e a raiz sai do próprio evento — raiz() lia
         scrollHeight, que força layout, em todo quadro de rolagem. */
      var bu = document.querySelector('.am-bu.am-vis, .am-bu:not([hidden])');
      if (bu && bu.classList.contains('am-vis') &&
          getComputedStyle(bu).display !== 'none') { mostrar(); return; }

      /* a posição foi lida no próprio evento de rolagem, quando o layout
         ainda está limpo; ler scrollTop aqui, depois das seções escreverem
         estilo no mesmo quadro, forçava o layout inteiro da página */
      var y = yEvento !== null ? yEvento : raiz().scrollTop;
      var d = y - ultimo;
      ultimo = y;

      /* os primeiros 140px sao a area da capa: ali o cabecalho sempre aparece */
      if (y < 140) { mostrar(); return; }
      /* folga de 6px para o tremor do dedo nao ficar piscando o cabecalho */
      if (d > 6) cab.classList.add('am-cab-fora');
      else if (d < -6) mostrar();
    }

    var yEvento = null;
    function aoRolar(e) {
      /* quem disparou o evento E a raiz que rola: a janela (celular) ou a
         .page-wrapper (computador) */
      var rolador = (e && e.currentTarget && e.currentTarget !== window)
        ? e.currentTarget : (document.scrollingElement || document.documentElement);
      yEvento = rolador.scrollTop;
      if (!parado) return;
      parado = false;
      requestAnimationFrame(passo);
    }

    window.addEventListener('scroll', aoRolar, { passive: true });
    var pw = document.querySelector('.page-wrapper');
    if (pw) pw.addEventListener('scroll', aoRolar, { passive: true });

    var ouvir = function (e) { ehCelular = e ? e.matches : celular.matches; if (!ehCelular) mostrar(); };
    if (celular.addEventListener) celular.addEventListener('change', ouvir);
    else if (celular.addListener) celular.addListener(ouvir);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-heranca"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sec = document.querySelector('[data-am-heranca]');
    if (!sec) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.innerWidth < 861) return;
    // O Horizon rola dentro de .page-wrapper (html/body ficam overflow:hidden em >=990px).
    var raiz = (function () {
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 4) return pw;
      return window;
    })();
    /* Aqui morava:
           function posY() { return raiz === window ? posY() : raiz.scrollTop; }
       que chama a si mesma para sempre quando a raiz E a janela — e no celular
       ela sempre e. Ninguem chamava, entao nunca estourou; mas era a segunda
       copia da mesma mina (a outra estava no cabecalho). Sem chamador, sai. */

    var fotos = [].slice.call(sec.querySelectorAll('[data-am-par]'));

    /* DESEMPENHO: antes isto rodava a cada evento de rolagem da PÁGINA INTEIRA
       e fazia getComputedStyle em cada foto — escrita de transform numa foto,
       leitura de estilo na seguinte, recálculo forçado a cada quadro (580 ms
       de script num trecho de rolagem com a CPU a 1/4). Agora: as variáveis
       --dx/--dy/--rot são lidas UMA vez (e de novo no resize), o desenho sai
       no máximo uma vez por quadro, só enquanto a seção está perto da tela, e
       não escreve nada se a abertura do leque não mudou. */
    var medidas = [];
    function mede() {
      medidas = fotos.map(function (f) {
        var st = getComputedStyle(f);
        return {
          v: parseFloat(f.getAttribute('data-am-par')) || 1,
          dx: parseFloat(st.getPropertyValue('--dx')) || 0,
          dy: parseFloat(st.getPropertyValue('--dy')) || 0,
          rot: st.getPropertyValue('--rot')
        };
      });
    }

    var ultimoQ = -1;
    function desenha() {
      quadro = null;
      var r = sec.getBoundingClientRect();
      var alcance = window.innerHeight + r.height;
      var p = (window.innerHeight - r.top) / alcance;
      p = Math.max(0, Math.min(1, p));
      var q = Math.max(0, Math.min(1, (p - 0.12) / 0.68));   // abertura do leque
      if (q === ultimoQ) return;
      ultimoQ = q;

      for (var i = 0; i < fotos.length; i++) {
        var m = medidas[i];
        fotos[i].style.transform =
          'translate(' + (m.dx * q * m.v).toFixed(2) + 'vw,' + (m.dy * q * m.v).toFixed(2) + 'vh) ' +
          'rotate(calc(' + m.rot + ' * ' + (1 + q * 1.4).toFixed(2) + '))';
      }
    }

    var quadro = null, perto = true;
    function agenda() { if (perto && !quadro) quadro = requestAnimationFrame(desenha); }

    mede();
    desenha();
    document.addEventListener('scroll', agenda, { passive: true, capture: true });
    window.addEventListener('resize', function () { mede(); ultimoQ = -1; agenda(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        perto = ents[0].isIntersecting;
        /* saiu da tela: um último desenho assenta o leque no extremo certo */
        if (!quadro) quadro = requestAnimationFrame(desenha);
      }, { rootMargin: '25% 0px' }).observe(sec);
    }
  })();
  /* ---------------------------------------------------------------
     CELULAR (<=749px): a coreografia da "slide-show" da Bragg, com a
     rolagem (scrub). Cada peca anda pela PROPRIA posicao na tela, nao pela
     da secao: em tela baixa o paragrafo so acende quando chega nele.
     rAF + IntersectionObserver + nao escreve se nada mudou (armadilha 74);
     medidas fora do quadro. A posicao sai do getBoundingClientRect de cada
     quadro, entao quem abre a pagina ja rolada ve tudo montado.
     --------------------------------------------------------------- */
  (function () {
    var sec = document.querySelector('[data-am-heranca]');
    if (!sec) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var mq = window.matchMedia('(max-width: 749px)');

    var tit = sec.querySelector('.am-heranca__tit');
    var palco = sec.querySelector('.am-fotos');
    var f1 = sec.querySelector('.am-foto--1');
    var f2 = sec.querySelector('.am-foto--2');
    var f3 = sec.querySelector('.am-foto--3');
    var par = sec.querySelector('.am-heranca__txt p');
    var btn = sec.querySelector('.am-heranca__txt .am-btn');
    var pal = null, M = null, ativo = false, ultimo = null, quadro = null, perto = true;

    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
    function faixa(p, a, b) { return clamp((p - a) / (b - a), 0, 1); }
    function suave(t) { return t * t * (3 - 2 * t); }

    function escreve(el, prop, v) {
      if (!el) return;
      var c = el.__amHs || (el.__amHs = {});
      if (c[prop] === v) return;
      c[prop] = v;
      if (prop.charAt(0) === '-') el.style.setProperty(prop, v);
      else el.style[prop] = v;
    }

    /* palavra = mascara (de fora) + o que sobe (de dentro); o espaco fica
       fora dos dois, senao some no fim do inline-block */
    function parte(el) {
      var texto = el.textContent.trim();
      el.textContent = '';
      texto.split(/\s+/).forEach(function (w, k) {
        if (k) el.appendChild(document.createTextNode(' '));
        var s = document.createElement('span');
        s.className = 'am-hs-p';
        var d = document.createElement('span');
        d.className = 'am-hs-pi';
        d.textContent = w;
        s.appendChild(d);
        el.appendChild(s);
      });
      return Array.prototype.slice.call(el.querySelectorAll('.am-hs-pi'));
    }

    function palavrasEm(lista, t) {
      var n = lista.length;
      if (!n) return;
      var d = n > 1 ? Math.min(0.1, 0.6 / (n - 1)) : 0;
      var dur = 1 - d * (n - 1);
      for (var k = 0; k < n; k++) {
        var v = suave(clamp((t - k * d) / dur, 0, 1));
        escreve(lista[k], 'transform', v >= 1 ? 'none' : 'translate3d(0,' + ((1 - v) * 105).toFixed(1) + '%,0)');
      }
    }

    /* distancia do topo da secao, pelo layout (transform nao conta) */
    function topoEm(el) {
      var y = 0;
      while (el && el !== sec) { y += el.offsetTop; el = el.offsetParent; }
      return y;
    }
    function mede() {
      M = {
        vh: window.innerHeight,
        tit: topoEm(tit), palco: topoEm(palco),
        par: par ? topoEm(par) : 0, btn: btn ? topoEm(btn) : 0
      };
    }

    function limpa() {
      [f1, f2, f3, par, btn].concat(pal || []).forEach(function (el) {
        if (!el) return;
        el.removeAttribute('style');
        el.__amHs = null;
      });
      ativo = false;
      ultimo = null;
    }

    /* sobe 24px e acende ao cruzar de 94% a 74% da tela (o fade-in da Bragg) */
    function sobe(el, y, top, vh) {
      if (!el) return;
      var t = suave(faixa(vh * 0.94 - (top + y), 0, vh * 0.2));
      escreve(el, 'opacity', t.toFixed(3));
      escreve(el, 'transform', t >= 1 ? 'none' : 'translate3d(0,' + (24 * (1 - t)).toFixed(1) + 'px,0)');
    }

    function desenha() {
      quadro = null;
      if (!mq.matches) { if (ativo) limpa(); return; }
      if (!ativo) { ativo = true; if (!pal) pal = parte(tit); mede(); }
      var top = sec.getBoundingClientRect().top;
      var q = Math.round(top * 2) / 2;
      if (q === ultimo) return;
      ultimo = q;
      var vh = M.vh;

      // 1. titulo: palavra a palavra enquanto cruza de 92% a 52% da tela
      palavrasEm(pal, faixa(vh * 0.92 - (top + M.tit), 0, vh * 0.4));

      // 2. fotos: 0 com o palco na borda de baixo, 1 com ele a 20% do topo
      var tp = clamp((vh - (top + M.palco)) / (vh * 0.8), 0, 1);
      escreve(f1, 'transform', 'rotate(' + (-2 * suave(faixa(tp, 0.12, 1))).toFixed(3) + 'deg)');
      var e = suave(faixa(tp, 0.18, 0.78));
      var fora = 1 - e;
      escreve(f2, 'transform', e >= 1 ? 'rotate(8deg)'
        : 'translate3d(' + (-72 * fora).toFixed(1) + '%,' + (22 * fora).toFixed(1) + '%,0) rotate(' + (8 * e).toFixed(2) + 'deg)');
      escreve(f3, 'transform', e >= 1 ? 'rotate(-8deg)'
        : 'translate3d(' + (72 * fora).toFixed(1) + '%,' + (22 * fora).toFixed(1) + '%,0) rotate(' + (-8 * e).toFixed(2) + 'deg)');
      var sep = (1 - suave(faixa(tp, 0.42, 1))).toFixed(3);
      escreve(f2, '--hs-sep', sep);
      escreve(f3, '--hs-sep', sep);

      // 3. paragrafo e botao
      sobe(par, M.par, top, vh);
      sobe(btn, M.btn, top, vh);
    }

    function agenda() { if (perto && !quadro) quadro = requestAnimationFrame(desenha); }

    desenha();
    window.addEventListener('scroll', agenda, { passive: true });
    var pw = document.querySelector('.page-wrapper');
    if (pw) pw.addEventListener('scroll', agenda, { passive: true });
    window.addEventListener('resize', function () {
      if (ativo && mq.matches) mede();
      ultimo = null;
      if (!quadro) quadro = requestAnimationFrame(desenha);
    });
    function remede() { if (ativo && mq.matches) { mede(); ultimo = null; agenda(); } }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remede);
    window.addEventListener('load', remede);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        perto = ents[0].isIntersecting;
        if (!quadro) quadro = requestAnimationFrame(desenha);
      }, { rootMargin: '25% 0px' }).observe(sec);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-hero"] && !Shopify.designMode) return;
  try {
    
  /* Capa da home.
     Um controlador so, com dois modos pela largura:
     - COMPUTADOR (>=750): exatamente o comportamento de antes — troca por
       opacidade a cada 6,5s, texto do titulo/cartao global trocado aqui.
     - CELULAR (<=749): fila horizontal no molde da Bragg — 7s por slide,
       deslize de 700ms (CSS), arrastar com o dedo, pausa fora da tela, com a
       aba oculta, com o foco do teclado dentro, e sem autoplay para quem pediu
       movimento reduzido. A entrada (palavras + cartao) e CSS; aqui so se
       religa a classe `am-hr-anima` a cada troca. */
  /* libera as fotos 2-4 (ver o CSS de `.am-hr-adia`): quando a foto 1 já
     chegou, no primeiro toque/foco na capa, ou quando o carrossel for
     mostrar um slide ainda travado — o que vier primeiro. */
  (function () {
    var hero = document.querySelector('[data-am-hero]');
    if (!hero || !hero.querySelector('.am-hr-adia')) return;
    var feito = false;
    function libera() { if (feito) return; feito = true; hero.classList.add('am-hr-fotos'); }
    var img1 = hero.querySelector('[data-am-slide] .am-slide__img');
    if (!img1 || (img1.complete && img1.naturalWidth)) { libera(); return; }
    img1.addEventListener('load', libera, { once: true });
    img1.addEventListener('error', libera, { once: true });
    ['pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
      hero.addEventListener(ev, libera, { once: true, passive: true });
    });
    /* sem prazo fixo: em rede ruim a foto 1 leva 9 s, e um prazo soltava as
       outras três no meio dela. Se o carrossel for trocar antes, solta na
       hora em que um slide travado ganha `am-on`. */
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        if (hero.querySelector('.am-hr-adia.am-on')) { libera(); mo.disconnect(); }
      });
      mo.observe(hero, { subtree: true, attributes: true, attributeFilter: ['class'] });
    } else {
      setTimeout(libera, 6000);
    }
  })();

  (function () {
    var hero = document.querySelector('[data-am-hero]');
    if (!hero) return;
    var dados = [];
    try { dados = JSON.parse(hero.querySelector('[data-am-hero-dados]').textContent); } catch (e) { return; }
    if (dados.length < 2) return;

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-am-slide]'));
    var pontos = Array.prototype.slice.call(hero.querySelectorAll('[data-am-pontos] button'));
    var h1 = hero.querySelector('[data-am-h1]');
    var ct = hero.querySelector('[data-am-ct]');
    var cp = hero.querySelector('[data-am-cp]');
    var cb = hero.querySelector('[data-am-cb]');
    var n = slides.length;
    var i = 0, timer = null;
    /* no computador o movimento reduzido e lido uma vez, como sempre foi */
    var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mqCel = window.matchMedia('(max-width: 749px)');
    var mqReduz = window.matchMedia('(prefers-reduced-motion: reduce)');
    var cel = mqCel.matches;

    /* ------------------------------------------------ comum aos dois modos */
    function marca(k) {
      slides.forEach(function (s, j) { s.classList.toggle('am-on', j === k); });
      pontos.forEach(function (p, j) {
        p.classList.toggle('am-on', j === k);
        if (j === k) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current');
      });
      var d = dados[k];
      if (d && h1 && ct && cp && cb) {
        h1.textContent = d.h1;
        ct.textContent = d.ct;
        cp.textContent = d.cp;
        cb.textContent = d.cb;
        if (d.url) cb.setAttribute('href', d.url);
      }
    }

    /* ------------------------------------------------------- computador */
    function vaiComp(k) { i = (k + n) % n; marca(i); }
    function reiniciaComp() {
      if (timer) clearInterval(timer);
      timer = null;
      if (!reduz) timer = setInterval(function () { vaiComp(i + 1); }, 6500);
    }

    /* ---------------------------------------------------------- celular */
    var visivel = true, focoDentro = false, arrastando = false;
    var espera = null, limpa = null;

    /* grava a posicao (em larguras de tela) de cada slide. `salto` = sem
       animar: o slide esta fora da tela e so troca de lado. */
    function aplica(pares, salto) {
      if (salto) pares.forEach(function (p) { p[0].classList.add('am-hr-salto'); });
      pares.forEach(function (p) { p[0].style.setProperty('--am-hr-o', p[1]); p[0]._amHrO = p[1]; });
      if (salto) {
        void hero.offsetWidth;
        pares.forEach(function (p) { p[0].classList.remove('am-hr-salto'); });
      }
    }
    /* o atual no meio, o proximo a direita, o anterior a esquerda (para o
       arrasto achar vizinho dos dois lados) e o resto esperando fora */
    function arruma(k, salto) {
      aplica(slides.map(function (s, j) {
        var o = ((j - k) % n + n) % n;
        if (o > 1) o = (o === n - 1) ? -1 : 2;
        return [s, o];
      }), salto);
    }
    function inerte() {
      slides.forEach(function (s, j) {
        if (cel && j !== i) s.setAttribute('inert', ''); else s.removeAttribute('inert');
      });
    }
    /* religa a entrada: tirar a classe, forcar o calculo e devolver faz o
       navegador recomecar as animacoes do zero */
    function anima(s, atraso) {
      s.style.setProperty('--am-hr-a', atraso);
      s.classList.remove('am-hr-anima');
      void s.offsetWidth;
      s.classList.add('am-hr-anima');
    }
    function soltaDedo() {
      hero.classList.remove('am-hr-arrasta');
      hero.style.setProperty('--am-hr-dx', '0px');
    }

    function vaiCel(k, dir) {
      k = (k + n) % n;
      var ant = i;
      clearTimeout(limpa);
      if (k === ant) {           /* arrasto curto: volta para o lugar */
        soltaDedo();
        agenda();
        return;
      }
      if (!dir) {                /* bolinha: pelo caminho mais curto */
        var o = ((k - ant) % n + n) % n;
        dir = (o <= n / 2) ? 1 : -1;
      }
      /* 1) quem entra vai, sem animar, para o lado de onde vai surgir */
      if (slides[k]._amHrO !== dir) aplica([[slides[k], dir]], true);
      /* 2) desliza: o atual sai para o outro lado e o novo ocupa o meio */
      soltaDedo();
      aplica([[slides[ant], -dir], [slides[k], 0]], false);
      i = k;
      marca(i);
      inerte();
      anima(slides[i], '.25s');
      slides.forEach(function (s, j) { if (j !== i && j !== ant) s.classList.remove('am-hr-anima'); });
      /* o que saiu guarda o texto ate sumir; depois tudo volta a posicao de
         espera (fora da tela, sem animar) */
      limpa = setTimeout(function () {
        if (ant !== i) slides[ant].classList.remove('am-hr-anima');
        arruma(i, true);
      }, 720);
      agenda();
    }

    function podeRodar() {
      return cel && !mqReduz.matches && visivel && !document.hidden && !focoDentro && !arrastando;
    }
    function agenda() {
      clearTimeout(espera);
      espera = null;
      if (podeRodar()) espera = setTimeout(function () { vaiCel(i + 1, 1); }, 7000);
    }

    /* arrastar: so decide que e arrasto depois de 8px, e so se o dedo andou
       mais na horizontal que na vertical — senao a pessoa esta rolando a
       pagina e o navegador cuida (touch-action:pan-y no CSS) */
    var x0 = 0, y0 = 0, t0 = 0, dx = 0, gesto = null, idp = null, fimArrasto = 0;
    hero.addEventListener('pointerdown', function (e) {
      if (!cel) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest && e.target.closest('[data-am-pontos],[data-am-hr-ir]')) return;
      x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); dx = 0;
      gesto = 'talvez'; idp = e.pointerId;
    });
    hero.addEventListener('pointermove', function (e) {
      if (!gesto || gesto === 'y' || e.pointerId !== idp) return;
      var ddx = e.clientX - x0, ddy = e.clientY - y0;
      if (gesto === 'talvez') {
        if (Math.abs(ddx) < 8 && Math.abs(ddy) < 8) return;
        if (Math.abs(ddy) >= Math.abs(ddx)) { gesto = 'y'; return; }
        gesto = 'x'; arrastando = true;
        clearTimeout(limpa);
        arruma(i, true);
        hero.classList.add('am-hr-arrasta');
        try { hero.setPointerCapture(e.pointerId); } catch (_) {}
        agenda();
      }
      dx = ddx;
      /* com dois slides o unico vizinho troca de lado conforme o dedo */
      if (n === 2) {
        var outro = slides[(i + 1) % 2], lado = dx > 0 ? -1 : 1;
        if (outro._amHrO !== lado) aplica([[outro, lado]], true);
      }
      hero.style.setProperty('--am-hr-dx', dx + 'px');
      if (e.cancelable) e.preventDefault();
    });
    function solta(e) {
      if (!gesto || e.pointerId !== idp) return;
      var era = gesto;
      gesto = null;
      if (era !== 'x') return;
      arrastando = false;
      fimArrasto = Date.now();
      var larg = hero.clientWidth || 1;
      var vel = Math.abs(dx) / Math.max(1, Date.now() - t0);
      if (Math.abs(dx) > larg * 0.2 || (vel > 0.4 && Math.abs(dx) > 24)) {
        vaiCel(i + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      } else {
        vaiCel(i);
      }
    }
    hero.addEventListener('pointerup', solta);
    hero.addEventListener('pointercancel', solta);
    /* o clique que chega logo depois de um arrasto nao e clique no cartao.
       Janela de tempo, e nao uma marca de "arrastou": a marca so se apagava
       no proximo toque, e o toque numa bolinha depois de um arrasto era
       engolido (pego na prova: a bolinha 3 nao respondia). */
    hero.addEventListener('click', function (e) {
      if (Date.now() - fimArrasto < 350) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    hero.addEventListener('dragstart', function (e) { if (cel) e.preventDefault(); });

    pontos.forEach(function (p, k) {
      p.addEventListener('click', function () {
        if (cel) vaiCel(k);
        else { vaiComp(k); reiniciaComp(); }
      });
    });

    /* setas: um para cada lado, no celular deslizando na direção da seta */
    hero.querySelectorAll('[data-am-hr-ir]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = Number(b.getAttribute('data-am-hr-ir'));
        if (cel) vaiCel(i + d, d);
        else { vaiComp(i + d); reiniciaComp(); }
      });
    });

    /* pausas do autoplay no celular */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visivel = es[es.length - 1].isIntersecting;
        agenda();
      }).observe(hero);
    }
    document.addEventListener('visibilitychange', function () { if (cel) agenda(); });
    /* so o foco do TECLADO pausa: tocar numa bolinha tambem da foco ao
       botao, e ai o autoplay pararia para sempre */
    hero.addEventListener('focusin', function (e) {
      var tec = false;
      try { tec = e.target.matches(':focus-visible'); } catch (_) {}
      if (tec) { focoDentro = true; if (cel) agenda(); }
    });
    hero.addEventListener('focusout', function (e) {
      if (!hero.contains(e.relatedTarget)) { focoDentro = false; if (cel) agenda(); }
    });
    if (mqReduz.addEventListener) mqReduz.addEventListener('change', function () { if (cel) agenda(); });

    /* editor de tema: selecionar um slide no painel mostra o slide */
    document.addEventListener('shopify:block:select', function (e) {
      var j = slides.indexOf(e.target);
      if (j < 0) return;
      if (cel) vaiCel(j); else { vaiComp(j); reiniciaComp(); }
    });

    /* troca de modo quando a largura atravessa 749/750 (girar o tablet,
       redimensionar a janela) */
    function monta() {
      cel = mqCel.matches;
      if (timer) clearInterval(timer);
      timer = null;
      clearTimeout(espera);
      clearTimeout(limpa);
      gesto = null; arrastando = false;
      soltaDedo();
      if (cel) {
        arruma(i, true);
        agenda();
      } else {
        hero.style.removeProperty('--am-hr-dx');
        slides.forEach(function (s) { s.style.removeProperty('--am-hr-o'); s._amHrO = null; });
        reiniciaComp();
      }
      inerte();
    }
    monta();
    if (mqCel.addEventListener) mqCel.addEventListener('change', monta);
    else if (mqCel.addListener) mqCel.addListener(monta);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-hist-capa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* A curva liga o PE do titulo ao ALTO do paragrafo. Os dois se mexem: o
       titulo quebra em mais linhas conforme o texto e a largura, e o paragrafo
       fica colado no rodape da caixa. Entao a linha se mede a cada vez, em pixel
       de verdade — viewBox igual a caixa, sem `preserveAspectRatio`, senao o
       traco engorda de um lado e afina do outro. */
    document.querySelectorAll('.am-hc').forEach(function (sec) {
      var svg = sec.querySelector('[data-am-hc-curva]');
      if (!svg) return;
      var linha = svg.querySelector('path');
      var tit = sec.querySelector('.am-hc__tit');
      var txt = sec.querySelector('.am-hc__txt');

      /* O CSS esconde a curva no celular. Nao da para perguntar isso ao
         `display` do proprio SVG: ele nasce `hidden`, entao o `display` ja e
         `none` e a conta nunca comecaria. Pergunta-se a consulta de midia. */
      var estreito = window.matchMedia('(max-width:820px)');

      /* `svg.hidden = x` NAO funciona: `hidden` e propriedade de HTMLElement, e
         SVGElement nao herda dela — a atribuicao vira um campo solto no objeto,
         o atributo continua no DOM e o `display:none` junto. No SVG tem que ser
         atributo de verdade. */
      function mostra(sim) {
        if (sim) svg.removeAttribute('hidden');
        else svg.setAttribute('hidden', '');
      }

      function desenha() {
        if (!tit || !txt) return;
        if (estreito.matches) { mostra(false); return; }
        var r = sec.getBoundingClientRect();
        var t = tit.getBoundingClientRect();
        var p = txt.getBoundingClientRect();
        if (!r.width || !r.height) return;

        var x0 = t.right - r.left - t.width * 0.14;  // sai do fim da manchete
        var y0 = t.bottom - r.top + 18;              // ABAIXO dela, nunca dentro
        var x1 = p.left - r.left;                    // na margem do paragrafo
        var y1 = p.top - r.top - 16;                 // ACIMA da primeira linha
        var alt = y1 - y0;

        /* pouco espaco entre os dois: melhor nao ter linha do que ter risco */
        if (alt < 46 || x0 - x1 < 90) { mostra(false); return; }
        mostra(true);

        var rabo = Math.min(190, (x0 - x1) * 0.52);
        var xm = x1 + rabo;
        svg.setAttribute('viewBox', '0 0 ' + r.width.toFixed(1) + ' ' + r.height.toFixed(1));
        linha.setAttribute('d',
          'M' + x0.toFixed(1) + ',' + y0.toFixed(1) +
          ' C' + x0.toFixed(1) + ',' + (y0 + alt * 0.52).toFixed(1) +
          ' ' + (x0 - 10).toFixed(1) + ',' + (y1 - alt * 0.10).toFixed(1) +
          ' ' + xm.toFixed(1) + ',' + y1.toFixed(1) +
          ' L' + x1.toFixed(1) + ',' + y1.toFixed(1));
      }

      desenha();
      /* a manchete muda de altura quando a Season Mix entra no lugar da reserva */
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(desenha);
      window.addEventListener('load', desenha);
      var preso = false;
      window.addEventListener('resize', function () {
        if (preso) return;
        preso = true;
        requestAnimationFrame(function () { preso = false; desenha(); });
      });
      if (window.ResizeObserver) new ResizeObserver(desenha).observe(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-leituras"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-lei]');
    if (!raiz) return;
    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* título escrito à mão, o mesmo alfabeto das receitas */
    var tit = raiz.querySelector('[data-am-lei-escrever]');
    if (tit) {
      var tenta = 0;
      (function espera() {
        if (window.AmanaCaligrafia) {
          var alvo = document.createElement('span');
          alvo.className = 'am-lei__calig';
          tit.appendChild(alvo);
          tit.classList.add('am-lei__escrito');
          var texto = tit.getAttribute('data-am-lei-escrever');
          var m = window.AmanaCaligrafia.caber(texto, (tit.clientWidth || 700) - 4, { max: 78, min: 28, maxLinhas: 2 });
          window.AmanaCaligrafia.animar(alvo, texto, {
            tamanho: m.tamanho, larguraMax: m.larguraMax, tremor: 0.85, espessura: 4.6, instantaneo: reduz
          });
          return;
        }
        if (++tenta < 130) setTimeout(espera, 60);
      })();
    }

    /* entrada por rolagem: o Horizon não rola o window, então IntersectionObserver */
    if (!('IntersectionObserver' in window) || reduz) return;
    raiz.classList.add('am-lei-js');
    var ob = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.bottom > 0) return;
        e.target.classList.add('am-lei-vis');
        ob.unobserve(e.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
    raiz.querySelectorAll('[data-am-lei-rv]').forEach(function (el) { ob.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-linha-tempo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-lt]');
    if (!raiz) return;
    var trilho = raiz.querySelector('[data-am-lt-trilho]');
    var eras = Array.prototype.slice.call(raiz.querySelectorAll('[data-am-lt-era]'));
    var chips = Array.prototype.slice.call(raiz.querySelectorAll('[data-am-lt-chip]'));
    var setas = Array.prototype.slice.call(raiz.querySelectorAll('[data-am-lt-ir]'));
    if (!trilho || !eras.length) return;

    var atual = 0;

    function marca(i) {
      atual = Math.max(0, Math.min(eras.length - 1, i));
      chips.forEach(function (c, k) {
        c.classList.toggle('am-on', k === atual);
        c.setAttribute('aria-selected', k === atual ? 'true' : 'false');
      });
      setas.forEach(function (s) {
        var d = Number(s.getAttribute('data-am-lt-ir'));
        s.disabled = (d < 0 && atual === 0) || (d > 0 && atual === eras.length - 1);
      });
      /* o chip escolhido entra no campo de visão da própria régua de chips */
      var c = chips[atual];
      if (c && c.parentNode.scrollWidth > c.parentNode.clientWidth) {
        var pai = c.parentNode;
        var alvo = c.offsetLeft - pai.clientWidth / 2 + c.offsetWidth / 2;
        pai.scrollTo({ left: alvo, behavior: 'smooth' });
      }
    }

    function vai(i) {
      var alvo = eras[Math.max(0, Math.min(eras.length - 1, i))];
      if (!alvo) return;
      trilho.scrollTo({ left: alvo.offsetLeft - trilho.offsetLeft, behavior: 'smooth' });
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var i = Number(c.getAttribute('data-am-lt-chip'));
        marca(i); vai(i);
      });
    });
    setas.forEach(function (s) {
      s.addEventListener('click', function () {
        var i = atual + Number(s.getAttribute('data-am-lt-ir'));
        marca(i); vai(i);
      });
    });

    /* arrastar o trilho também troca de época: descobre qual está mais centrada */
    var pendente = false;
    trilho.addEventListener('scroll', function () {
      if (pendente) return;
      pendente = true;
      requestAnimationFrame(function () {
        pendente = false;
        var centro = trilho.scrollLeft + trilho.clientWidth / 2;
        var perto = 0, menor = Infinity;
        eras.forEach(function (e, k) {
          var d = Math.abs((e.offsetLeft - trilho.offsetLeft) + e.offsetWidth / 2 - centro);
          if (d < menor) { menor = d; perto = k; }
        });
        if (perto !== atual) marca(perto);
      });
    }, { passive: true });

    /* revelação: a colagem só monta quando a época entra na tela */
    var alvos = [].concat(eras, Array.prototype.slice.call(raiz.querySelectorAll('[data-am-rv]')));
    if ('IntersectionObserver' in window) {
      var ob = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('am-vis');
          ob.unobserve(en.target);
        });
      }, { threshold: .12 });
      alvos.forEach(function (e) { ob.observe(e); });
    } else {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
    }

    marca(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-manifesto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var alvos = document.querySelectorAll('.am-mf [data-am-rv]');
    if (!alvos.length) return;
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.bottom > 0) return;
        e.target.classList.add('am-vis');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.12 });
    alvos.forEach(function (el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-onde-capa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-odc]');
    if (!raiz) return;

    var campo = raiz.querySelector('[data-am-odc-q]');
    var limpa = raiz.querySelector('[data-am-odc-limpa]');
    var estado = raiz.querySelector('[data-am-odc-estado]');
    var atalhos = raiz.querySelector('[data-am-odc-atalhos]');

    /* sem acento e sem caixa: "sao paulo" acha "São Paulo", "jundiai" acha "Jundiaí" */
    function norm(s) {
      return (s || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '')
        .toLowerCase().replace(/\s+/g, ' ').trim();
    }
    function plural(n, um, varios) { return n + ' ' + (n === 1 ? um : varios); }

    /* O scroll do Horizon mora em `.page-wrapper`, nao no window: scrollIntoView
       rola o container certo sozinho. */
    function ir(alvo) {
      if (!alvo) return;
      var suave = !window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      alvo.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'start' });
    }
    raiz.addEventListener('click', function (e) {
      var a = e.target.closest('[data-am-odc-ir]');
      if (!a) return;
      var alvo = document.querySelector(a.getAttribute('data-am-odc-ir'));
      if (!alvo) return;
      e.preventDefault();
      ir(alvo);
    });

    function lojas() { return [].slice.call(document.querySelectorAll('[data-am-od-loja]')); }
    /* nome de cidade digitado inteiro (ou vindo do atalho) filtra pela CIDADE,
       nao pelo texto: "Santos" nao pode trazer loja de outra cidade que tenha
       "santos" no endereco */
    var conhecidas = {};

    /* ---- carimbo: conta o que as listas desenharam */
    function contar() {
      var todas = lojas();
      if (!todas.length) return;
      var cidades = {}, ufs = {};
      conhecidas = {};
      todas.forEach(function (l) {
        var c = l.getAttribute('data-am-od-cidade') || '';
        var u = l.getAttribute('data-am-od-uf') || '';
        var k = norm(c) + '|' + norm(u);
        if (!cidades[k]) cidades[k] = { nome: c, n: 0 };
        cidades[k].n++;
        conhecidas[norm(c)] = 1;
        if (u) ufs[u.toUpperCase()] = 1;
      });
      var nCid = Object.keys(cidades).length;
      var nUf = Object.keys(ufs);
      raiz.querySelector('[data-am-odc-n="lojas"]').textContent = todas.length;
      raiz.querySelector('[data-am-odc-n="lojas-rot"]').textContent = todas.length === 1 ? 'loja física' : 'lojas físicas';
      raiz.querySelector('[data-am-odc-n="cidades"]').textContent =
        plural(nCid, 'cidade', 'cidades') + ' · ' + (nUf.length === 1 ? nUf[0] : nUf.length + ' estados');
      raiz.querySelector('[data-am-odc-carimbo]').removeAttribute('hidden');
      raiz.querySelector('[data-am-odc-etiq]').removeAttribute('hidden');

      /* atalhos: as cidades com mais lojas, ate seis */
      var lista = Object.keys(cidades).map(function (k) { return cidades[k]; })
        .sort(function (a, b) { return b.n - a.n || a.nome.localeCompare(b.nome, 'pt-BR'); })
        .slice(0, 6);
      atalhos.innerHTML = '';
      lista.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'am-odc__chip';
        b.setAttribute('data-am-odc-cidade', c.nome);
        b.setAttribute('aria-pressed', 'false');
        b.appendChild(document.createTextNode(c.nome));
        var s = document.createElement('small');
        s.textContent = c.n;
        s.setAttribute('aria-hidden', 'true');
        b.appendChild(s);
        atalhos.appendChild(b);
      });
      if (lista.length > 1) atalhos.removeAttribute('hidden');
    }

    /* ---- filtro */
    function filtrar() {
      var q = norm(campo.value);
      var termos = q ? q.split(' ') : [];
      var vistas = 0, cidadesVistas = {};
      var primeira = null;

      var exata = q && conhecidas[q];
      lojas().forEach(function (l) {
        var alvo = norm(l.getAttribute('data-am-od-busca'));
        var ok = exata
          ? norm(l.getAttribute('data-am-od-cidade')) === q
          : termos.every(function (t) { return alvo.indexOf(t) !== -1; });
        if (ok) l.removeAttribute('hidden'); else l.setAttribute('hidden', '');
        if (ok) {
          vistas++;
          cidadesVistas[norm(l.getAttribute('data-am-od-cidade'))] = 1;
          if (!primeira) primeira = l;
        }
      });
      /* a lista de distribuidores (data-am-od-dist) não entra na busca de lojas */
      document.querySelectorAll('[data-am-od-grupo]').forEach(function (g) {
        if (g.closest('[data-am-od-dist]')) return;
        var algum = g.querySelector('[data-am-od-loja]:not([hidden])');
        if (algum) g.removeAttribute('hidden'); else g.setAttribute('hidden', '');
      });
      document.querySelectorAll('[data-am-od-lista]').forEach(function (s) {
        if (s.hasAttribute('data-am-od-dist')) return;
        var algum = s.querySelector('[data-am-od-loja]:not([hidden])');
        if (algum || !q) s.removeAttribute('hidden'); else s.setAttribute('hidden', '');
        /* no celular as cidades nascem recolhidas; achado de busca aparece aberto */
        s.classList.toggle('am-odl--busca', !!q);
      });

      if (q) limpa.removeAttribute('hidden'); else limpa.setAttribute('hidden', '');
      atalhos.querySelectorAll('[data-am-odc-cidade]').forEach(function (b) {
        var on = norm(b.getAttribute('data-am-odc-cidade')) === q;
        b.classList.toggle('am-odc-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      estado.innerHTML = '';
      if (!q) return primeira;
      if (vistas) {
        estado.appendChild(document.createTextNode(
          plural(vistas, 'loja', 'lojas') + ' em ' + plural(Object.keys(cidadesVistas).length, 'cidade', 'cidades') + '. '));
        var ver = document.createElement('a');
        ver.href = '#';
        ver.textContent = 'Ver ' + (vistas === 1 ? 'a loja' : 'as lojas') + ' ↓';
        ver.addEventListener('click', function (e) {
          e.preventDefault();
          ir(primeira.closest('[data-am-od-grupo]') || primeira);
        });
        estado.appendChild(ver);
      } else {
        estado.appendChild(document.createTextNode('Ainda não temos loja física com “' + campo.value.trim() + '”. '));
        var on = document.querySelector('#onde-online');
        var fale = document.querySelector('#onde-fale');
        if (on) {
          var a1 = document.createElement('a');
          a1.href = '#onde-online'; a1.textContent = 'Compre online';
          a1.addEventListener('click', function (e) { e.preventDefault(); ir(on); });
          estado.appendChild(a1);
        }
        if (on && fale) estado.appendChild(document.createTextNode(' ou '));
        if (fale) {
          var a2 = document.createElement('a');
          a2.href = '#onde-fale'; a2.textContent = (on ? 'i' : 'I') + 'ndique o seu mercado';
          a2.addEventListener('click', function (e) { e.preventDefault(); ir(fale); });
          estado.appendChild(a2);
        }
        estado.appendChild(document.createTextNode('.'));
      }
      return primeira;
    }

    var espera = null;
    campo.addEventListener('input', function () {
      clearTimeout(espera);
      espera = setTimeout(filtrar, 120);
    });
    campo.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      clearTimeout(espera);
      var p = filtrar();
      if (p) ir(p.closest('[data-am-od-grupo]') || p);
    });
    limpa.addEventListener('click', function () {
      campo.value = '';
      filtrar();
      campo.focus();
    });
    atalhos.addEventListener('click', function (e) {
      var b = e.target.closest('[data-am-odc-cidade]');
      if (!b) return;
      var nome = b.getAttribute('data-am-odc-cidade');
      campo.value = norm(campo.value) === norm(nome) ? '' : nome;
      filtrar();
    });

    contar();
    /* no editor do tema as listas re-renderizam sem recarregar a pagina */
    document.addEventListener('shopify:section:load', function () { contar(); filtrar(); });
    document.addEventListener('shopify:block:select', contar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-onde-lista"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Recolhe as cidades no celular: 45 lojas abertas davam ~10 mil px de
       rolagem. No computador tudo fica aberto. */
    var celular = window.matchMedia('(max-width:749px)');
    function montar(raiz) {
      if (raiz.__amOdl) return;
      raiz.__amOdl = true;
      raiz.addEventListener('click', function (e) {
        var b = e.target.closest('[data-am-odl-abre]');
        if (!b) return;
        var g = b.closest('[data-am-od-grupo]');
        var aberta = !g.classList.contains('am-odl-aberta');
        g.classList.toggle('am-odl-aberta', aberta);
        b.setAttribute('aria-expanded', aberta ? 'true' : 'false');
      });
    }
    function aplicar() {
      document.querySelectorAll('[data-am-od-lista]').forEach(function (raiz) {
        montar(raiz);
        var rec = celular.matches;
        raiz.classList.toggle('am-odl--recolhe', rec);
        raiz.querySelectorAll('[data-am-od-grupo]').forEach(function (g) {
          var aberta = !rec || g.classList.contains('am-odl-aberta');
          var b = g.querySelector('[data-am-odl-abre]');
          if (b) b.setAttribute('aria-expanded', aberta ? 'true' : 'false');
        });
      });
    }
    aplicar();
    if (celular.addEventListener) celular.addEventListener('change', aplicar);
    document.addEventListener('shopify:section:load', aplicar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-pagina"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-pg]');
    if (!raiz) return;
    var col = raiz.querySelector('[data-am-pg-texto]');
    var alvos = Array.prototype.slice.call(raiz.querySelectorAll('[data-am-rv]'));
    if (col) alvos = alvos.concat(Array.prototype.slice.call(col.children));
    if (!alvos.length) return;

    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
      return;
    }
    var ob = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('am-vis');
        ob.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: .04 });
    alvos.forEach(function (e) { ob.observe(e); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-pilares"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-am-pilares]').forEach(function (cx) {
      var abas = [].slice.call(cx.querySelectorAll('[data-am-aba]'));
      var paineis = [].slice.call(cx.querySelectorAll('[data-am-painel]'));
      if (!abas.length) return;

      function mostrar(i) {
        abas.forEach(function (a, k) {
          var on = k === i;
          a.classList.toggle('am-pilar-on', on);
          a.setAttribute('aria-selected', on ? 'true' : 'false');
          a.tabIndex = on ? 0 : -1;
        });
        paineis.forEach(function (p, k) {
          p.hidden = k !== i;
          p.classList.toggle('am-pilar-on', k === i);
        });
      }

      abas.forEach(function (a, i) {
        a.addEventListener('click', function () { mostrar(i); });
        a.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1
                : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var prox = (i + d + abas.length) % abas.length;
          mostrar(prox);
          abas[prox].focus();
        });
      });
    });

    /* entrada por rolagem — o Horizon nao rola no window, entao observer */
    var alvos = document.querySelectorAll('.am-pilar [data-am-rv]');
    if (alvos.length) {
      var obs = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting && e.boundingClientRect.bottom > 0) return;
          e.target.classList.add('am-vis');
          obs.unobserve(e.target);
        });
      }, { threshold: 0.1 });
      alvos.forEach(function (el) { obs.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var pop = document.querySelector('[data-am-pop]');
    if (!pop) return;

    var CHAVE = 'am-pop-visto';
    var editor = !!(window.Shopify && window.Shopify.designMode);

    /* Sai da seção e vai para o body, para que nenhum ancestral com transform
       quebre o position:fixed. */
    if (pop.parentNode !== document.body) document.body.appendChild(pop);

    /* O Horizon põe overflow:hidden no html/body em telas grandes e rola dentro
       do .page-wrapper. Travar o scroll no body não teria efeito nenhum:
       é preciso travar o container que de fato rola. */
    function containerDeScroll() {
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 4) return pw;
      return document.documentElement;
    }

    var trava = null;
    var ultimoFoco = null;

    function abrir() {
      ultimoFoco = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('am-vis'); });
      trava = containerDeScroll();
      trava.style.overflow = 'hidden';
      var alvo = pop.querySelector('input[type="email"]') || pop.querySelector('.am-pop__x');
      if (alvo) setTimeout(function () { alvo.focus(); }, 420);
      document.addEventListener('keydown', tecla);
    }

    function fechar() {
      pop.classList.remove('am-vis');
      setTimeout(function () { pop.hidden = true; }, 420);
      if (trava) { trava.style.overflow = ''; trava = null; }
      document.removeEventListener('keydown', tecla);
      marcar();
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    }

    function tecla(e) {
      if (e.key === 'Escape') { fechar(); return; }
      if (e.key !== 'Tab') return;
      var focaveis = pop.querySelectorAll('button, input, a[href], select');
      if (!focaveis.length) return;
      var primeiro = focaveis[0];
      var ultimo = focaveis[focaveis.length - 1];
      if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
    }

    function marcar() {
      if (editor) return;
      try {
        var dias = Number(pop.getAttribute('data-dias')) || 14;
        localStorage.setItem(CHAVE, String(Date.now() + dias * 86400000));
      } catch (e) { /* navegação privada: só não lembra */ }
    }

    function jaViu() {
      if (editor) return false;
      try {
        var ate = Number(localStorage.getItem(CHAVE));
        return !!ate && Date.now() < ate;
      } catch (e) { return false; }
    }

    pop.querySelectorAll('[data-am-pop-fecha]').forEach(function (b) {
      b.addEventListener('click', fechar);
    });

    /* copiar o cupom (com reserva para navegador sem clipboard) */
    var copia = pop.querySelector('[data-am-pop-copia]');
    if (copia) copia.addEventListener('click', function () {
      var cod = (pop.querySelector('[data-am-pop-codigo]') || {}).textContent || '';
      function ok() { copia.textContent = 'Copiado!'; copia.classList.add('am-feito');
        setTimeout(function () { copia.textContent = 'Copiar'; copia.classList.remove('am-feito'); }, 2200); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(cod.trim()).then(ok, ok);
      else { var t = document.createElement('textarea'); t.value = cod.trim(); document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); } catch (e) {} t.remove(); ok(); }
    });

    /* Volta do POST do formulário com ?customer_posted=true: mostra o obrigado
       e não pergunta de novo. */
    var sucesso = /customer_posted=true/.test(window.location.search);
    if (sucesso) {
      var miolo = pop.querySelector('[data-am-pop-miolo]');
      var ok = pop.querySelector('[data-am-pop-ok]');
      if (miolo && ok) { miolo.hidden = true; ok.hidden = false; }
      abrir();
      marcar();
      return;
    }

    if (editor) { abrir(); return; }

    /* `?popup=1` força a abertura ignorando o "já vi" — é o único jeito de
       conferir o popup depois de fechá-lo uma vez, já que a marca dura 14 dias
       e mora no localStorage de cada navegador. `?popup=0` apaga a marca. */
    var forca = /[?&]popup=1/.test(window.location.search);
    if (/[?&]popup=0/.test(window.location.search)) {
      try { localStorage.removeItem(CHAVE); } catch (e) { }
    }
    if (!forca && jaViu()) return;

    /* QUANDO ABRE (20/10). Abria aos 6 s e cobria a tela do celular antes de a
       pessoa ver um produto (Clarity: 17 de 77 sessões mexeram nele, quase
       sempre para fechar). Agora abre quando a pessoa já leu metade da página
       OU depois de 30 s, o que vier primeiro; no computador também quando o
       mouse sai pelo topo da janela (vai fechar a aba). Nunca por cima da
       sacola aberta: espera ela fechar. O ajuste "Aparece depois de" do
       editor vale como piso: abaixo de 30 s ele é ignorado. */
    var atraso = Math.max(30, Number(pop.getAttribute('data-atraso')) || 0) * 1000;
    var foi = false;
    /* containerDeScroll() devolve o documentElement quando a janela é quem
       rola, e o evento `scroll` não nasce nele: aqui a raiz vira `window` */
    var raizRolo = containerDeScroll();
    if (raizRolo === document.documentElement) raizRolo = window;
    function sacolaAberta() {
      var c = document.querySelector('[data-am-cart]');
      return c && !c.hidden;
    }
    function tenta() {
      if (foi) return;
      if (sacolaAberta()) { setTimeout(tenta, 1500); return; }
      foi = true;
      (raizRolo === window ? window : raizRolo).removeEventListener('scroll', rolou);
      document.removeEventListener('mouseout', saiu);
      abrir();
    }
    function rolou() {
      var el = raizRolo === window ? document.documentElement : raizRolo;
      var y = raizRolo === window ? window.scrollY : raizRolo.scrollTop;
      var max = el.scrollHeight - el.clientHeight;
      if (max > 0 && y / max >= 0.5) tenta();
    }
    function saiu(e) {
      if (!e.relatedTarget && e.clientY <= 0) tenta();
    }
    (raizRolo === window ? window : raizRolo).addEventListener('scroll', rolou, { passive: true });
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', saiu);
    }
    setTimeout(tenta, atraso);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-porque"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Duas entradas, cada uma no seu gatilho, como na Bragg: o cabeçalho
       (título, texto, botão) e a lista. Quem abre a página já rolada tem o que
       ficou ACIMA da tela revelado na hora (é o buraco que o
       amana-resgate-entrada tapa para o [data-am-rv]). */
    function liga(sec) {
      if (sec.__amPq) return;
      sec.__amPq = true;
      var tit = sec.querySelector('.am-pq__tit');
      var lista = sec.querySelector('.am-pq__lista');
      if (!('IntersectionObserver' in window)) return;
      sec.classList.add('am-pq--js');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting || e.boundingClientRect.bottom < 0) {
            sec.classList.add(e.target === lista ? 'am-pq--lista' : 'am-pq--cab');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      if (tit) io.observe(tit);
      if (lista) io.observe(lista);
    }
    function tudo() {
      document.querySelectorAll('.am-porque').forEach(liga);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo);
    else tudo();
    document.addEventListener('shopify:section:load', tudo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-praticas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var secao = document.querySelector('.am-pr');
    if (!secao) return;

    /* no toque nao existe hover: o primeiro toque vira o cartao, o segundo
       segue o link */
    var toque = window.matchMedia && window.matchMedia('(hover: none)').matches;
    if (toque) {
      secao.querySelectorAll('[data-am-vira]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (!a.classList.contains('am-pr-aberto')) {
            e.preventDefault();
            secao.querySelectorAll('.am-pr-aberto').forEach(function (o) {
              o.classList.remove('am-pr-aberto');
            });
            a.classList.add('am-pr-aberto');
          }
        });
      });
    }

    var alvos = secao.querySelectorAll('[data-am-rv]');
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.bottom > 0) return;
        e.target.classList.add('am-vis');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.1 });
    alvos.forEach(function (el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-prod-avaliacoes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-opi]');
    if (!raiz || raiz.__amOpi) return;
    raiz.__amOpi = true;

    /* ================= abas (Avaliações / Perguntas) ================= */
    var abas = raiz.querySelectorAll('[data-am-aba]');
    var paineis = raiz.querySelectorAll('[data-am-avpainel]');
    function abrirAba(alvo) {
      abas.forEach(function (o) {
        var on = o.getAttribute('data-am-aba') === alvo;
        o.classList.toggle('am-on', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      paineis.forEach(function (p) {
        var on = p.getAttribute('data-am-avpainel') === alvo;
        p.classList.toggle('am-on', on);
        p.hidden = !on;
      });
    }
    abas.forEach(function (b) { b.addEventListener('click', function () { abrirAba(b.getAttribute('data-am-aba')); }); });

    /* ================= revelação do título ================= */
    var rvs = raiz.querySelectorAll('[data-am-rv]');
    if ('IntersectionObserver' in window) {
      var obsRv = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('am-vis'); obsRv.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      rvs.forEach(function (e) { obsRv.observe(e); });
    } else rvs.forEach(function (e) { e.classList.add('am-vis'); });

    /* ================= base ================= */
    var API = (raiz.getAttribute('data-am-opi-api') || '').replace(/\/+$/, '');
    var PRODUTO = raiz.getAttribute('data-am-opi-produto');
    var SITEKEY = raiz.getAttribute('data-am-opi-sitekey');
    var TESTE = /[?&]avaliacoes=teste\b/.test(location.search);
    var DADOS = {};
    try { DADOS = JSON.parse(raiz.querySelector('[data-am-opi-dados]').textContent); } catch (e) {}
    var corpo = raiz.querySelector('[data-am-opi-corpo]');
    var PARA = { celiaco: 'Celíaco', aplv: 'APLV', vegano: 'Vegano', 'sem-acucar': 'Evita açúcar', crianca: 'Criança', 'sem-restricao': 'Sem restrição' };
    var ORDENS = [['recentes', 'Mais recentes'], ['uteis', 'Mais úteis'], ['melhores', 'Melhores notas'], ['piores', 'Piores notas']];
    var reduz = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (TESTE) raiz.querySelector('[data-am-opi-teste]').hidden = false;

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function num(n) { return String(n).replace('.', ','); }
    var CAM = 'M10 1.6l2.5 5.4 5.9.7-4.4 4 1.2 5.8L10 14.6 4.8 17.5 6 11.7 1.6 7.7l5.9-.7Z';
    function svg5() { var s = ''; for (var i = 0; i < 5; i++) s += '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + CAM + '"/></svg>'; return s; }
    /* o mesmo desenho de window.AmanaEstrelas (amana-cartao-base) */
    function est(n) {
      if (window.AmanaEstrelas) return window.AmanaEstrelas(n);
      var p = Math.max(0, Math.min(100, n / 5 * 100));
      return '<span class="am-opi-est" role="img" aria-label="' + num(n) + ' de 5 estrelas"><span class="am-opi-est__v">' + svg5() +
        '</span><span class="am-opi-est__c" style="width:' + p + '%">' + svg5() + '</span></span>';
    }
    function quando(iso) {
      var d = new Date(iso), dias = Math.floor((Date.now() - d.getTime()) / 864e5);
      if (dias < 1) return 'hoje';
      if (dias < 2) return 'ontem';
      if (dias < 7) return 'há ' + dias + ' dias';
      if (dias < 31) { var s = Math.floor(dias / 7); return 'há ' + s + (s > 1 ? ' semanas' : ' semana'); }
      return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
    }
    function plural(n, um, varios) { return n + ' ' + (n === 1 ? um : varios); }
    var guarda = {
      ler: function (k, pad) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : pad; } catch (e) { return pad; } },
      por: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
    };

    /* ============ trava de rolagem (Horizon rola no .page-wrapper ≥990) ============ */
    function travar() {
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 4 && getComputedStyle(pw).overflowY !== 'visible') {
        var antes = pw.style.overflow;
        pw.style.overflow = 'hidden';
        return function () { pw.style.overflow = antes; };
      }
      /* celular: prende o body no lugar em vez de overflow:hidden (armadilha 51) */
      var y = window.scrollY || document.documentElement.scrollTop, b = document.body.style;
      var guardado = [b.position, b.top, b.left, b.right, b.width];
      b.position = 'fixed'; b.top = -y + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
      return function () {
        b.position = guardado[0]; b.top = guardado[1]; b.left = guardado[2]; b.right = guardado[3]; b.width = guardado[4];
        window.scrollTo({ top: y, left: 0, behavior: 'instant' });
      };
    }

    /* ================= estado ================= */
    var S = { ordem: 'recentes', nota: null, para: null, midia: false, pagina: 1, itens: [], resumo: null, galeria: [], total: 0, paginas: 1 };
    var carregando = false;

    function urlLista() {
      var q = ['produto=' + encodeURIComponent(PRODUTO), 'ordem=' + S.ordem, 'pagina=' + S.pagina];
      if (S.nota) q.push('nota=' + S.nota);
      if (S.para) q.push('para=' + S.para);
      if (S.midia) q.push('filtro=com-midia');
      if (S.pagina > 1) q.push('galeria=0');
      if (TESTE) q.push('teste=1');
      return API + '/v1/avaliacoes?' + q.join('&');
    }

    function carregar(mais) {
      if (carregando) return;
      carregando = true;
      if (!mais) { S.pagina = 1; }
      var botao = corpo.querySelector('[data-am-opi-mais]');
      if (botao) { botao.disabled = true; botao.textContent = 'Carregando…'; }
      fetch(urlLista(), { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (d) {
          carregando = false;
          corpo.setAttribute('aria-busy', 'false');
          S.resumo = d.resumo; /* o resumo da API é sempre do conjunto inteiro, sem filtro */
          if (d.galeria) S.galeria = d.galeria;
          S.total = d.total_filtrado;
          S.paginas = d.paginas;
          S.itens = mais ? S.itens.concat(d.avaliacoes) : d.avaliacoes;
          if (mais) acrescentar(d.avaliacoes); else desenhar();
          if (!mais) extras();
        })
        .catch(function () {
          carregando = false;
          corpo.setAttribute('aria-busy', 'false');
          corpo.innerHTML = '<div class="am-opi-vazio"><h3>Não carregou agora</h3><p>Não conseguimos buscar as avaliações neste momento.</p>' +
            '<button class="am-opi-btn" type="button" data-am-opi-recarrega>Tentar de novo</button></div>';
        });
    }

    /* ================= desenho ================= */
    function htmlVazio() {
      return '<div class="am-opi-vazio">' +
        '<div class="am-opi-vazio__selo" aria-hidden="true"><svg viewBox="0 0 20 20"><path d="' + CAM + '"/></svg></div>' +
        '<h3>Seja o primeiro a avaliar</h3>' +
        '<p>' + esc(DADOS.vazio || '') + '</p>' +
        '<button class="am-opi-btn am-opi-btn--cheio" type="button" data-am-opi-abre>' + esc(DADOS.escrever || 'Escrever uma avaliação') + '</button>' +
        '<small>Dá para mandar foto e vídeo junto.</small></div>';
    }

    function htmlResumo(r) {
      var maior = Math.max(1, r.dist[1], r.dist[2], r.dist[3], r.dist[4], r.dist[5]);
      var bons = r.dist[4] + r.dist[5];
      var barras = '';
      for (var n = 5; n >= 1; n--) {
        var c = r.dist[n] || 0;
        barras += '<button class="am-opi-barra" type="button" data-am-opi-nota="' + n + '" aria-pressed="' + (S.nota === n) + '"' + (c ? '' : ' disabled') +
          ' aria-label="' + plural(c, 'avaliação', 'avaliações') + ' com ' + n + (n > 1 ? ' estrelas' : ' estrela') + '">' +
          '<span>' + n + '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + CAM + '"/></svg></span>' +
          '<span class="am-opi-barra__t"><i data-w="' + Math.round(c / maior * 100) + '"></i></span>' +
          '<span class="am-opi-barra__n">' + c + '</span></button>';
      }
      return '<div class="am-opi-res">' +
        '<div class="am-opi-res__topo"><b class="am-opi-res__media">' + num(r.media.toFixed(1)) + '</b>' +
        '<div>' + est(r.media) + '<span class="am-opi-res__total">' + plural(r.total, 'avaliação', 'avaliações') + '</span></div></div>' +
        '<p class="am-opi-res__rec"><b>' + Math.round(bons / r.total * 100) + '%</b> deram 4 ou 5 estrelas</p>' +
        '<div class="am-opi-barras">' + barras + '</div>' +
        '<button class="am-opi-btn am-opi-btn--cheio" type="button" data-am-opi-abre>' + esc(DADOS.escrever || 'Escrever uma avaliação') + '</button>' +
        '</div>';
    }

    function htmlMini(m, i, origem) {
      var img = m.tipo === 'video' ? (m.capa ? '<img src="' + esc(m.capa) + '" alt="" loading="lazy" decoding="async">' : '<span class="am-opi-mini__vid"></span>')
        : '<img src="' + esc(m.url) + '" alt="" loading="lazy" decoding="async">';
      var play = m.tipo === 'video' ? '<span class="am-opi-mini__play"><svg viewBox="0 0 10 10" aria-hidden="true"><path d="M2 1l7 4-7 4z"/></svg>' + (m.d ? Math.round(m.d) + ' s' : 'vídeo') + '</span>' : '';
      return '<button class="am-opi-mini" type="button" data-am-opi-ver="' + origem + '" data-am-opi-i="' + i + '" aria-label="Abrir ' + (m.tipo === 'video' ? 'vídeo' : 'foto') + ' da avaliação">' + img + play + '</button>';
    }

    function htmlGaleria() {
      if (!S.galeria || !S.galeria.length) return '';
      return '<div class="am-opi-gal"><div class="am-opi-gal__topo"><h3>' + esc(DADOS.galeria || 'Fotos e vídeos de clientes') + ' <small style="font-weight:400;color:#7A6647">(' + S.galeria.length + ')</small></h3>' +
        '<div class="am-opi-gal__setas"><button class="am-opi-seta" type="button" data-am-opi-gal="-1" aria-label="Voltar"><svg viewBox="0 0 24 24"><path d="m14.5 5-6 7 6 7"/></svg></button>' +
        '<button class="am-opi-seta" type="button" data-am-opi-gal="1" aria-label="Avançar"><svg viewBox="0 0 24 24"><path d="m9.5 5 6 7-6 7"/></svg></button></div></div>' +
        '<div class="am-opi-gal__trilho" data-am-opi-trilho>' + S.galeria.map(function (m, i) { return htmlMini(m, i, 'gal'); }).join('') + '</div></div>';
    }

    function htmlFerramentas() {
      var r = S.resumo, chips = '';
      if (S.nota) chips += '<button class="am-opi-chip" type="button" aria-pressed="true" data-am-opi-tira-nota>' + S.nota + ' <svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + CAM + '"/></svg> ✕</button>';
      if (r.com_midia) chips += '<button class="am-opi-chip" type="button" data-am-opi-midia aria-pressed="' + S.midia + '">Com foto ou vídeo <small>' + r.com_midia + '</small></button>';
      Object.keys(PARA).forEach(function (k) {
        if (r.para && r.para[k]) chips += '<button class="am-opi-chip" type="button" data-am-opi-para="' + k + '" aria-pressed="' + (S.para === k) + '">' + PARA[k] + ' <small>' + r.para[k] + '</small></button>';
      });
      var ordem = '<label class="am-opi-ordem"><span>Ordenar</span><select data-am-opi-ordem>' +
        ORDENS.map(function (o) { return '<option value="' + o[0] + '"' + (S.ordem === o[0] ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('') + '</select></label>';
      return '<div class="am-opi-ferr"><div class="am-opi-chips" role="group" aria-label="Filtrar avaliações">' + chips + '</div>' + ordem + '</div>';
    }

    function htmlCartao(a, k) {
      var longo = a.texto.length > 420;
      var midias = a.midias.length ? '<div class="am-opi-c__midias">' + a.midias.map(function (m, i) { return htmlMini(m, i, 'c:' + a.id); }).join('') + '</div>' : '';
      var local = [a.cidade].filter(Boolean).join('');
      var votos = guarda.ler('am-opi-votos', []);
      var votou = votos.indexOf(a.id) >= 0;
      var marcas = (a.teste ? '<span class="am-opi-marca am-opi-marca--teste">Teste</span>' : '') +
        (a.destaque ? '<span class="am-opi-marca am-opi-marca--dest">Em destaque</span>' : '');
      return '<article class="am-opi-c" id="am-opi-' + a.id + '" style="--am-opi-d:' + (reduz ? 0 : Math.min(k, 6) * 60) + 'ms">' +
        '<div class="am-opi-c__topo"><div class="am-opi-c__marcas">' + est(a.nota) + marcas + '</div><time datetime="' + esc(a.data) + '">' + quando(a.data) + '</time></div>' +
        (a.titulo ? '<h3 class="am-opi-c__tit">' + esc(a.titulo) + '</h3>' : '') +
        '<p class="am-opi-c__txt' + (longo ? ' am-opi-c__txt--corta' : '') + '">' + esc(a.texto) + '</p>' +
        (longo ? '<button class="am-opi-c__mais" type="button" data-am-opi-lermais aria-expanded="false">Ler mais</button>' : '') +
        midias +
        '<div class="am-opi-c__pe"><div class="am-opi-quem"><span class="am-opi-av" aria-hidden="true">' + esc(a.nome.charAt(0).toUpperCase()) + '</span>' +
        '<span><b>' + esc(a.nome) + '</b>' + (local ? '<small>' + esc(local) + '</small>' : '') + '</span></div>' +
        (a.verificada ? '<span class="am-opi-selo"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>Compra verificada</span>' : '') +
        (a.para.length ? '<span class="am-opi-c__para">Para: ' + a.para.map(function (p) { return '<span class="am-opi-tag">' + esc(PARA[p] || p) + '</span>'; }).join('') + '</span>' : '') +
        '</div>' +
        (a.resposta ? '<div class="am-opi-c__resp"><b>Resposta da Amana</b><p>' + esc(a.resposta.texto) + '</p></div>' : '') +
        '<div class="am-opi-c__util"><span>Foi útil?</span><button class="am-opi-util" type="button" data-am-opi-util="' + a.id + '" aria-pressed="' + votou + '"' + (votou ? ' disabled' : '') + '>' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 10.6v9H4.4v-9Zm3 9V10.6l3.4-6.8c1.5 0 2.4 1 2.2 2.4l-.5 3h4.1c1.2 0 2 1 1.7 2.2l-1.5 6c-.2 1-1 1.6-2 1.6Z"/></svg>' +
        '<span>' + (a.util || 0) + '</span><span class="am-opi-oculto"> pessoas acharam útil</span></button></div>' +
        '</article>';
    }

    function htmlMais() {
      return S.pagina < S.paginas ? '<button class="am-opi-btn am-opi-maisb" type="button" data-am-opi-mais>Ver mais avaliações</button>' : '';
    }

    function desenhar() {
      var r = S.resumo;
      var n = raiz.querySelector('[data-am-opi-aba-n]');
      if (n) n.textContent = r && r.total ? '(' + r.total + ')' : '';
      if (!r || !r.total) { corpo.innerHTML = htmlVazio(); return; }
      var lista = S.itens.length ? S.itens.map(htmlCartao).join('')
        : '<div class="am-opi-filtro-vazio">Nenhuma avaliação com esse filtro. <button class="am-opi-c__mais" type="button" data-am-opi-limpa>Limpar filtros</button></div>';
      var filtrando = S.nota || S.para || S.midia;
      corpo.innerHTML = '<div class="am-opi-grade">' + htmlResumo(r) +
        '<div class="am-opi-lado">' + htmlGaleria() + htmlFerramentas() +
        '<p class="am-opi-conta" aria-live="polite">' + (filtrando ? plural(S.total, 'avaliação encontrada', 'avaliações encontradas') : 'Mostrando ' + Math.min(S.itens.length, S.total) + ' de ' + plural(S.total, 'avaliação', 'avaliações')) + '</p>' +
        '<div class="am-opi-lista" data-am-opi-lista>' + lista + '</div>' + htmlMais() + '</div></div>';
      /* as barras crescem depois de desenhadas */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          corpo.querySelectorAll('.am-opi-barra__t i').forEach(function (i) { i.style.width = i.getAttribute('data-w') + '%'; });
        });
      });
      setasGaleria();
    }

    function acrescentar(novos) {
      var lista = corpo.querySelector('[data-am-opi-lista]');
      var base = S.itens.length - novos.length;
      lista.insertAdjacentHTML('beforeend', novos.map(function (a, k) { return htmlCartao(a, k); }).join(''));
      var velho = corpo.querySelector('[data-am-opi-mais]');
      if (velho) velho.remove();
      lista.insertAdjacentHTML('afterend', htmlMais());
      var conta = corpo.querySelector('.am-opi-conta');
      if (conta && !(S.nota || S.para || S.midia)) conta.textContent = 'Mostrando ' + S.itens.length + ' de ' + plural(S.total, 'avaliação', 'avaliações');
      var primeiro = lista.children[base];
      if (primeiro && primeiro.focus) { primeiro.setAttribute('tabindex', '-1'); primeiro.focus({ preventScroll: true }); }
    }

    function setasGaleria() {
      var t = corpo.querySelector('[data-am-opi-trilho]');
      if (!t) return;
      var bs = corpo.querySelectorAll('[data-am-opi-gal]');
      var atualiza = function () {
        var sobra = t.scrollWidth - t.clientWidth;
        bs[0].disabled = t.scrollLeft < 4;
        bs[1].disabled = t.scrollLeft > sobra - 4;
        corpo.querySelector('.am-opi-gal__setas').hidden = sobra < 4;
      };
      t.addEventListener('scroll', atualiza, { passive: true });
      atualiza();
    }

    /* ================= estrelas no topo da PDP + JSON-LD ================= */
    function extras() {
      var r = S.resumo;
      var topo = document.querySelector('[data-am-opi-topo]');
      if (topo && r && r.total) {
        topo.innerHTML = est(r.media) + '<span>' + num(r.media.toFixed(1)) + ' · ' + plural(r.total, 'avaliação', 'avaliações') + '</span>';
        topo.hidden = false;
      }
      /* SEO: só com avaliação real e nunca no modo de teste */
      if (TESTE || !r || !r.total || !DADOS.produto || document.querySelector('script[data-am-opi-ld]')) return;
      var reais = S.itens.filter(function (a) { return !a.teste; });
      if (!reais.length) return;
      var p = DADOS.produto;
      var ld = {
        '@context': 'https://schema.org', '@type': 'Product', '@id': p.url + '#produto', name: p.name, url: p.url,
        brand: { '@type': 'Brand', name: 'Amana' },
        aggregateRating: { '@type': 'AggregateRating', ratingValue: r.media, reviewCount: r.total, bestRating: 5, worstRating: 1 },
        review: reais.slice(0, 10).map(function (a) {
          var rv = { '@type': 'Review', author: { '@type': 'Person', name: a.nome }, datePublished: a.data.slice(0, 10),
            reviewRating: { '@type': 'Rating', ratingValue: a.nota, bestRating: 5, worstRating: 1 }, reviewBody: a.texto };
          if (a.titulo) rv.name = a.titulo;
          return rv;
        })
      };
      if (p.image) ld.image = [p.image];
      if (p.description) ld.description = p.description;
      if (p.sku) ld.sku = p.sku;
      if (p.price != null) ld.offers = { '@type': 'Offer', price: Number(p.price).toFixed(2), priceCurrency: 'BRL', url: p.url,
        availability: p.available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock' };
      var s = document.createElement('script');
      s.type = 'application/ld+json';
      s.setAttribute('data-am-opi-ld', '');
      s.textContent = JSON.stringify(ld);
      document.head.appendChild(s);
    }

    /* ================= cliques na área das avaliações ================= */
    corpo.addEventListener('click', function (e) {
      var t = e.target;
      var b;
      if ((b = t.closest('[data-am-opi-abre]'))) { abrirForm(b); return; }
      if (t.closest('[data-am-opi-recarrega]')) { corpo.innerHTML = ''; carregar(false); return; }
      if ((b = t.closest('[data-am-opi-nota]'))) {
        var n = Number(b.getAttribute('data-am-opi-nota'));
        S.nota = S.nota === n ? null : n; carregar(false); return;
      }
      if (t.closest('[data-am-opi-tira-nota]')) { S.nota = null; carregar(false); return; }
      if (t.closest('[data-am-opi-midia]')) { S.midia = !S.midia; carregar(false); return; }
      if ((b = t.closest('[data-am-opi-para]'))) { var k = b.getAttribute('data-am-opi-para'); S.para = S.para === k ? null : k; carregar(false); return; }
      if (t.closest('[data-am-opi-limpa]')) { S.nota = S.para = null; S.midia = false; carregar(false); return; }
      if (t.closest('[data-am-opi-mais]')) { S.pagina++; carregar(true); return; }
      if ((b = t.closest('[data-am-opi-lermais]'))) {
        var p = b.previousElementSibling, aberto = b.getAttribute('aria-expanded') === 'true';
        p.classList.toggle('am-opi-c__txt--corta', aberto);
        b.setAttribute('aria-expanded', aberto ? 'false' : 'true');
        b.textContent = aberto ? 'Ler mais' : 'Ler menos';
        return;
      }
      if ((b = t.closest('[data-am-opi-gal]'))) {
        var tr = corpo.querySelector('[data-am-opi-trilho]');
        tr.scrollBy({ left: Number(b.getAttribute('data-am-opi-gal')) * tr.clientWidth * 0.8, behavior: reduz ? 'auto' : 'smooth' });
        return;
      }
      if ((b = t.closest('[data-am-opi-ver]'))) { abrirVisor(b.getAttribute('data-am-opi-ver'), Number(b.getAttribute('data-am-opi-i')), b); return; }
      if ((b = t.closest('[data-am-opi-util]'))) { votar(b); }
    });
    corpo.addEventListener('change', function (e) {
      if (e.target.matches('[data-am-opi-ordem]')) { S.ordem = e.target.value; carregar(false); }
    });

    /* estrelas do topo levam à aba de avaliações */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#am-avaliacoes"]');
      if (a) abrirAba('avaliacoes');
    });

    /* ================= voto "foi útil" ================= */
    function quemSou() {
      var q = guarda.ler('am-opi-quem', null);
      if (!q) {
        var b = new Uint8Array(12); (window.crypto || window.msCrypto).getRandomValues(b);
        q = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
        guarda.por('am-opi-quem', q);
      }
      return q;
    }
    function votar(b) {
      var id = b.getAttribute('data-am-opi-util');
      var n = b.querySelector('span');
      b.disabled = true;
      b.setAttribute('aria-pressed', 'true');
      n.textContent = Number(n.textContent) + 1;
      b.classList.add('am-opi-pula');
      var votos = guarda.ler('am-opi-votos', []);
      votos.push(id); guarda.por('am-opi-votos', votos.slice(-300));
      fetch(API + '/v1/util', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quem: quemSou() }) })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.ok) n.textContent = d.util; })
        .catch(function () {});
    }

    /* ================= visualizador ================= */
    var V = raiz.querySelector('[data-am-opi-v]');
    var trilho = V.querySelector('[data-am-opi-v-trilho]');
    var vAtual = 0, vItens = [], vDestrava = null, vFoco = null;
    document.body.appendChild(V); /* fora da seção: nenhum ancestral com transform */

    function itensDe(origem) {
      if (origem === 'gal') return S.galeria;
      var id = origem.slice(2);
      var a = S.itens.filter(function (x) { return x.id === id; })[0];
      if (!a) return [];
      return a.midias.map(function (m) { return Object.assign({}, m, { avaliacao: a }); });
    }
    function abrirVisor(origem, i, botao) {
      vItens = itensDe(origem);
      if (!vItens.length) return;
      vFoco = botao;
      trilho.innerHTML = vItens.map(function (m, k) { return '<div class="am-opi-v__slide" data-k="' + k + '"></div>'; }).join('');
      V.hidden = false;
      vDestrava = travar();
      requestAnimationFrame(function () { V.classList.add('am-opi-vis'); });
      irPara(i, true);
      V.querySelector('[data-am-opi-v-fecha]').focus();
      document.addEventListener('keydown', teclaVisor);
    }
    function montarSlide(k) {
      var el = trilho.children[k];
      if (!el || el.firstChild) return;
      var m = vItens[k];
      el.innerHTML = m.tipo === 'video'
        ? '<video src="' + esc(m.url) + '" controls playsinline preload="metadata"' + (m.capa ? ' poster="' + esc(m.capa) + '"' : '') + '></video>'
        : '<img src="' + esc(m.url) + '" alt="Foto enviada por quem avaliou" draggable="false">';
    }
    function irPara(i, sem) {
      vAtual = Math.max(0, Math.min(vItens.length - 1, i));
      [vAtual - 1, vAtual, vAtual + 1].forEach(montarSlide);
      trilho.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
      if (sem) trilho.classList.add('am-opi-arrasta');
      trilho.style.transform = 'translateX(' + (-vAtual * 100) + '%)';
      if (sem) { trilho.offsetWidth; trilho.classList.remove('am-opi-arrasta'); }
      V.querySelector('[data-am-opi-v-conta]').textContent = (vAtual + 1) + ' / ' + vItens.length;
      V.querySelector('[data-am-opi-v-ir="-1"]').disabled = vAtual === 0;
      V.querySelector('[data-am-opi-v-ir="1"]').disabled = vAtual === vItens.length - 1;
      var a = vItens[vAtual].avaliacao || {};
      V.querySelector('[data-am-opi-v-leg]').innerHTML = est(a.nota || 0) +
        '<b>' + esc(a.nome || '') + (a.cidade ? ' <span>· ' + esc(a.cidade) + '</span>' : '') + (a.teste ? ' <span>· TESTE</span>' : '') + '</b>' +
        (a.titulo || a.texto ? '<p>' + esc(a.titulo ? a.titulo + ' — ' : '') + esc(a.texto || '') + '</p>' : '') +
        '<button type="button" data-am-opi-v-avaliacao="' + esc(a.id || '') + '">Ver avaliação</button>';
    }
    function fecharVisor() {
      V.classList.remove('am-opi-vis');
      document.removeEventListener('keydown', teclaVisor);
      trilho.querySelectorAll('video').forEach(function (v) { v.pause(); });
      if (vDestrava) { vDestrava(); vDestrava = null; }
      setTimeout(function () { V.hidden = true; trilho.innerHTML = ''; }, reduz ? 0 : 260);
      if (vFoco && vFoco.focus) vFoco.focus({ preventScroll: true });
    }
    function teclaVisor(e) {
      if (e.key === 'Escape') fecharVisor();
      else if (e.key === 'ArrowRight') irPara(vAtual + 1);
      else if (e.key === 'ArrowLeft') irPara(vAtual - 1);
    }
    V.addEventListener('click', function (e) {
      var b;
      if (e.target.closest('[data-am-opi-v-fecha]')) { fecharVisor(); return; }
      if ((b = e.target.closest('[data-am-opi-v-ir]'))) { irPara(vAtual + Number(b.getAttribute('data-am-opi-v-ir'))); return; }
      if ((b = e.target.closest('[data-am-opi-v-avaliacao]'))) {
        var id = b.getAttribute('data-am-opi-v-avaliacao');
        fecharVisor();
        var alvo = document.getElementById('am-opi-' + id);
        if (!alvo) { /* a avaliação ainda não está na lista: tira os filtros e procura de novo */ return; }
        alvo.classList.add('am-opi-c--alvo');
        setTimeout(function () { alvo.scrollIntoView({ behavior: reduz ? 'auto' : 'smooth', block: 'start' }); }, 60);
        setTimeout(function () { alvo.classList.remove('am-opi-c--alvo'); }, 2400);
        return;
      }
      if (e.target.classList.contains('am-opi-v__slide')) fecharVisor();
    });
    /* arrastar com o dedo (ou o mouse) */
    (function () {
      var x0 = null, y0 = 0, dx = 0, larg = 1, horizontal = null;
      var palco = V.querySelector('[data-am-opi-v-palco]');
      palco.addEventListener('pointerdown', function (e) {
        if (e.target.closest('video') && e.pointerType === 'mouse') return;
        x0 = e.clientX; y0 = e.clientY; dx = 0; horizontal = null; larg = palco.clientWidth || 1;
      });
      palco.addEventListener('pointermove', function (e) {
        if (x0 === null) return;
        dx = e.clientX - x0;
        if (horizontal === null && (Math.abs(dx) > 8 || Math.abs(e.clientY - y0) > 8)) horizontal = Math.abs(dx) > Math.abs(e.clientY - y0);
        if (!horizontal) return;
        var borda = (vAtual === 0 && dx > 0) || (vAtual === vItens.length - 1 && dx < 0) ? 0.3 : 1;
        trilho.classList.add('am-opi-arrasta');
        trilho.style.transform = 'translateX(calc(' + (-vAtual * 100) + '% + ' + dx * borda + 'px))';
      });
      function solta() {
        if (x0 === null) return;
        trilho.classList.remove('am-opi-arrasta');
        if (horizontal && Math.abs(dx) > Math.min(90, larg * 0.18)) irPara(vAtual + (dx < 0 ? 1 : -1));
        else if (horizontal) irPara(vAtual);
        x0 = null;
      }
      palco.addEventListener('pointerup', solta);
      palco.addEventListener('pointercancel', solta);
      palco.addEventListener('pointerleave', solta);
    })();

    /* ================= formulário ================= */
    var F = raiz.querySelector('[data-am-opi-f]');
    var forma = F.querySelector('[data-am-opi-forma]');
    var obrigado = F.querySelector('[data-am-opi-obrigado]');
    var erroEl = F.querySelector('[data-am-opi-erro]');
    var previas = F.querySelector('[data-am-opi-previas]');
    var entrada = F.querySelector('[data-am-opi-arquivos]');
    var solta = F.querySelector('[data-am-opi-solta]');
    var prog = F.querySelector('[data-am-opi-prog]');
    var enviarB = F.querySelector('[data-am-opi-enviar]');
    var fDestrava = null, fFoco = null, enviando = false;
    var arquivos = []; /* {id, tipo, blob, previa, l, a, d, capa, pronto, erro, el} */
    var robo = { id: null, pedido: null };
    document.body.appendChild(F);

    function abrirForm(botao) {
      fFoco = botao || document.activeElement;
      F.hidden = false;
      fDestrava = travar();
      requestAnimationFrame(function () { F.classList.add('am-opi-vis'); });
      document.addEventListener('keydown', teclaForm);
      prepararRobo();
      setTimeout(function () { var s = F.querySelector('.am-opi-f__x'); if (s) s.focus({ preventScroll: true }); }, 60);
    }
    function fecharForm() {
      if (enviando) return;
      F.classList.remove('am-opi-vis');
      document.removeEventListener('keydown', teclaForm);
      if (fDestrava) { fDestrava(); fDestrava = null; }
      setTimeout(function () {
        F.hidden = true;
        if (!obrigado.hidden) { /* depois do obrigado, o formulário volta limpo */
          forma.reset(); limparArquivos(); pintaEstrelas(0); obrigado.hidden = true; forma.hidden = false;
          if (window.turnstile && robo.id !== null) turnstile.reset(robo.id);
        }
      }, reduz ? 0 : 300);
      if (fFoco && fFoco.focus) fFoco.focus({ preventScroll: true });
    }
    function teclaForm(e) {
      if (e.key === 'Escape') { fecharForm(); return; }
      if (e.key !== 'Tab') return;
      /* o foco fica preso no painel */
      var foc = F.querySelectorAll('button:not([disabled]), input:not([disabled]), textarea, select, a[href], iframe');
      foc = Array.prototype.filter.call(foc, function (x) { return x.offsetParent !== null; });
      if (!foc.length) return;
      var ini = foc[0], fim = foc[foc.length - 1];
      if (e.shiftKey && document.activeElement === ini) { e.preventDefault(); fim.focus(); }
      else if (!e.shiftKey && document.activeElement === fim) { e.preventDefault(); ini.focus(); }
    }
    F.addEventListener('click', function (e) { if (e.target.closest('[data-am-opi-fecha]')) fecharForm(); });

    /* ---- Turnstile (anti-robô do Cloudflare), carregado só quando o painel abre ---- */
    function prepararRobo() {
      if (!SITEKEY || robo.id !== null || robo.pedido) return;
      robo.pedido = new Promise(function (ok, falha) {
        if (window.turnstile) return ok();
        window.amOpiTurnstile = ok;
        var s = document.createElement('script');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=amOpiTurnstile';
        s.async = true; s.defer = true; s.onerror = falha;
        document.head.appendChild(s);
      }).then(function () {
        robo.id = turnstile.render(F.querySelector('[data-am-opi-robo]'), {
          sitekey: SITEKEY, language: 'pt-br', theme: 'light', size: 'flexible', appearance: 'interaction-only',
          'response-field': false
        });
      }).catch(function () { robo.pedido = null; });
    }
    function tokenRobo() {
      return new Promise(function (ok) {
        if (!window.turnstile || robo.id === null) return ok('');
        var t = turnstile.getResponse(robo.id);
        if (t) return ok(t);
        /* ainda resolvendo: espera até 12 s */
        var n = 0, iv = setInterval(function () {
          t = turnstile.getResponse(robo.id);
          if (t || ++n > 48) { clearInterval(iv); ok(t || ''); }
        }, 250);
      });
    }

    /* ---- estrelas grandes ---- */
    var ROT = ['', 'Não gostei', 'Poderia ser melhor', 'Ok', 'Gostei', 'Amei!'];
    var labels = F.querySelectorAll('.am-opi-f__estrelas label');
    var rotNota = F.querySelector('[data-am-opi-nota-rot]');
    function notaAtual() { var c = forma.querySelector('input[name="nota"]:checked'); return c ? Number(c.value) : 0; }
    function pintaEstrelas(n, provisorio) {
      labels.forEach(function (l, i) { l.classList.toggle('am-opi-acesa', i < n); });
      rotNota.textContent = n ? ROT[n] : 'Toque nas estrelas';
      if (!provisorio) F.querySelector('.am-opi-f__notas').classList.remove('am-opi-ruim');
    }
    forma.querySelectorAll('input[name="nota"]').forEach(function (r) {
      r.addEventListener('change', function () { pintaEstrelas(notaAtual()); });
    });
    labels.forEach(function (l, i) {
      l.addEventListener('mouseenter', function () { if (matchMedia('(hover:hover)').matches) pintaEstrelas(i + 1, true); });
      l.addEventListener('mouseleave', function () { pintaEstrelas(notaAtual(), true); });
    });

    var texto = forma.querySelector('textarea[name="texto"]');
    var conta = F.querySelector('[data-am-opi-conta]');
    texto.addEventListener('input', function () { conta.textContent = texto.value.length + '/2000'; });
    forma.addEventListener('input', function (e) {
      var c = e.target.closest('.am-opi-f__campo, .am-opi-f__ok');
      if (c) c.classList.remove('am-opi-ruim');
    });

    /* ---- fotos e vídeo: comprimidos NO NAVEGADOR antes de subir ---- */
    var MAX_FOTOS = 5, MAX_VIDEO_MB = 25, MAX_VIDEO_S = 30, LADO = 1600;
    function blobDeCanvas(c, q) { return new Promise(function (ok) { c.toBlob(function (b) { ok(b); }, 'image/jpeg', q); }); }
    function carregarImagem(arq) {
      if (window.createImageBitmap) {
        return createImageBitmap(arq, { imageOrientation: 'from-image' }).catch(function () { return carregarImg(arq); });
      }
      return carregarImg(arq);
    }
    function carregarImg(arq) {
      return new Promise(function (ok, falha) {
        var u = URL.createObjectURL(arq), im = new Image();
        im.onload = function () { ok(im); };
        im.onerror = function () { URL.revokeObjectURL(u); falha(new Error('imagem')); };
        im.src = u;
      });
    }
    function comprimirFoto(arq) {
      return carregarImagem(arq).then(function (im) {
        var w = im.width || im.naturalWidth, h = im.height || im.naturalHeight;
        var k = Math.min(1, LADO / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.round(w * k); c.height = Math.round(h * k);
        var g = c.getContext('2d');
        g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height);
        g.drawImage(im, 0, 0, c.width, c.height);
        if (im.close) im.close();
        return blobDeCanvas(c, 0.82).then(function (b) { return { blob: b, l: c.width, a: c.height }; });
      });
    }
    function lerVideo(arq) {
      return new Promise(function (ok, falha) {
        var v = document.createElement('video'), u = URL.createObjectURL(arq), feito = false;
        v.muted = true; v.playsInline = true; v.preload = 'metadata'; v.src = u;
        var fim = function (res) { if (feito) return; feito = true; ok(res); };
        v.onerror = function () { falha(new Error('Esse vídeo não abriu aqui. Tente MP4 ou MOV.')); };
        v.onloadedmetadata = function () {
          var d = v.duration, info = { d: isFinite(d) ? d : 0, l: v.videoWidth, a: v.videoHeight, previa: u, capa: null };
          if (info.d > MAX_VIDEO_S + 1) { falha(new Error('O vídeo tem ' + Math.round(info.d) + ' s. O máximo é ' + MAX_VIDEO_S + ' s.')); return; }
          v.onseeked = function () {
            try {
              var k = Math.min(1, 960 / Math.max(v.videoWidth, v.videoHeight));
              var c = document.createElement('canvas');
              c.width = Math.round(v.videoWidth * k); c.height = Math.round(v.videoHeight * k);
              c.getContext('2d').drawImage(v, 0, 0, c.width, c.height);
              blobDeCanvas(c, 0.8).then(function (b) { info.capa = b; fim(info); });
            } catch (e) { fim(info); }
          };
          try { v.currentTime = Math.min(1, (info.d || 2) / 2); } catch (e) { fim(info); }
          setTimeout(function () { fim(info); }, 4000);
        };
      });
    }

    function desenhaPrevia(item) {
      var li = document.createElement('li');
      li.className = 'am-opi-pv am-opi-pv--carrega';
      li.innerHTML = '<button class="am-opi-pv__x" type="button" aria-label="Tirar este arquivo"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        (item.tipo === 'video' ? '<span class="am-opi-pv__tag">vídeo</span>' : '') +
        '<span class="am-opi-pv__barra" hidden><i></i></span>';
      li.querySelector('.am-opi-pv__x').addEventListener('click', function () {
        if (enviando) return;
        arquivos = arquivos.filter(function (x) { return x !== item; });
        li.remove();
        if (item.previaUrl) URL.revokeObjectURL(item.previaUrl);
      });
      item.el = li;
      previas.appendChild(li);
    }
    function mostraPrevia(item, url) {
      item.el.classList.remove('am-opi-pv--carrega');
      var img = document.createElement('img');
      img.alt = ''; img.src = url;
      item.el.insertBefore(img, item.el.firstChild);
    }
    function avisoArquivo(msg) {
      var p = F.querySelector('.am-opi-f__msg');
      if (!p) { p = document.createElement('p'); p.className = 'am-opi-f__msg'; previas.after(p); }
      p.textContent = msg;
      clearTimeout(avisoArquivo.t);
      avisoArquivo.t = setTimeout(function () { p.remove(); }, 6000);
    }
    function adicionar(lista) {
      Array.prototype.forEach.call(lista, function (arq) {
        var fotos = arquivos.filter(function (x) { return x.tipo === 'foto'; }).length;
        var videos = arquivos.filter(function (x) { return x.tipo === 'video'; }).length;
        if (/^video\//.test(arq.type) || /\.(mov|mp4|m4v|webm)$/i.test(arq.name)) {
          if (videos >= 1) return avisoArquivo('Só dá para mandar 1 vídeo.');
          if (arq.size > MAX_VIDEO_MB * 1048576) return avisoArquivo('O vídeo tem ' + Math.round(arq.size / 1048576) + ' MB. O máximo é ' + MAX_VIDEO_MB + ' MB — tente um trecho menor.');
          var it = { tipo: 'video', blob: arq, pronto: false };
          arquivos.push(it); desenhaPrevia(it);
          lerVideo(arq).then(function (info) {
            it.d = info.d; it.l = info.l; it.a = info.a; it.capa = info.capa; it.previaUrl = info.previa; it.pronto = true;
            if (info.capa) mostraPrevia(it, URL.createObjectURL(info.capa));
            else { it.el.classList.remove('am-opi-pv--carrega'); it.el.insertAdjacentHTML('afterbegin', '<video src="' + info.previa + '#t=0.5" muted playsinline preload="metadata" style="width:100%;height:100%;object-fit:cover"></video>'); }
          }).catch(function (e) {
            arquivos = arquivos.filter(function (x) { return x !== it; }); it.el.remove(); avisoArquivo(e.message);
          });
        } else if (/^image\//.test(arq.type) || /\.(jpe?g|png|webp|heic|heif|gif)$/i.test(arq.name)) {
          if (fotos >= MAX_FOTOS) return avisoArquivo('No máximo ' + MAX_FOTOS + ' fotos.');
          var f = { tipo: 'foto', pronto: false };
          arquivos.push(f); desenhaPrevia(f);
          comprimirFoto(arq).then(function (r) {
            f.blob = r.blob; f.l = r.l; f.a = r.a; f.pronto = true;
            f.previaUrl = URL.createObjectURL(r.blob);
            mostraPrevia(f, f.previaUrl);
          }).catch(function () {
            arquivos = arquivos.filter(function (x) { return x !== f; }); f.el.remove();
            avisoArquivo('Não conseguimos abrir “' + arq.name + '”. Envie em JPG ou PNG.');
          });
        } else {
          avisoArquivo('“' + arq.name + '” não é foto nem vídeo.');
        }
      });
    }
    function limparArquivos() {
      arquivos.forEach(function (x) { if (x.previaUrl) URL.revokeObjectURL(x.previaUrl); });
      arquivos = []; previas.innerHTML = '';
    }
    entrada.addEventListener('change', function () { adicionar(entrada.files); entrada.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) {
      solta.addEventListener(ev, function (e) { e.preventDefault(); solta.classList.add('am-opi-sobre'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      solta.addEventListener(ev, function (e) { e.preventDefault(); solta.classList.remove('am-opi-sobre'); });
    });
    solta.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) adicionar(e.dataTransfer.files); });

    /* ---- validação ---- */
    function marca(el) { var c = el.closest('.am-opi-f__campo, .am-opi-f__ok, .am-opi-f__notas'); if (c) c.classList.add('am-opi-ruim'); }
    function erro(msg, el) {
      erroEl.textContent = msg; erroEl.hidden = false;
      if (el) { marca(el); el.focus({ preventScroll: true }); (el.closest('.am-opi-f__campo, .am-opi-f__ok, .am-opi-f__notas') || el).scrollIntoView({ block: 'center', behavior: reduz ? 'auto' : 'smooth' }); }
    }
    function validar() {
      erroEl.hidden = true;
      var el = forma.elements;
      if (!notaAtual()) { F.querySelector('.am-opi-f__notas').classList.add('am-opi-ruim'); erro('Escolha de 1 a 5 estrelas.', forma.querySelector('input[name="nota"]')); return false; }
      if (el.texto.value.trim().length < 10) { erro('Conte um pouco mais na sua avaliação (mínimo de 10 letras).', el.texto); return false; }
      if (el.nome.value.trim().length < 2) { erro('Diga seu nome.', el.nome); return false; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.email.value.trim())) { erro('Confira o e-mail.', el.email); return false; }
      if (!el.consentimento.checked) { erro('Para publicar, precisamos do seu de acordo.', el.consentimento); return false; }
      if (arquivos.some(function (x) { return !x.pronto; })) { erro('Espere as fotos terminarem de carregar.'); return false; }
      return true;
    }

    /* ---- envio ---- */
    function postar(caminho, dados) {
      return fetch(API + caminho, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(dados) })
        .then(function (r) { return r.json().catch(function () { return { ok: false, erro: 'Resposta inesperada (' + r.status + ').' }; }); });
    }
    function subir(bilhete, item, blob, tipo, extra, aoProgresso) {
      return new Promise(function (ok, falha) {
        var q = 'bilhete=' + bilhete + '&tipo=' + tipo;
        Object.keys(extra).forEach(function (k) { if (extra[k] != null) q += '&' + k + '=' + encodeURIComponent(extra[k]); });
        var x = new XMLHttpRequest();
        x.open('PUT', API + '/v1/midia?' + q);
        x.setRequestHeader('Content-Type', blob.type || 'application/octet-stream');
        x.upload.onprogress = function (e) { if (e.lengthComputable) aoProgresso(e.loaded); };
        x.onload = function () {
          var d = {}; try { d = JSON.parse(x.responseText); } catch (e) {}
          if (x.status === 200 && d.ok) ok(d); else falha(new Error(d.erro || 'falha ao enviar arquivo'));
        };
        x.onerror = function () { falha(new Error('A conexão caiu no meio do envio.')); };
        x.send(blob);
      });
    }
    function estadoEnvio(ligado, texto) {
      enviando = ligado;
      enviarB.disabled = ligado;
      prog.hidden = !ligado;
      if (texto) prog.querySelector('span').textContent = texto;
      forma.querySelectorAll('input, textarea').forEach(function (i) { i.readOnly = ligado; });
    }
    function progresso(p) { prog.querySelector('i').style.width = Math.round(p * 100) + '%'; }

    forma.addEventListener('submit', function (e) {
      e.preventDefault();
      if (enviando || !validar()) return;
      var el = forma.elements;
      estadoEnvio(true, 'Conferindo…');
      progresso(0.03);
      var paras = Array.prototype.map.call(forma.querySelectorAll('input[name="para"]:checked'), function (c) { return c.value; });
      tokenRobo().then(function (tk) {
        if (!tk) throw new Error('Confirme que você não é um robô (a caixinha acima do botão) e tente de novo.');
        return postar('/v1/envio', { turnstile: tk, produto: PRODUTO });
      }).then(function (d) {
        if (!d.ok) throw new Error(d.erro || 'Não deu para enviar agora.');
        var bilhete = d.bilhete;
        var fila = [];
        arquivos.forEach(function (it) {
          fila.push({ it: it, blob: it.blob, tipo: it.tipo, extra: { l: it.l, a: it.a, d: it.d ? it.d.toFixed(1) : null } });
          if (it.tipo === 'video' && it.capa) fila.push({ it: it, blob: it.capa, tipo: 'capa', extra: { l: it.l, a: it.a } });
        });
        var total = fila.reduce(function (s, f) { return s + f.blob.size; }, 0) || 1, feito = 0, ids = [];
        var seq = Promise.resolve();
        fila.forEach(function (f, k) {
          seq = seq.then(function () {
            estadoEnvio(true, 'Enviando ' + (f.tipo === 'video' ? 'o vídeo' : f.tipo === 'capa' ? 'a capa do vídeo' : 'foto') + '… ');
            var barra = f.it.el.querySelector('.am-opi-pv__barra');
            if (f.tipo !== 'capa') barra.hidden = false;
            if (f.tipo === 'capa') f.extra.capa_de = f.it.idRemoto;
            return subir(bilhete, f.it, f.blob, f.tipo, f.extra, function (n) {
              if (f.tipo !== 'capa') barra.querySelector('i').style.width = Math.round(n / f.blob.size * 100) + '%';
              progresso(0.05 + 0.85 * (feito + n) / total);
            }).then(function (r) {
              feito += f.blob.size;
              if (f.tipo === 'capa') return;
              f.it.idRemoto = r.id; ids.push(r.id);
              barra.hidden = true; f.it.el.classList.add('am-opi-pv--ok');
            });
          });
        });
        return seq.then(function () {
          estadoEnvio(true, 'Finalizando…');
          progresso(0.94);
          return postar('/v1/avaliacoes', {
            bilhete: bilhete, produto: PRODUTO, produto_titulo: (DADOS.produto || {}).name, nota: notaAtual(),
            titulo: el.titulo.value, texto: el.texto.value, nome: el.nome.value, email: el.email.value,
            cidade: el.cidade.value, pedido: el.pedido.value, para: paras, midias: ids, consentimento: el.consentimento.checked
          });
        });
      }).then(function (d) {
        if (!d.ok) throw new Error(d.erro || 'Não deu para enviar agora.');
        progresso(1);
        estadoEnvio(false);
        forma.hidden = true;
        obrigado.hidden = false;
        obrigado.focus({ preventScroll: true });
        F.querySelector('.am-opi-f__cx').scrollTop = 0;
      }).catch(function (err) {
        estadoEnvio(false);
        erro(err.message || 'Não deu para enviar agora. Tente de novo.');
        erroEl.scrollIntoView({ block: 'center', behavior: reduz ? 'auto' : 'smooth' });
        if (window.turnstile && robo.id !== null) turnstile.reset(robo.id);
      });
    });

    /* ================= começa ================= */
    if (!API || !PRODUTO) return;
    /* carrega quando a seção chega perto da tela (e já de cara se a página abrir em #am-avaliacoes) */
    var iniciou = false;
    function inicia() { if (!iniciou) { iniciou = true; carregar(false); } }
    if ('IntersectionObserver' in window && location.hash !== '#am-avaliacoes') {
      var obs = new IntersectionObserver(function (ents) {
        if (ents.some(function (en) { return en.isIntersecting; })) { obs.disconnect(); inicia(); }
      }, { rootMargin: '600px 0px' });
      obs.observe(raiz);
      /* as estrelas do topo da página precisam do resumo cedo: busca logo depois do carregamento */
      if (document.querySelector('[data-am-opi-topo]')) {
        if (document.readyState === 'complete') setTimeout(inicia, 300);
        else window.addEventListener('load', function () { setTimeout(inicia, 300); });
      }
    } else inicia();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-prod-ingredientes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-ingr]');
    if (!raiz) return;

    var itens = Array.prototype.slice.call(raiz.querySelectorAll('[data-am-item]'));
    var fichas = raiz.querySelectorAll('[data-am-ficha-i]');
    var fotos = raiz.querySelectorAll('[data-am-foto]');
    if (!itens.length) return;

    /* Cada círculo tem o próprio comprimento, então a animação de traçado
       precisa dele medido — não dá para chutar um valor único. */
    raiz.querySelectorAll('.am-ingr__circ path').forEach(function (p) {
      try {
        var L = p.getTotalLength();
        p.style.setProperty('--am-len', L);
      } catch (e) { /* navegador sem getTotalLength: fica sem o traçado */ }
    });

    var atual = 0;
    var caixa = raiz.querySelector('[data-am-fotos]');
    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var t1, t2;

    function trocarFoto(i) {
      fotos.forEach(function (f) {
        f.classList.toggle('am-on', Number(f.getAttribute('data-am-foto')) === i);
      });
    }

    function ir(i) {
      if (i === atual) return;
      atual = i;
      itens.forEach(function (b, k) {
        b.classList.toggle('am-on', k === i);
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      fichas.forEach(function (f) {
        f.classList.toggle('am-on', f.getAttribute('data-am-ficha-i') === String(i));
      });

      var rasgo = caixa ? caixa.querySelector('[data-am-rasgo]') : null;
      if (reduz || !caixa || !rasgo) { trocarFoto(i); return; }

      /* Congela a foto que está saindo nas duas metades, troca a de baixo na
         mesma hora e só então abre o rasgo: o que aparece pelo meio já é a
         foto nova. Remover a classe e forçar reflow reinicia a animação em
         cliques seguidos. */
      var saindo = caixa.querySelector('.am-ingr__foto.am-on img');
      if (saindo) {
        var fonte = saindo.currentSrc || saindo.src;
        if (fonte) rasgo.style.setProperty('--am-velha', 'url("' + fonte + '")');
      }
      clearTimeout(t1); clearTimeout(t2);
      caixa.classList.remove('am-rasgando');
      void caixa.offsetWidth;
      trocarFoto(i);
      caixa.classList.add('am-rasgando');
      t2 = setTimeout(function () { caixa.classList.remove('am-rasgando'); }, 780);
    }

    itens.forEach(function (b, i) { b.addEventListener('click', function () { ir(i); }); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-prod-modo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-modo]');
    if (!raiz) return;
    var alvos = raiz.querySelectorAll('[data-am-rv]');
    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
      return;
    }
    var obs = new IntersectionObserver(function (ents) {
      var n = 0;
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        setTimeout(function () { el.classList.add('am-vis'); }, n * 110);
        n++;
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.18 });
    alvos.forEach(function (e) { obs.observe(e); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-prod-selos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-pdpselos]');
    if (!raiz) return;
    var alvos = raiz.querySelectorAll('[data-am-rv]');
    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
      return;
    }
    var obs = new IntersectionObserver(function (ents) {
      var n = 0;
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        setTimeout(function () { el.classList.add('am-vis'); }, n * 55);
        n++;
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    alvos.forEach(function (e) { obs.observe(e); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-prod-similares"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-junto]');
    if (!raiz) return;
    var alvos = raiz.querySelectorAll('[data-am-rv]');
    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
      return;
    }
    var obs = new IntersectionObserver(function (ents) {
      var n = 0;
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        setTimeout(function () { el.classList.add('am-vis'); }, n * 80);
        n++;
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.14 });
    alvos.forEach(function (e) { obs.observe(e); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-produto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-pdp]');
    if (!raiz) return;

    function moeda(c) {
      try { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
      catch (e) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
    }
    function lojaRaiz() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
    var computador = window.matchMedia('(min-width: 990px)');

    /* ------------------------------------------------ galeria */
    var palco = raiz.querySelector('[data-am-pdg-palco]');
    var trilho = raiz.querySelector('[data-am-pdg-trilho]');
    var slides = raiz.querySelectorAll('[data-am-pdg-slide]');
    var minis = raiz.querySelectorAll('[data-am-pdpmini]');
    var agoraEl = raiz.querySelector('[data-am-pdg-agora]');
    var atual = 0;

    function mostra(i) {
      if (i < 0 || i >= slides.length) return;
      atual = i;
      slides.forEach(function (s, k) { s.classList.toggle('am-on', k === i); });
      minis.forEach(function (b, k) {
        b.classList.toggle('am-on', k === i);
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
        b.tabIndex = k === i ? 0 : -1;
      });
      if (agoraEl) agoraEl.textContent = (i < 9 ? '0' : '') + (i + 1);
      /* no celular o palco é carrossel: rolar até a foto */
      if (!computador.matches && trilho) {
        trilho.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      }
    }
    minis.forEach(function (b, k) {
      b.tabIndex = k === 0 ? 0 : -1;
      b.addEventListener('click', function () { mostra(k); });
      b.addEventListener('keydown', function (e) {
        var d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = (k + d + minis.length) % minis.length;
        mostra(n);
        minis[n].focus();
      });
    });

    /* zoom que segue o mouse — só com mouse fino e no computador */
    var mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (palco && mouse.matches) {
      palco.classList.add('am-pdg--pode');
      var mira = function (e) {
        var img = slides[atual] && slides[atual].querySelector('img');
        if (!img) return;
        var r = img.getBoundingClientRect();
        var x = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
        var y = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
        img.style.transformOrigin = x + '% ' + y + '%';
      };
      palco.addEventListener('click', function (e) {
        if (!computador.matches) return;
        if (e.target.closest('button,a')) return;
        var liga = !palco.classList.contains('am-pdg--zoom');
        palco.classList.toggle('am-pdg--zoom', liga);
        if (liga) mira(e);
      });
      palco.addEventListener('mousemove', function (e) {
        if (palco.classList.contains('am-pdg--zoom')) mira(e);
      });
      palco.addEventListener('mouseleave', function () { palco.classList.remove('am-pdg--zoom'); });
    }

    /* celular: a foto em que o trilho parou vira a atual (sem ouvir scroll no
       window, que no Horizon não dispara) */
    if (trilho && 'IntersectionObserver' in window && slides.length > 1) {
      var vis = new IntersectionObserver(function (ents) {
        if (computador.matches) return;
        ents.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) {
            var k = Array.prototype.indexOf.call(slides, en.target);
            atual = k;
          }
        });
      }, { root: trilho, threshold: [0.6] });
      slides.forEach(function (s) { vis.observe(s); });
    }
    /* celular: as miniaturas seguem o trilho (e o trilho segue elas). Cada
       slide tem a largura do trilho, então o índice é a rolagem dividida pela
       largura, sem a conta por passo que nunca acende o último (armadilha
       40). A fileira rola sozinha para a ativa ficar à vista, mexendo só no
       scrollLeft DELA; scrollIntoView puxaria a página junto. */
    var tira = raiz.querySelector('[data-am-pdg-tira]');
    var tiras = raiz.querySelectorAll('[data-am-pdgt]');
    if (trilho && tira && tiras.length > 1) {
      /* `alvo`: no toque a foto desliza até lá, e no caminho o trilho passa
         pelas do meio; sem isso elas piscariam acesas uma a uma */
      var marcada = 0, pedido = 0, alvo = -1, alvoAte = 0;
      var marca = function (k) {
        if (k === marcada) return;
        marcada = k;
        tiras.forEach(function (b, j) {
          var on = j === k;
          b.classList.toggle('am-on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        var b = tiras[k];
        var esq = b.offsetLeft, dir = esq + b.offsetWidth;
        if (esq < tira.scrollLeft + 8 || dir > tira.scrollLeft + tira.clientWidth - 8) {
          tira.scrollTo({ left: esq - (tira.clientWidth - b.offsetWidth) / 2, behavior: 'smooth' });
        }
      };
      var segue = function () {
        pedido = 0;
        var w = trilho.clientWidth;
        if (!w) return;
        var i = Math.max(0, Math.min(tiras.length - 1, Math.round(trilho.scrollLeft / w)));
        if (alvo > -1 && Date.now() < alvoAte) {
          if (i !== alvo) return;
          alvo = -1;
        }
        marca(i);
      };
      trilho.addEventListener('scroll', function () {
        if (!pedido) pedido = requestAnimationFrame(segue);
      }, { passive: true });
      var vai = function (k) {
        alvo = k; alvoAte = Date.now() + 900;
        marca(k); mostra(k);
      };
      tiras.forEach(function (b, k) {
        b.addEventListener('click', function () { vai(k); });
        b.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = (k + d + tiras.length) % tiras.length;
          vai(n);
          tiras[n].focus();
        });
      });
    }

    /* virou computador de novo: volta a valer a foto marcada */
    var aoMudar = function () { if (computador.matches) mostra(atual); };
    if (computador.addEventListener) computador.addEventListener('change', aoMudar);

    /* ------------------------------------------------ variantes */
    var variantes = [];
    try {
      var js = raiz.querySelector('[data-am-pdp-vars]');
      if (js) variantes = JSON.parse(js.textContent);
    } catch (e) { variantes = []; }
    var campoId = raiz.querySelector('[data-am-id]');
    var campoQtd = raiz.querySelector('[data-am-qtd-campo]');
    var botao = raiz.querySelector('[data-am-comprar]');
    var botaoRot = raiz.querySelector('[data-am-comprar-rot]');
    var rotuloComprar = botaoRot ? botaoRot.textContent : '';
    var totalEl = raiz.querySelector('[data-am-pdp-total]');
    var precoEl = raiz.querySelector('[data-am-pdp-preco]');
    var deEl = raiz.querySelector('[data-am-pdp-de]');
    var ecoEl = raiz.querySelector('[data-am-pdp-econ]');
    var erroEl = raiz.querySelector('[data-am-pdp-erro]');
    var pixEl = raiz.querySelector('[data-am-pdp-pix]');
    var pixTotEl = raiz.querySelector('[data-am-pdp-pix-total]');
    var pixContaEl = raiz.querySelector('[data-am-pdp-pix-conta]');
    var pixUnit = pixEl ? Number(pixEl.getAttribute('data-am-pdp-pix')) : 0;

    function varAtual() {
      var id = campoId ? Number(campoId.value) : 0;
      for (var i = 0; i < variantes.length; i++) if (variantes[i].id === id) return variantes[i];
      return variantes[0];
    }
    function qtd() {
      var n = campoQtd ? parseInt(campoQtd.value, 10) : 1;
      if (!n || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }
    function pintaPreco() {
      var v = varAtual();
      if (!v) return;
      if (precoEl) precoEl.textContent = v.fmt;
      var tem = v.de && v.de > v.preco;
      if (deEl) { deEl.hidden = !tem; if (tem) deEl.textContent = v.defmt; }
      if (ecoEl) { ecoEl.hidden = !tem; if (tem) ecoEl.textContent = 'economize ' + v.eco; }
      if (totalEl) totalEl.textContent = moeda(v.preco * qtd());
      if (pixUnit && pixTotEl) {
        var n = qtd();
        pixTotEl.textContent = moeda(pixUnit * n);
        /* de 2 em diante, mostra a conta: "9 × R$ 73,31" */
        if (pixContaEl) {
          pixContaEl.hidden = n < 2;
          if (n >= 2) pixContaEl.textContent = n + ' × ' + moeda(pixUnit);
        }
      }
      if (botao) {
        botao.disabled = !v.ok;
        if (botaoRot) botaoRot.textContent = v.ok ? rotuloComprar : 'Esgotado';
      }
    }

    raiz.querySelectorAll('[data-am-var]').forEach(function (b) {
      b.addEventListener('click', function () {
        raiz.querySelectorAll('[data-am-var]').forEach(function (o) {
          o.classList.remove('am-on');
          o.setAttribute('aria-pressed', 'false');
        });
        b.classList.add('am-on');
        b.setAttribute('aria-pressed', 'true');
        if (campoId) campoId.value = b.getAttribute('data-am-var');
        var u = new URL(window.location.href);
        u.searchParams.set('variant', b.getAttribute('data-am-var'));
        window.history.replaceState({}, '', u);
        pintaPreco();
      });
    });

    /* ------------------------------------------------ quantidade */
    raiz.querySelectorAll('[data-am-qtd]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!campoQtd) return;
        campoQtd.value = Math.min(99, Math.max(1, qtd() + Number(b.getAttribute('data-am-qtd'))));
        pintaPreco();
        /* a barra fixa de comprar espelha a quantidade pelo `change` do campo */
        campoQtd.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (campoQtd) {
      campoQtd.addEventListener('input', pintaPreco);
      campoQtd.addEventListener('change', function () { campoQtd.value = qtd(); pintaPreco(); });
    }

    /* ------------------------------------------------ pôr na sacola
       Sem JS o formulário vai para /cart. Com JS: /cart/add.js e a gaveta
       da casa (`amana-carrinho`) abre pelo evento `amana:cart:open`. */
    var forma = raiz.querySelector('#am-forma-produto');
    if (forma && window.fetch) {
      forma.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!botao || botao.disabled) return;
        var v = varAtual();
        if (!v) return;
        botao.disabled = true;
        botao.classList.add('am-pdp--indo');
        if (erroEl) erroEl.hidden = true;
        fetch(lojaRaiz() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qtd() }] })
        }).then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok) throw new Error(d && (d.description || d.message) || 'Não deu para adicionar agora.');
            return d;
          });
        }).then(function () {
          document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', { bubbles: true, detail: { source: 'amana-produto' } }));
          document.dispatchEvent(new CustomEvent('amana:cart:open', { bubbles: true }));
          botao.classList.remove('am-pdp--indo');
          botao.classList.add('am-pdp--foi');
          if (botaoRot) botaoRot.textContent = 'Na sacola!';
          setTimeout(function () {
            botao.classList.remove('am-pdp--foi');
            if (botaoRot) botaoRot.textContent = rotuloComprar;
            botao.disabled = false;
          }, 1800);
        }).catch(function (err) {
          botao.classList.remove('am-pdp--indo');
          botao.disabled = false;
          if (erroEl) { erroEl.textContent = err.message; erroEl.hidden = false; }
        });
      });
    }

    /* ------------------------------------------------ sanfonas */
    /* `alvoDet`, não `alvo`: a galeria acima usa `var alvo` (um número) no
       mesmo escopo, e o `var` é um só — depois de deslizar as fotos o link
       "Ingredientes e detalhes" chamava scrollIntoView num número e morria
       (Clarity, 20/10: "alvo.scrollIntoView is not a function"). */
    var leva = raiz.querySelector('[data-am-leva]');
    var alvoDet = raiz.querySelector('[data-am-alvo-detalhes]') || raiz.querySelector('.am-pdp__item');
    if (leva && alvoDet) {
      leva.addEventListener('click', function () {
        alvoDet.open = true;
        alvoDet.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    var itens = raiz.querySelectorAll('.am-pdp__item');
    itens.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        itens.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  })();

  /* cupom: copiar + guardar na sessão */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-am-cupom-copia]');
    if (!b) return;
    var cx = b.closest('[data-am-cupom]'); var cod = cx ? cx.getAttribute('data-am-cupom') : '';
    var rot = b.querySelector('[data-am-cupom-rot]');
    function ok() { if (rot) rot.textContent = 'Copiado!'; b.classList.add('am-feito');
      setTimeout(function () { if (rot) rot.textContent = cod; b.classList.remove('am-feito'); }, 2200); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(cod).then(ok, ok);
    else { var t = document.createElement('textarea'); t.value = cod; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {} t.remove(); ok(); }
    if (!b.dataset.amCupomGuardado && window.fetch) { b.dataset.amCupomGuardado = '1';
      fetch('/discount/' + encodeURIComponent(cod), { credentials: 'same-origin' }).catch(function () {}); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-receita"] && !Shopify.designMode) return;
  try {
    
  /* Receita: caligrafia, tinta, porcoes, riscos, cronometro e cesta.

     Nada aqui escuta `scroll` no window: o Horizon poe overflow:hidden no
     html/body em telas >=990px e a rolagem acontece dentro de .page-wrapper.
     IntersectionObserver funciona nos dois casos. */
  (function () {
    var raiz = document.querySelector('[data-am-receita]');
    if (!raiz) return;

    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function raizLoja() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    /* ---------------------------------------------- 1. caligrafia

       O alfabeto entra por <script defer> e o codigo da secao entra pelo pacote
       de {% javascript %}. A ordem entre os dois nao e garantida, entao nao da
       para assumir que a biblioteca ja esta la — espera por ela. */
    function comCaligrafia(cb) {
      if (window.AmanaCaligrafia) { cb(); return; }
      var t = setInterval(function () {
        if (window.AmanaCaligrafia) { clearInterval(t); cb(); }
      }, 60);
      setTimeout(function () { clearInterval(t); }, 8000);
    }

    function escrever(el) {
      /* o sinalizador NAO pode se chamar amFeito: dataset.amFeito escreve o
         atributo data-am-feito, que e o gancho do botao de passo concluido —
         a marcacao de passo parava de funcionar em silencio */
      if (el.dataset.amJaEscrito) return;
      el.dataset.amJaEscrito = '1';
      comCaligrafia(function () { escreverAgora(el); });
    }

    function escreverAgora(el) {
      var A = window.AmanaCaligrafia;
      var texto = el.dataset.amEscrever;
      if (!A || !texto) { return; }
      var alvo = document.createElement('span');
      alvo.className = 'am-rc__calig';
      el.appendChild(alvo);
      el.classList.add('am-rc__escrito');
      /* o corpo sai da largura disponivel, nao de um numero fixo: titulo longo
         em coluna estreita com corpo fixo vira quatro linhas gigantes */
      var teto = parseInt(el.dataset.amTam || '44', 10);
      var largura = (el.clientWidth || 600) - 4;
      var m = A.caber(texto, largura, {
        max: teto, min: Math.min(22, teto), maxLinhas: parseInt(el.dataset.amLinhas || '2', 10)
      });
      A.animar(alvo, texto, {
        tamanho: m.tamanho, larguraMax: m.larguraMax, tremor: 0.85,
        espessura: m.tamanho > 50 ? 4.4 : 5.2, instantaneo: reduz,
        cor: el.dataset.amCor || undefined
      });
    }

    /* ------------------------------------- 2. tinta palavra a palavra

       O atraso por palavra e DIVIDIDO pelo tamanho do paragrafo, com teto: com
       atraso fixo de 26ms + 7ms por letra, um passo de quarenta palavras levava
       quase dois segundos e as ultimas palavras ficavam cinzas na tela por
       tempo suficiente para parecer bug de renderizacao. */
    var TINTA_MS = 460;
    function tintar(el) {
      if (el.dataset.amTintado) return;
      el.dataset.amTintado = '1';
      var palavras = el.textContent.split(/(\s+)/);
      var quantas = palavras.filter(function (p) { return p.trim(); }).length || 1;
      el.textContent = '';
      var passo = Math.min(34, TINTA_MS / quantas);
      var criados = [];
      var atraso = 0;
      palavras.forEach(function (p) {
        if (!p.trim()) { el.appendChild(document.createTextNode(p)); return; }
        var s = document.createElement('span');
        s.className = 'am-rc__tinta-p';
        s.textContent = p;
        el.appendChild(s);
        criados.push(s);
        if (reduz) { s.classList.add('am-rc-vis'); return; }
        atraso += passo;
        setTimeout(function () { s.classList.add('am-rc-vis'); }, atraso);
      });
      /* rede de seguranca: aba em segundo plano engole setTimeout, e paragrafo
         que fica meio cinza para sempre parece defeito */
      if (!reduz) {
        setTimeout(function () {
          criados.forEach(function (s) { s.classList.add('am-rc-vis'); });
        }, TINTA_MS + 500);
      }
    }

    /* -------------------------------- 3. quem entra na tela, acontece */
    var animaveis = '[data-am-escrever],[data-am-tinta],[data-am-rv]';
    function acontece(el) {
      el.classList.add('am-vis');
      if (el.dataset.amEscrever != null) escrever(el);
      if (el.dataset.amTinta != null) tintar(el);
      el.querySelectorAll('[data-am-tinta]').forEach(tintar);
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.bottom > 0) return;
        acontece(e.target);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    raiz.querySelectorAll(animaveis).forEach(function (el) { obs.observe(el); });

    /* resgate: quem abre a pagina ja rolada deixa acima da tela elementos que
       nunca vao cruzar observer nenhum. So o que ficou PARA TRAS — a condicao
       antiga (`top < innerHeight`) revelava a pagina inteira aos 600ms e
       anulava o observer. */
    function resgata() {
      raiz.querySelectorAll(animaveis).forEach(function (el) {
        if (el.classList.contains('am-vis')) return;
        if (el.getBoundingClientRect().bottom < 0) { acontece(el); obs.unobserve(el); }
      });
    }
    setTimeout(resgata, 400);
    window.addEventListener('load', resgata);

    /* ------------------------------------------------- 4. porcoes */
    var base = parseInt(raiz.dataset.porcoes || '2', 10) || 2;
    var atual = base;
    var elN = raiz.querySelector('[data-am-porcoes-n]');
    var elRot = raiz.querySelector('[data-am-porcoes-rotulo]');

    /* fracao com cara de receita, nao de planilha */
    var FRACAO = { 0.25: '¼', 0.33: '⅓', 0.5: '½', 0.66: '⅔', 0.75: '¾' };
    function bonito(v) {
      if (!isFinite(v)) return '';
      var inteiro = Math.floor(v + 1e-9), resto = v - inteiro;
      var chave = null, menor = 0.06;
      Object.keys(FRACAO).forEach(function (k) {
        var d = Math.abs(resto - parseFloat(k));
        if (d < menor) { menor = d; chave = k; }
      });
      if (chave) return (inteiro ? inteiro : '') + FRACAO[chave];
      if (Math.abs(resto) < 0.06) return String(inteiro);
      return (Math.round(v * 10) / 10).toString().replace('.', ',');
    }

    /* o que nao escala: pitada nao vira uma pitada e meia, e ramo nao vira ramo
       e um terco. Dobrar a receita nao dobra o tempero a olho. */
    var FIXAS = /^(pitada|pitadas|a gosto|ramo|ramos|q\.b\.|qb)$/i;

    function recalcular() {
      var fator = atual / base;
      raiz.querySelectorAll('[data-am-base]').forEach(function (el) {
        var b = parseFloat((el.dataset.amBase || '').replace(',', '.'));
        if (!isFinite(b)) return;          // "a gosto" e afins ficam como estao
        var un = el.parentNode.querySelector('.am-rc__un');
        if (un && FIXAS.test(un.textContent.trim())) {
          el.textContent = el.dataset.amBase;
          return;
        }
        el.textContent = bonito(b * fator);
      });
      if (elN) elN.textContent = atual;
      if (elRot) elRot.textContent = atual + (atual === 1 ? ' porção' : ' porções');
    }

    raiz.querySelectorAll('[data-am-porcoes]').forEach(function (b) {
      b.addEventListener('click', function () {
        atual = Math.min(12, Math.max(1, atual + parseInt(b.dataset.amPorcoes, 10)));
        recalcular();
      });
    });
    /* uma passada logo de cara: e o que troca "0.5" por "½" antes de alguem
       clicar em qualquer coisa */
    recalcular();

    /* ------------------------------------------ 5. lista de compras */
    var caixas = [].slice.call(raiz.querySelectorAll('[data-am-ing]'));
    var conta = raiz.querySelector('[data-am-conta]');
    var limpar = raiz.querySelector('[data-am-limpar]');
    function contar() {
      var n = caixas.filter(function (c) { return c.checked; }).length;
      if (conta) conta.textContent = n;
      if (limpar) limpar.hidden = n === 0;
    }
    caixas.forEach(function (c) { c.addEventListener('change', contar); });
    if (limpar) limpar.addEventListener('click', function () {
      caixas.forEach(function (c) { c.checked = false; });
      contar();
    });

    /* --------------------------------------------- 6. passos feitos */
    raiz.querySelectorAll('[data-am-feito]').forEach(function (b) {
      b.addEventListener('click', function () {
        var li = b.closest('[data-am-passo]');
        if (li) li.classList.toggle('am-rc-feito');
      });
    });

    /* ------------------------------------------------ 7. cronometro */
    raiz.querySelectorAll('[data-am-timer]').forEach(function (b) {
      var total = parseInt(b.dataset.amTimer, 10) * 60;
      var rot = b.querySelector('[data-am-timer-rot]');
      var resta = total, id = null;
      function pinta() {
        var m = Math.floor(resta / 60), s = resta % 60;
        rot.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      }
      b.addEventListener('click', function () {
        if (id) {                                   // rodando -> zera
          clearInterval(id); id = null; resta = total;
          b.classList.remove('am-rc-correndo', 'am-rc-fim');
          rot.textContent = (total / 60) + ' min';
          return;
        }
        b.classList.add('am-rc-correndo');
        pinta();
        id = setInterval(function () {
          resta--;
          if (resta <= 0) {
            clearInterval(id); id = null;
            b.classList.remove('am-rc-correndo');
            b.classList.add('am-rc-fim');
            rot.textContent = 'pronto!';
            var li = b.closest('[data-am-passo]');
            if (li) li.classList.add('am-rc-feito');
            return;
          }
          pinta();
        }, 1000);
      });
    });

    /* ------------------------------------------------- 8. imprimir */
    var imp = raiz.querySelector('[data-am-imprimir]');
    if (imp) imp.addEventListener('click', function () { window.print(); });

    /* --------------------------------------------- 9. pôr na sacola */
    function moeda(centavos) {
      try {
        return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      } catch (e) { return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ','); }
    }

    function manda(itens) {
      return fetch(raizLoja() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: itens })
      }).then(function (r) {
        if (!r.ok) throw new Error('carrinho');
        /* o resto do tema ouve este evento: contador do header, gaveta */
        document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', { bubbles: true }));
        return r.json();
      });
    }
    function abreGaveta() {
      document.dispatchEvent(new CustomEvent('amana:cart:open', { bubbles: true }));
    }

    function confirma(b, texto) {
      var antes = b.dataset.amRotulo || b.textContent;
      b.dataset.amRotulo = antes;
      b.classList.add('am-rc-feito');
      b.textContent = texto;
      setTimeout(function () {
        b.classList.remove('am-rc-feito');
        b.textContent = antes;
        b.disabled = false;
      }, 1900);
    }

    /* o botao do cartao do ingrediente essencial */
    raiz.querySelectorAll('[data-am-rc-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        b.disabled = true;
        manda([{ id: Number(b.dataset.amRcAdd), quantity: 1 }])
          .then(function () { confirma(b, 'Na sacola'); abreGaveta(); })
          .catch(function () { b.disabled = false; });
      });
    });

    /* a cesta do fecho: quantidade por linha, total ao vivo, um pedido so */
    var cesta = raiz.querySelector('[data-am-rc-cesta]');
    if (cesta) {
      var linhas = [].slice.call(cesta.querySelectorAll('[data-am-rc-linha]'));
      var elTotal = cesta.querySelector('[data-am-rc-total]');
      var elFrete = cesta.querySelector('[data-am-rc-frete]');
      var btnTudo = cesta.querySelector('[data-am-rc-tudo]');
      var limiar = parseInt(raiz.dataset.amLimiar || '0', 10) || 0;

      function somaTotal() {
        var total = 0;
        linhas.forEach(function (l) {
          var q = parseInt(l.dataset.amRcQtd, 10) || 0;
          total += q * (parseInt(l.dataset.amRcPreco, 10) || 0);
          l.classList.toggle('am-rc__ci--zero', q === 0);
        });
        if (elTotal) elTotal.textContent = moeda(total);
        /* faltando pouco, dizer QUANTO falta vale mais do que não dizer nada:
           é a diferença entre "não deu" e "falta um item pequeno" */
        if (elFrete) {
          if (limiar <= 0 || total === 0) {
            elFrete.hidden = true;
          } else if (total >= limiar) {
            elFrete.hidden = false;
            elFrete.classList.remove('am-rc__falta');
            elFrete.textContent = 'com frete grátis';
          } else {
            elFrete.hidden = false;
            elFrete.classList.add('am-rc__falta');
            elFrete.textContent = 'faltam ' + moeda(limiar - total) + ' para o frete grátis';
          }
        }
        if (btnTudo) btnTudo.disabled = total === 0;
      }

      cesta.addEventListener('click', function (e) {
        var b = e.target.closest('[data-am-rc-menos],[data-am-rc-mais]');
        if (!b) return;
        var l = b.closest('[data-am-rc-linha]');
        if (!l) return;
        var q = parseInt(l.dataset.amRcQtd, 10) || 0;
        q = Math.max(0, Math.min(20, q + (b.hasAttribute('data-am-rc-mais') ? 1 : -1)));
        l.dataset.amRcQtd = q;
        var n = l.querySelector('[data-am-rc-n]');
        if (n) n.textContent = q;
        somaTotal();
      });

      if (btnTudo) btnTudo.addEventListener('click', function () {
        var itens = linhas
          .map(function (l) {
            return { id: Number(l.dataset.amRcId), quantity: parseInt(l.dataset.amRcQtd, 10) || 0 };
          })
          .filter(function (i) { return i.quantity > 0; });
        if (!itens.length) return;
        btnTudo.disabled = true;
        manda(itens)
          .then(function () { confirma(btnTudo, 'Na sacola'); abreGaveta(); })
          .catch(function () { btnTudo.disabled = false; });
      });

      somaTotal();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-receitas-indice"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('.am-rx');
    if (!raiz) return;
    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* --- caligrafia do titulo (o alfabeto pode chegar depois deste codigo) */
    function comCaligrafia(cb) {
      if (window.AmanaCaligrafia) { cb(); return; }
      var t = setInterval(function () {
        if (window.AmanaCaligrafia) { clearInterval(t); cb(); }
      }, 60);
      setTimeout(function () { clearInterval(t); }, 8000);
    }
    var tit = raiz.querySelector('[data-am-escrever]');
    if (tit) comCaligrafia(function () {
      var alvo = document.createElement('span');
      alvo.className = 'am-rx__calig';
      tit.appendChild(alvo);
      tit.classList.add('am-rx__escrito');
      var teto = parseInt(tit.dataset.amTam || '60', 10);
      var m = window.AmanaCaligrafia.caber(tit.dataset.amEscrever, (tit.clientWidth || 700) - 4, {
        max: teto, min: 26, maxLinhas: parseInt(tit.dataset.amLinhas || '2', 10)
      });
      window.AmanaCaligrafia.animar(alvo, tit.dataset.amEscrever, {
        tamanho: m.tamanho, larguraMax: m.larguraMax, tremor: 0.85,
        espessura: 4.6, instantaneo: reduz
      });
    });

    /* --- entrada por rolagem (o Horizon nao rola no window) */
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.bottom > 0) return;
        e.target.classList.add('am-vis');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
    raiz.querySelectorAll('[data-am-rv]').forEach(function (el) { obs.observe(el); });
    setTimeout(function () {
      raiz.querySelectorAll('[data-am-rv]:not(.am-vis)').forEach(function (el) {
        if (el.getBoundingClientRect().top < (window.innerHeight || 800)) el.classList.add('am-vis');
      });
    }, 600);

    /* --- filtros por categoria */
    var chips = [].slice.call(raiz.querySelectorAll('[data-am-filtro]'));
    var cels = [].slice.call(raiz.querySelectorAll('[data-am-cat]'));
    var vazio = raiz.querySelector('[data-am-vazio]');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (o) { o.classList.toggle('am-rx-on', o === c); });
        var alvo = c.dataset.amFiltro;
        var n = 0;
        cels.forEach(function (li) {
          var ok = alvo === 'todas' || li.dataset.amCat === alvo;
          li.hidden = !ok;
          if (ok) n++;
        });
        if (vazio) vazio.hidden = n > 0;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-receitas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.am-receitas').forEach(function (sec) {
      var pills = sec.querySelectorAll('[data-am-filtro]');
      var cards = sec.querySelectorAll('[data-am-tags]');
      var trilho = sec.querySelector('[data-am-trilho]');

      pills.forEach(function (b) {
        b.addEventListener('click', function () {
          var alvo = (b.getAttribute('data-am-filtro') || '').trim().toLowerCase();
          pills.forEach(function (o) { o.classList.toggle('am-on', o === b); });
          cards.forEach(function (c) {
            var tags = (c.getAttribute('data-am-tags') || '').toLowerCase();
            c.hidden = alvo !== '' && alvo !== 'todas' && tags.indexOf(alvo) === -1;
          });
          if (trilho) trilho.scrollLeft = 0;
        });
      });

      sec.querySelectorAll('[data-am-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (trilho) trilho.scrollBy({ left: Number(b.getAttribute('data-am-dir')) * trilho.clientWidth, behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-resultados"]) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-rs]');
    if (!raiz) return;
    var alvos = raiz.querySelectorAll('[data-am-rv]');
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      alvos.forEach(function (e) { e.classList.add('am-vis'); });
      return;
    }
    var ob = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('am-vis');
        ob.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: .05 });
    alvos.forEach(function (e) { ob.observe(e); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-social"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Entrada do celular da home (variante "lado"). Quem abre a página já
       rolada tem o que ficou ACIMA da tela revelado na hora. */
    function liga(sec) {
      if (sec.__amSo) return;
      sec.__amSo = true;
      var tit = sec.querySelector('.am-so__tit');
      if (!tit || !('IntersectionObserver' in window)) return;
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var pal = tit.textContent.trim().split(/\s+/);
      tit.textContent = '';
      pal.forEach(function (w, i) {
        var m = document.createElement('span');
        m.className = 'am-so__p';
        var d = document.createElement('span');
        d.style.setProperty('--i', i);
        d.textContent = w;
        m.appendChild(d);
        tit.appendChild(m);
        if (i < pal.length - 1) tit.appendChild(document.createTextNode(' '));
      });
      sec.classList.add('am-so--js');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting || e.boundingClientRect.bottom < 0) {
            sec.classList.add('am-so--on');
            io.disconnect();
          }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      io.observe(tit);
    }
    function tudo() {
      document.querySelectorAll('.am-social--lado').forEach(liga);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo);
    else tudo();
    document.addEventListener('shopify:section:load', tudo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-tempo-viagem"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-am-tv]');
    if (!raiz) return;
    var pista = raiz.querySelector('[data-am-tv-pista]');
    var trilho = raiz.querySelector('[data-am-tv-trilho]');
    var eras = [].slice.call(raiz.querySelectorAll('[data-am-tv-era]'));
    var chips = [].slice.call(raiz.querySelectorAll('[data-am-tv-ir]'));
    var setas = [].slice.call(raiz.querySelectorAll('[data-am-tv-passo]'));
    var fotos = [].slice.call(raiz.querySelectorAll('[data-am-tv-foto]'));
    if (!pista || !eras.length) return;

    var calmo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var atual = 0;

    /* ---------------------------------------- 1. a viagem entre épocas */
    function larguraEra() { return trilho.clientWidth; }

    function ir(i, instantaneo) {
      i = Math.max(0, Math.min(eras.length - 1, i));
      var salto = Math.abs(i - atual);
      atual = i;

      /* duração e borrão saem da DISTÂNCIA: pular de 2020 para hoje não pode
         custar o mesmo que andar uma época */
      var ms = instantaneo || calmo ? 0 : Math.min(1500, 620 + salto * 210);
      var borrao = instantaneo || calmo ? 0 : Math.min(7, salto * 1.9);

      raiz.style.setProperty('--tv-borrao', borrao.toFixed(1) + 'px');
      pista.style.transition = ms
        ? 'transform ' + ms + 'ms cubic-bezier(.62,.02,.2,1)'
        : 'none';
      pista.style.transform = 'translate3d(' + (-i * larguraEra()) + 'px,0,0)';

      if (borrao > 0.2) {
        raiz.classList.add('am-tv--viajando');
        clearTimeout(ir._t);
        ir._t = setTimeout(function () {
          raiz.classList.remove('am-tv--viajando');
        }, ms - 120);
      }

      chips.forEach(function (c, k) {
        c.classList.toggle('am-on', k === i);
        c.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      eras.forEach(function (e, k) {
        if (k === i) e.removeAttribute('aria-hidden');
        else e.setAttribute('aria-hidden', 'true');
      });
      setas.forEach(function (s) {
        var d = parseInt(s.dataset.amTvPasso, 10);
        s.disabled = (d < 0 && i === 0) || (d > 0 && i === eras.length - 1);
      });
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () { ir(parseInt(c.dataset.amTvIr, 10)); });
    });
    setas.forEach(function (s) {
      s.addEventListener('click', function () { ir(atual + parseInt(s.dataset.amTvPasso, 10)); });
    });
    raiz.addEventListener('keydown', function (e) {
      if (!e.target.closest('[data-am-tv-ir]')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); ir(atual + 1); chips[atual].focus(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); ir(atual - 1); chips[atual].focus(); }
    });
    window.addEventListener('resize', function () { ir(atual, true); });
    ir(0, true);

    /* -------------------------------- 2. as fotos seguem o ponteiro */
    /* Cada foto anda o tanto da sua PROFUNDIDADE. Se todas andarem igual não é
       parallax, é o bloco inteiro deslizando — e o olho percebe na hora. */
    var mx = 0, my = 0, ax = 0, ay = 0, quadro = null, perto = false;

    function passo() {
      quadro = null;
      ax += (mx - ax) * 0.085;
      ay += (my - ay) * 0.085;
      for (var i = 0; i < fotos.length; i++) {
        var p = parseFloat(fotos[i].style.getPropertyValue('--p')) || 0.5;
        fotos[i].style.translate =
          (ax * 34 * p).toFixed(2) + 'px ' + (ay * 20 * p).toFixed(2) + 'px';
      }
      if (Math.abs(mx - ax) > 0.001 || Math.abs(my - ay) > 0.001) agenda();
    }
    function agenda() { if (!quadro) quadro = requestAnimationFrame(passo); }

    if (!calmo && window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      raiz.addEventListener('mouseenter', function () {
        perto = true;
        raiz.classList.add('am-tv--segue');
      });
      raiz.addEventListener('mousemove', function (e) {
        if (!perto) return;
        var r = raiz.getBoundingClientRect();
        mx = ((e.clientX - r.left) / r.width) * 2 - 1;     // -1 .. 1
        my = ((e.clientY - r.top) / r.height) * 2 - 1;
        agenda();
      }, { passive: true });
      raiz.addEventListener('mouseleave', function () {
        perto = false;
        /* a volta é com transição: sem ela as fotos estalam de volta ao lugar */
        raiz.classList.remove('am-tv--segue');
        mx = 0; my = 0;
        fotos.forEach(function (f) { f.style.translate = '0px 0px'; });
        ax = 0; ay = 0;
      });
    }

    /* ------------------------------------------------ 3. arrastar */
    var x0 = null, movido = 0;
    function pegaX(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
    function comeca(e) {
      if (e.target.closest('a,button')) return;
      x0 = pegaX(e); movido = 0;
      trilho.classList.add('am-tv--puxando');
    }
    function anda(e) {
      if (x0 === null) return;
      movido = pegaX(e) - x0;
      pista.style.transition = 'none';
      pista.style.transform =
        'translate3d(' + (-atual * larguraEra() + movido * 0.85) + 'px,0,0)';
    }
    function acaba() {
      if (x0 === null) return;
      trilho.classList.remove('am-tv--puxando');
      var limite = larguraEra() * 0.16;
      var destino = atual;
      if (movido < -limite) destino = atual + 1;
      else if (movido > limite) destino = atual - 1;
      x0 = null;
      /* `ir` reposiciona sempre, inclusive quando o destino é a própria época:
         é assim que o arrasto curto volta sozinho para o lugar */
      ir(destino, false);
    }
    trilho.addEventListener('mousedown', comeca);
    window.addEventListener('mousemove', anda, { passive: true });
    window.addEventListener('mouseup', acaba);
    trilho.addEventListener('touchstart', comeca, { passive: true });
    trilho.addEventListener('touchmove', anda, { passive: true });
    trilho.addEventListener('touchend', acaba);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-trava"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var trava = document.querySelector('[data-am-trava]');
    if (!trava) return;
    // O Horizon rola dentro de .page-wrapper (html/body ficam overflow:hidden em >=990px).
    var raiz = (function () {
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 4) return pw;
      return window;
    })();
    var linhaA = trava.querySelector('[data-am-linha-a]');
    var linhaB = trava.querySelector('[data-am-linha-b]');
    var fenda = trava.querySelector('[data-am-fenda]');
    var leque = trava.querySelector('[data-am-leque]');
    var tit = trava.querySelector('[data-am-tit]');

    var fixa = trava.querySelector('.am-trava__fixa');
    var fundo = trava.querySelector('.am-trava__fundo');
    var grade = trava.querySelector('[data-am-tc-grade]');
    var itens = Array.prototype.slice.call(leque.querySelectorAll('[data-am-item]'));

    /* Celular (<=749px) tem desenho proprio — o da "featured products" da
       Bragg. Os mesmos elementos, outra coreografia: o ramo e escolhido a cada
       quadro, e quem troca de ramo limpa o que o outro escreveu. */
    var celularMq = window.matchMedia('(max-width: 749px)');
    function ehCelular() { return celularMq.matches; }

    /* ---------------- dica de produto no hover ----------------
       Cada pacote vira alvo: ele sobe e balanca, os vizinhos abrem espaco e
       recuam, e a dica abre por cima. So liga depois que o leque assenta na
       rolagem (am-vivo), senao o mouse parado ja dispara tudo no meio da
       animacao de entrada. */
    var focado = -1;

    function apagaDica() {
      if (focado < 0) return;
      focado = -1;
      itens.forEach(function (it) {
        it.classList.remove('am-foco');
        it.style.removeProperty('--am-dir');
      });
      leque.classList.remove('am-alvo');
      if (fixa) fixa.classList.remove('am-dica-on');
    }

    /* A dica e contra-escalada, entao px de layout nao e px de tela. Em vez de
       confiar na conta da escala, empurra e mede de novo: duas passadas bastam
       para encostar o cartao na margem sem estourar a borda da janela. */
    function encaixa(it) {
      var d = it.querySelector('[data-am-dica]');
      if (!d) return;
      var cx = d.firstElementChild;
      if (!cx) return;
      d.style.setProperty('--am-desl', '0px');
      var m = 16, soma = 0;
      for (var passo = 0; passo < 3; passo++) {
        var r = cx.getBoundingClientRect();
        if (!r.width) return;
        var dx = 0;
        if (r.left < m) dx = m - r.left;
        else if (r.right > window.innerWidth - m) dx = (window.innerWidth - m) - r.right;
        if (Math.abs(dx) < 0.6) break;
        var fator = r.width / (cx.offsetWidth || r.width);
        soma += dx / (fator || 1);
        d.style.setProperty('--am-desl', soma.toFixed(1) + 'px');
      }
    }

    function acendeDica(i) {
      if (focado === i) return;
      focado = i;
      itens.forEach(function (it, k) {
        it.classList.toggle('am-foco', k === i);
        it.style.setProperty('--am-dir', k === i ? 0 : (k < i ? -1 : 1));
      });
      leque.classList.add('am-alvo');
      if (fixa) fixa.classList.add('am-dica-on');
      encaixa(itens[i]);
    }

    var fino = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

    itens.forEach(function (it, k) {
      if (fino) {
        it.addEventListener('mouseenter', function () {
          if (leque.classList.contains('am-vivo')) acendeDica(k);
        });
        it.addEventListener('mouseleave', apagaDica);
        /* teclado: o link do pacote recebe foco e a dica abre junto */
        it.addEventListener('focusin', function () { acendeDica(k); });
        it.addEventListener('focusout', apagaDica);
      } else {
        /* toque: o primeiro toque abre a dica, o segundo segue o link.
           No celular a dica nao existe (o pacote e link direto). */
        it.addEventListener('click', function (e) {
          if (ehCelular()) return;
          if (!leque.classList.contains('am-vivo')) return;
          if (focado !== k) { e.preventDefault(); acendeDica(k); }
        });
      }
    });

    if (!fino) {
      document.addEventListener('click', function (e) {
        if (!leque.contains(e.target)) apagaDica();
      });
    }

    /* Palavra = span de fora (a mascara do celular) + span de dentro (o que
       sobe), com o espaco DENTRO do de fora, depois do de dentro — a mesma
       arvore de antes ("palavra + espaco" num span), para o computador sair
       pixel a pixel igual. No celular o de fora vira inline-block, o espaco
       do fim some, e quem separa as palavras e a margem do .am-tc-p. */
    function parte(el) {
      var texto = el.textContent.trim();
      el.textContent = '';
      texto.split(/\s+/).forEach(function (w) {
        var s = document.createElement('span');
        s.className = 'am-tc-p';
        var d = document.createElement('span');
        d.className = 'am-tc-pi';
        d.textContent = w;
        s.appendChild(d);
        s.appendChild(document.createTextNode(' '));
        el.appendChild(s);
      });
      return Array.prototype.slice.call(el.querySelectorAll('.am-tc-pi'));
    }

    var palavras = Array.prototype.slice.call(parte(tit).map(function (d) { return d.parentNode; }));
    var palTit = Array.prototype.slice.call(tit.querySelectorAll('.am-tc-pi'));
    /* as frases de cima so se partem quando o celular precisa delas */
    var palA = null, palB = null;

    var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
    function faixa(p, a, b) { return clamp((p - a) / (b - a), 0, 1); }
    function suave(t) { return t * t * (3 - 2 * t); }

    /* ================= CELULAR ================= */
    var M = null;            // medidas do palco, tiradas fora do quadro
    var pacs = itens.map(function (it) { return it.querySelector('.am-leque__pac'); });
    var itensGrade = grade ? Array.prototype.slice.call(grade.children) : [];
    /* ordem de entrada dos pacotes: o do meio, os de tras, os da frente */
    var ordemPac = [3, 1, 0, 2, 4];

    /* escreve so se mudou: a mesma string nao vira estilo de novo */
    function escreve(el, prop, v) {
      if (!el) return;
      var c = el.__amTc || (el.__amTc = {});
      if (c[prop] === v) return;
      c[prop] = v;
      el.style[prop] = v;
    }

    /* palavra a palavra: cada uma sobe 105% -> 0 na sua janela, e as janelas
       se sobrepoem (stagger) */
    function palavrasEm(lista, t) {
      var n = lista.length;
      if (!n) return;
      var d = n > 1 ? Math.min(0.09, 0.62 / (n - 1)) : 0;
      var dur = 1 - d * (n - 1);
      for (var k = 0; k < n; k++) {
        var v = suave(clamp((t - k * d) / dur, 0, 1));
        escreve(lista[k], 'transform', v >= 1 ? 'none' : 'translate3d(0,' + ((1 - v) * 105).toFixed(1) + '%,0)');
      }
    }

    function medeCel() {
      var fr = fixa.getBoundingClientRect();
      var fe = fenda.getBoundingClientRect();
      var fh = fixa.offsetHeight, fw = fixa.offsetWidth;
      var topo = tit.offsetTop + tit.offsetHeight;
      var base = grade ? grade.offsetTop : fh - 16;
      var vao = base - topo;
      /* o monte ocupa a largura toda que o vao deixa: 0,7 e a proporcao da
         caixa dos pacotes (altura/largura) */
      var w = Math.max(160, Math.min(fw - 20, 420, (vao - 28) / 0.7));
      var fenTop = fe.top - fr.top;
      M = {
        fh: fh, fw: fw, fenW: fe.width, fenH: fe.height,
        total: trava.offsetHeight - fh
      };
      fixa.style.setProperty('--tc-lq-w', w.toFixed(1) + 'px');
      fixa.style.setProperty('--tc-lq-y', ((topo + base) / 2 - fenTop).toFixed(1) + 'px');
    }

    function desenhaCel(pForcado) {
      var p;
      if (pForcado != null) p = pForcado;
      else {
        /* Bragg: de "top center" ate quase o fim da trava. Comeca com o topo
           da secao no meio da tela (as frases ja sobem enquanto a secao
           chega) e termina 0,3 tela antes de soltar: o fim fica parado um
           pouco, montado. */
        var r = trava.getBoundingClientRect();
        var ini = 0.5 * M.fh, fim = -(M.total - 0.3 * M.fh);
        p = clamp((ini - r.top) / (ini - fim), 0, 1);
      }
      if (p === ultimoP) return;
      ultimoP = p;

      // 1. as duas frases sobem palavra a palavra
      palavrasEm(palA, faixa(p, 0.03, 0.17));
      palavrasEm(palB, faixa(p, 0.09, 0.23));

      // 2. o cartao cresce de 30vw (raio 8) ate a tela, e as frases se afastam
      var g = suave(faixa(p, 0.26, 0.50));
      var cw = 0.30 * M.fw + (M.fenW - 0.30 * M.fw) * g;
      var ch = M.fenH * g;
      var ix = (M.fenW - cw) / 2, iy = (M.fenH - ch) / 2;
      var clip = g >= 1 ? 'none'
        : 'inset(' + iy.toFixed(1) + 'px ' + ix.toFixed(1) + 'px round ' + (8 * (1 - g)).toFixed(1) + 'px)';
      escreve(fenda, 'clipPath', clip);
      escreve(fenda, 'webkitClipPath', clip);
      var afasta = g * 0.30 * M.fh;
      escreve(linhaA, 'transform', 'translate3d(0,' + (-afasta).toFixed(1) + 'px,0)');
      escreve(linhaB, 'transform', 'translate3d(0,' + afasta.toFixed(1) + 'px,0)');
      /* com o cartao cheio o laranja nao tem mais o que fazer ali atras */
      escreve(fundo, 'opacity', g >= 1 ? '0' : '1');

      // 3. os pacotes entram um a um, e o grupo desce de 1.5 para 1
      var enc = suave(faixa(p, 0.30, 0.68));
      escreve(leque, 'transform', 'translate(-50%,-50%) translate3d(0,' + (-5 * (1 - enc)).toFixed(2) + '%,0) scale(' + (1.5 - 0.5 * enc).toFixed(4) + ')');
      for (var k = 0; k < pacs.length; k++) {
        var o = ordemPac[k] != null ? ordemPac[k] : k;
        var t = suave(faixa(p, 0.30 + o * 0.035, 0.42 + o * 0.035));
        escreve(pacs[k], 'opacity', t.toFixed(3));
        escreve(pacs[k], 'transform', t >= 1 ? 'none' : 'translate3d(0,' + (25 * (1 - t)).toFixed(1) + 'px,0)');
      }

      // 4. o paragrafo, palavra a palavra
      palavrasEm(palTit, faixa(p, 0.55, 0.77));

      // 5. a grade de atalhos, por ultimo
      for (var j = 0; j < itensGrade.length; j++) {
        var u = suave(faixa(p, 0.78 + j * 0.022, 0.88 + j * 0.022));
        escreve(itensGrade[j], 'opacity', u.toFixed(3));
        escreve(itensGrade[j], 'transform', u >= 1 ? 'none' : 'translate3d(0,' + (24 * (1 - u)).toFixed(1) + 'px,0)');
      }
    }

    /* troca de ramo (girar o celular, redimensionar): apaga o que o outro
       ramo escreveu e deixa o novo escrever tudo de novo */
    var modoCel = null;
    function limpa(el) {
      if (!el) return;
      el.removeAttribute('style');
      el.__amTc = null;
    }
    function trocaModo(cel) {
      [linhaA, linhaB, fenda, leque, tit, fundo].forEach(limpa);
      pacs.forEach(limpa);
      itensGrade.forEach(limpa);
      palTit.forEach(limpa);
      (palA || []).forEach(limpa);
      (palB || []).forEach(limpa);
      fixa.style.removeProperty('--tc-lq-w');
      fixa.style.removeProperty('--tc-lq-y');
      modoCel = cel;
      ultimoP = -1;
      if (cel) {
        apagaDica();
        leque.classList.remove('am-vivo');
        if (!palA) { palA = parte(linhaA); palB = parte(linhaB); }
        medeCel();
      }
    }

    var ultimoP = -1, quadro = null, perto = true;

    if (reduz) {
      /* movimento reduzido: sem scrub. No computador o titulo aceso; no
         celular a tela montada no estado final. */
      var assenta = function () {
        var cel = ehCelular();
        if (cel !== modoCel) trocaModo(cel);
        if (cel) { medeCel(); ultimoP = -1; desenhaCel(1); }
        else {
          palavras.forEach(function (s) { s.classList.add('am-on'); });
          tit.style.opacity = '1';
          leque.classList.add('am-vivo');
        }
      };
      assenta();
      window.addEventListener('resize', assenta);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(assenta);
      return;
    }

    /* DESEMPENHO: o desenho rodava a cada evento de rolagem da página inteira,
       inclusive com a trava fora da tela (770 ms de script numa rolagem da
       home com a CPU a 1/4). Agora: no máximo uma vez por quadro, só com a
       trava perto da tela, e sem escrever nada se o progresso não mudou. */
    function desenha() {
      quadro = null;
      var cel = ehCelular();
      if (cel !== modoCel) trocaModo(cel);
      if (cel) { desenhaCel(); return; }

      var r = trava.getBoundingClientRect();
      var total = trava.offsetHeight - window.innerHeight;
      if (total <= 0) return;
      var p = clamp(-r.top / total, 0, 1);
      if (p === ultimoP) return;
      ultimoP = p;

      /* 1. a fenda abre entre as duas linhas.

         Ela termina MAIOR que o palco (104 e nao 100) de proposito. A borda de
         baixo da fenda cai em coordenada fracionaria, e a linha anti-serrilhada
         dessa borda mistura o creme com a camada que estiver embaixo — que era
         o laranja. Era essa a risca laranja de 1px. Passando da borda, quem
         corta a fenda e o `overflow:hidden` do palco, e a mistura passa a ser
         creme com creme. Nos 4% a mais no meio do caminho ninguem repara: a
         fenda e um retangulo liso e o leque e centrado nela. */
      var abre = suave(faixa(p, 0.04, 0.34));
      fenda.style.height = (abre * 104).toFixed(2) + 'vh';
      fenda.style.width = (44 + abre * 60).toFixed(2) + 'vw';
      fenda.style.borderRadius = (6 - abre * 6).toFixed(1) + 'px';

      // 2. as linhas se afastam e somem
      var afasta = abre * 27;
      var visivel = 1 - faixa(p, 0.24, 0.38);
      linhaA.style.transform = 'translateY(calc(-124% - ' + afasta.toFixed(2) + 'vh))';
      linhaB.style.transform = 'translateY(calc(22% + ' + afasta.toFixed(2) + 'vh))';
      linhaA.style.opacity = visivel.toFixed(3);
      linhaB.style.opacity = visivel.toFixed(3);

      // 3. o leque entra grande e depois encolhe
      var entra = suave(faixa(p, 0.08, 0.42));
      var encolhe = suave(faixa(p, 0.46, 0.80));
      var escala = 1.46 - entra * 0.30 - encolhe * 0.32;
      var sobe = encolhe * 15;
      leque.style.transform =
        'translate(-50%, calc(-50% + ' + sobe.toFixed(2) + 'vh)) scale(' + escala.toFixed(3) + ')';
      /* a dica le isso para se contra-escalar e nao encolher junto */
      leque.style.setProperty('--am-esc', escala.toFixed(3));

      // 3b. o hover so vale com o leque assentado
      var vivo = p >= 0.66;
      leque.classList.toggle('am-vivo', vivo);
      if (!vivo) apagaDica();

      // 4. o titulo acende palavra a palavra
      tit.style.opacity = faixa(p, 0.54, 0.64).toFixed(3);
      var n = Math.round(faixa(p, 0.58, 0.95) * palavras.length);
      palavras.forEach(function (s, k) { s.classList.toggle('am-on', k < n); });
    }

    function agenda() { if (perto && !quadro) quadro = requestAnimationFrame(desenha); }

    desenha();
    document.addEventListener('scroll', agenda, { passive: true, capture: true });
    window.addEventListener('resize', function () {
      ultimoP = -1;
      /* a barra do navegador recolhe/volta e muda a tela: medir de novo */
      if (modoCel && ehCelular()) medeCel();
      if (!quadro) quadro = requestAnimationFrame(desenha);
    });
    /* a Season Mix chega depois: o paragrafo muda de altura e o vao dos
       pacotes junto */
    function remede() { if (modoCel && ehCelular()) { medeCel(); ultimoP = -1; agenda(); } }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remede);
    window.addEventListener('load', remede);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        perto = ents[0].isIntersecting;
        /* entrou ou saiu: um desenho na hora assenta o estado da ponta */
        if (!quadro) quadro = requestAnimationFrame(desenha);
      }, { rootMargin: '25% 0px' }).observe(trava);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amana-vendidos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-am-vend]').forEach(function (sec) {
      var pills = sec.querySelectorAll('[data-am-aba]');
      var paineis = sec.querySelectorAll('[data-am-painel]');
      var setas = sec.querySelectorAll('[data-am-vend-ir]');
      var prog = sec.querySelector('[data-am-vend-prog]');

      function atual() {
        for (var i = 0; i < paineis.length; i++) if (!paineis[i].hidden) return paineis[i];
        return paineis[0];
      }
      /* barra de progresso e setas acompanham a fileira visível */
      function mede() {
        var t = atual();
        if (!t) return;
        var max = t.scrollWidth - t.clientWidth;
        var vis = t.scrollWidth ? Math.max(8, Math.min(100, (t.clientWidth / t.scrollWidth) * 100)) : 100;
        if (prog) {
          prog.style.setProperty('--am-p', vis + '%');
          prog.style.setProperty('--am-x', (max > 0 ? (t.scrollLeft / max) * (100 - vis) : 0) + '%');
          prog.parentNode.hidden = max <= 4;
        }
        if (setas.length === 2) {
          setas[0].disabled = t.scrollLeft <= 4;
          setas[1].disabled = t.scrollLeft >= max - 4;
        }
      }
      paineis.forEach(function (p) { p.addEventListener('scroll', mede, { passive: true }); });
      window.addEventListener('resize', mede);

      setas.forEach(function (s) {
        s.addEventListener('click', function () {
          var t = atual();
          t.scrollBy({ left: Number(s.getAttribute('data-am-vend-ir')) * t.clientWidth * 0.9, behavior: 'smooth' });
        });
      });

      pills.forEach(function (b) {
        b.addEventListener('click', function () {
          var id = b.getAttribute('data-am-aba');
          pills.forEach(function (o) {
            var on = o === b;
            o.classList.toggle('am-on', on);
            o.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          paineis.forEach(function (p) { p.hidden = p.getAttribute('data-am-painel') !== id; });
          var t = atual();
          if (t) {
            t.scrollLeft = 0;
            /* cartões da aba que estava escondida: a revelação não os viu */
            t.querySelectorAll('[data-am-rv]').forEach(function (c) { c.classList.add('am-vis'); });
          }
          var fila = b.parentNode;
          if (fila && fila.scrollWidth > fila.clientWidth) {
            fila.scrollTo({ left: b.offsetLeft - (fila.clientWidth - b.offsetWidth) / 2, behavior: 'smooth' });
          }
          mede();
          try { if (typeof window.clarity === 'function') window.clarity('event', 'prateleira_' + b.getAttribute('data-am-rot')); } catch (e) { }
        });
      });
      mede();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
